import { ChangeEvent, useEffect, useMemo, useState, useRef } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { CheckBox, FerramentasDeDetalhe, RadioGroup, SelectComponent } from "../../shered/components";
import { VForm, VTextField } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import {
    IDadosDraftNao, IDadoDraftSim, IDadosComissarios, IDadosEmpate,
    IDadosLogo, IDadosMetodo, LigaService, IDadosDraftCalouros, IDadosSaveLiga,
    lstStatus, IDadosDuracao, IConfiguracao_multas_Liga,
    IConfiguracao_posicao_confronto, IConfiguracao_troca_posicao, BoxScore,
    IBonusCapJogadores, ILstDrafSalario,
    IIntervalo_Lance_Free_Agency, ITempo_Periodo_Free_Agency,
    IDadosPlayerOption,
    IDadosRegraDesempate
} from "../../shered/services/api/liga/LigaService";
import {
    Autocomplete, CircularProgress,
    Box, Button, FormControl,
    FormControlLabel, Icon,
    IconButton, InputLabel,
    LinearProgress, MenuItem,
    Pagination, Paper, Select, Tab,
    Table, TableBody, TableCell,
    TableContainer, TableFooter, TableHead,
    TableRow, Tabs, Typography, useTheme,
    Checkbox as MuiCheckBox,
    RadioGroup as MuiRadioGroup,
    TextField,
    FormGroup,
    FormLabel,
    tableCellClasses,
    tabsClasses,
    Radio,


} from "@mui/material";
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import Grid from '@mui/material/Grid2';
import { styled } from '@mui/material/styles';
import { ptBR } from '@mui/x-data-grid/locales';
import img from '../../img/empty.png'
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { Enviroment } from "../../shered/enviroments";
import { moedaRealLocaleValue } from "../../shered/components/input-valor-moeda/Current-Mask";
import { UsuarioService } from "../../shered/services/api/usuario/UsuarioService";
import { useDebounce } from "../../shered/hooks";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { VInputNumber } from "../../shered/forms/VInputNumber";
import { Loading } from "../../shered/components/loading/Loading";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { IDadosItensOptions, IDadosStats, ILstDrop, UtilidadeService, enumLstCriterioDesempate, lstPosicaoAmericana, lstReferenciasPosicaoConfronto, tiposLiga } from "../../shered/services/api/utilidades/UtilidadesService";
import { VTextMaskCustom } from "../../shered/forms/VTextMaskCustom";
//import { UndoSharp, UsbRounded } from "@mui/icons-material";
import {
    DataGrid, GridColDef,
    GridColumnVisibilityModel
} from "@mui/x-data-grid";
import { NumericFormatCustomMoneyNoDecimal } from "../../shered/components/numeric/FormatacaoNumericaMoney";

//dados do insert de liga
const SimNao = [
    {
        codigo: 1,
        label: "Sim"
    },
    {
        codigo: 2,
        label: "Não"
    }
];

const configuracaoMultas = [
    {
        codigo: 1,
        label: "Inteira"
    },
    {
        codigo: 2,
        label: "Por Temporada"
    },
    {
        codigo: 3,
        label: "Quebrada"
    },
    {
        codigo: 4,
        label: "Bloqueada"
    }
];
const configuracaoFreeAgency = [
    {
        codigo: 1,
        label: "Por Ano"
    },
    {
        codigo: 2,
        label: "Total Contrato"
    },
    {
        codigo: 3,
        label: "Total Contrato Ajustável"
    }
];

// const TipoFranquias = [
//     { codigo: 1, label: 'Sorteio' },
//     { codigo: 2, label: 'Manual' },
// ];


const lstAnos = [
    {
        codigo: 1,
        label: "1 Ano"
    },
    {
        codigo: 2,
        label: "2 Anos"
    },
    {
        codigo: 3,
        label: "3 Anos"
    },
    {
        codigo: 4,
        label: "4 Anos"
    },
    {
        codigo: 5,
        label: "5 Anos"
    },
    {
        codigo: 6,
        label: "6 Anos"
    }

];

const lstDescontoRestritoFreeAgence = [
    {
        codigo: 1,
        label: "Liberado"
    },
    {
        codigo: 2,
        label: "Lance Vencedor"
    },
    {
        codigo: 3,
        label: "Último Lance"
    },
    {
        codigo: 4,
        label: "Penúltimo Lance"
    },
    {
        codigo: 5,
        label: "Antepenúltimo Lance"
    },
    {
        codigo: 6,
        label: "Ter dado Lance"
    },

];

const lstTipoLiga = [
    {
        codigo: 1,
        label: "Stats"
    },
    {
        codigo: 2,
        label: "Pontuação"
    }
];

const lstTempoAnos = [
    {
        codigo: 1,
        label: "Ano 1"
    },
    {
        codigo: 2,
        label: "Ano 2"
    },
    {
        codigo: 3,
        label: "Ano 3"
    },
    {
        codigo: 4,
        label: "Ano 4"
    },
    {
        codigo: 5,
        label: "Ano 5"
    }
];


const lstRodadasDraft = [
    {
        codigo: 1,
        label: "1"
    },
    {
        codigo: 2,
        label: "2"
    },
    {
        codigo: 3,
        label: "3"
    },
    {
        codigo: 4,
        label: "4"
    },
    {
        codigo: 5,
        label: "5"
    },
    {
        codigo: 6,
        label: "6"
    }, {
        codigo: 7,
        label: "7"
    },
    {
        codigo: 8,
        label: "8"
    },
    {
        codigo: 9,
        label: "9"
    }, {
        codigo: 10,
        label: "10"
    },
    {
        codigo: 11,
        label: "11"
    },
    {
        codigo: 12,
        label: "12"
    },
    {
        codigo: 13,
        label: "13"
    },
    {
        codigo: 14,
        label: "14"
    },
    {
        codigo: 15,
        label: "15"
    }

];

const qtdTimesLiga = [{
    codigo: 12,
    label: "12"
}, {
    codigo: 16,
    label: "16"
}, {
    codigo: 20,
    label: "20"
}, {
    codigo: 24,
    label: "24"
}, {
    codigo: 28,
    label: "28"
}, {
    codigo: 30,
    label: "30"
}, {
    codigo: 32,
    label: "32"
}];


const lstTempoContrato = [{
    codigo: 1,
    label: "Alternativo 4"
},
{
    codigo: 2,
    label: "Alternativo 3"
},
{
    codigo: 3,
    label: "Alternativo 2"
},
{
    codigo: 4,
    label: "Fixo 4"
},
{
    codigo: 5,
    label: "Fixo 3"
},
{
    codigo: 6,
    label: "Fixo 2"
},
{
    codigo: 7,
    label: "Fixo 1"
}];

const lstTempoTrocaPosicao = [{
    codigo: 1,
    label: "Tempo 1"
},
{
    codigo: 2,
    label: "Tempo 2"
}];

const lstTiposPosicaoConfronto = [{
    codigo: 1,
    label: "Tradicional"
},
{
    codigo: 2,
    label: "Americano"
},
// {
//     codigo: 3,
//     label: "Criar"
// },
{
    codigo: 4,
    label: "8 Jogadores"
},
{
    codigo: 5,
    label: "7 Jogadores"
},
{
    codigo: 6,
    label: "Lista Americana"
}

];

const lstMetodoConfigJogador = [
    {
        codigo: 1,
        label: "Votação"
    },
    {
        codigo: 2,
        label: "Automático"
    }
];

const lstTipoLigaNBA = [
    {
        codigo: 1,
        label: "Liga"
    },
    {
        codigo: 2,
        label: "NBA"
    }
];

const lstRetornoJogador = [
    {
        codigo: 1,
        label: "Um Ano"
    },
    {
        codigo: 2,
        label: "Temporada"
    }
];

const lstTipoBonusJogador = [
    {
        codigo: 1,
        label: "Melhores"
    },
    {
        codigo: 2,
        label: "Piores"
    }
];

const lstDireitos = [
    {
        codigo: 3,
        label: "Team Option"
    },
    {
        codigo: 2,
        label: "Player Option"
    },
    {
        codigo: 4,
        label: "Qualifying Offer"
    },

];

const lstQuantidadeDireitos = [
    {
        codigo: 1,
        label: "1"
    },
    {
        codigo: 2,
        label: "2"
    },
    {
        codigo: 3,
        label: "3"
    },
    {
        codigo: 4,
        label: "4"
    },
    {
        codigo: 5,
        label: "5"
    }
];

type TAutoCompleteOptions = {
    codigo: number;
    label: string;
}


type TStatsOptions = {
    codigo: number;
    label: string;
    peso: string;
    outros: boolean
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

interface ICheckRodJog {
    rodada: number;
    value: boolean;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <> {value === index ?
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {
                    // value === index && (
                    <Box sx={{ p: 3 }}>
                        <Grid container>{children}</Grid>
                    </Box>
                    //)
                }
            </div>
            : ""}
        </>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

//const [rows, setRows] = useState(initialRows);




export const DetalheDeLigas: React.FC = () => {
    const user = CookieService.get("access_user");
    const navigate = useNavigate();
    const [voltarLigaSelecionada, setVoltarLigaSelecionada] = useState(false);
    // const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
    const { id = 'nova' } = useParams<"id">();
    const [isLoading, setIsLoading] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [codigo, setCodigo] = useState(0);
    const [codigoTipoLiga, setCodigoTipoLiga] = useState(0);
    const [codigoTemporada, setCodigoTemporada] = useState(0);
    const [codigoStatus, setCodigoStatus] = useState(0);
    const [codigoTipoPontuacao, setCodigoTipoPontuacao] = useState(0);

    const theme = useTheme();
    const { themeName } = useAppThemeContext();
    const [edicao, setEdicao] = useState(false);
    const [adm, setAdm] = useState(false);
    const [primeiraTemporada, setPrimeiraTemporada] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [logoImg, setLogoImg] = useState<any | null>("");
    const [showLogoImg, setShowLogoImg] = useState<any | null>("");
    const [dadosImg, setDadosImg] = useState<IDadosLogo>();
    const [valueTabs, setValueTabs] = useState(0);
    const { logout } = useAuthContext();
    const [totalCountDisputa, setTotalCountDisputa] = useState(0);
    const [totalCountRegrasDesempate, setTotalCountRegrasDesempate] = useState(0);
    const [totalCountRowsComis, setTotalCountRowsComis] = useState(1);
    const [totalCountRowsGms, setTotalCountRowsGms] = useState(1);
    //const [metodos, setMetodos] = useState<IDadosMetodo[]>([]);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [lstTodasTemporadas, setLstTodasTemporadas] = useState<ILstDrop[]>([]);
    const [lstTemporadasFiltros, setLstTemporadasFiltros] = useState<ILstDrop[]>([]);
    const [stats, setStats] = useState(0);
    const [valorRegraDesempate, setValorRegraDesempate] = useState(0);
    const [codigoLiga, setCodigoLiga] = useState(0);
    const [statsEmpate, setStatsEmpate] = useState("");
    const [pesoStats, setPesoStats] = useState("0,00");
    const { debounce } = useDebounce();
    const [statusLiga, setStatusLiga] = useState(1);
    const [tipoContratoAjustavel, setTipoContratoAjustavel] = useState(0);
    const [codigoTipoDescontoRestrito, setCodigoTipoDescontoRestrito] = useState(0);
    const [porcentagem_Bloqueio_Maximo_Multa, setPorcentagem_Bloqueio_Maximo_Multa] = useState("");


    const [metodosRows, setMetodosRows] = useState<IDadosMetodo[]>([]);
    const [comissariosRows, setComissariosRows] = useState<IDadosComissarios[]>([]);
    const [gmsRows, setGmsRows] = useState<IDadosComissarios[]>([]);
    const [searchParams, SetSearchParams] = useSearchParams();

    const [regraDesempateRows, setRegraDesempateRows] = useState<IDadosRegraDesempate[]>([]);
    //#region Tela Liga
    const [nome, setNome] = useState("");
    //const [quantidade_Franquia, setQuantidade_Franquia] = useState();
    const [exibeConfiguracao, setExibeConfiguracao] = useState(false);
    const [resetar_Posicao_Jogadores, setResetar_Posicao_Jogadores] = useState(false);
    const [resetar_Bloqueio_Franquias, setResetar_Bloqueio_Franquias] = useState(false);
    const [bloqueio_Maximo_Multa, setBloqueio_Maximo_Multa] = useState(false);


    const [quantidade_Ano_Partir_Direito, setQuantidade_Ano_Partir_Direito] = useState<number | undefined>(0);
    const [quantidade_Ano_Partir_Sem_Direito, setQuantidade_Ano_Partir_Sem_Direito] = useState<number | undefined>(0);
    const [newLstQuantidadeDireitos, setNewLstQuantidadeDireitos] = useState<ILstDrop[]>([]);
    const [newLstQuantidadeDireitosSem, setNewLstQuantidadeDireitosSem] = useState<ILstDrop[]>([]);

    const [divisao_Lotes, setDivisao_Lotes] = useState(false);
    const [player_Option, setPlayer_Option] = useState(false);
    const [quantidade_Jogo, setQuantidade_Jogo] = useState(0);
    const [pontuacao, setPontuacao] = useState(0);
    const [codigo_Item_Payer_Option, setCodigo_Item_Payer_Option] = useState(0);
    const [quantidadeFranquia, setQuantidadeFranquia] = useState(0);
    const [team_Option, setTeam_Option] = useState(false);
    const [match_Desconto, setMatch_Desconto] = useState(false);
    const [sign_Trade, setSign_Trade] = useState(false);
    const [cap, setCap] = useState("");
    const [opcoesAutoCompleteUsuario, setOpcoesAutoCompleteUsuario] = useState<TAutoCompleteOptions[]>([])
    const [opcoesAutoCompleteUsuarioGM, setOpcoesAutoCompleteUsuarioGM] = useState<TAutoCompleteOptions[]>([])
    const [opcoesAutoCompleteLigas, setOpcoesAutoCompleteLigas] = useState<TAutoCompleteOptions[]>([])
    const [selectedIdComplete, setSelectedIdComplete] = useState<number | undefined>(0);
    const [selectedIdCompleteGM, setSelectedIdCompleteGM] = useState<number | undefined>(0);
    const [selectedIdCompleteLiga, setSelectedIdCompleteLiga] = useState<number | undefined>(0);
    const [restrito, setChkRestrita] = useState(false);
    const [showLigasCadastradas, setShowLigasCadastradas] = useState(false);

    const [atualizar_Configuracao_Disputa, setAtualizar_Configuracao_Disputa] = useState(false);
    const [atualizar_Configuracao_Multas, setAtualizar_Configuracao_Multas] = useState(false);
    const [atualizar_Configuracao_Salario, setAtualizar_Configuracao_Salario] = useState(false);
    const [atualizar_BonusCAP_Jogadores, setAtualizar_BonusCAP_Jogadores] = useState(false);
    const [atualizar_Salarios_NBA_Porcentagem, setAtualizar_Salarios_NBA_Porcentagem] = useState(false);
    const [atualizar_Posicao_Conversao, setAtualizar_Posicao_Conversao] = useState(false);
    const [atualizar_Picks_Rodada_Inicial, setAtualizar_Picks_Rodada_Inicial] = useState(false);
    const [atualizar_Limites_Troca_Posicao, setAtualizar_Limites_Troca_Posicao] = useState(false);
    const [atualizar_Draft_Salario, setAtualizar_Draft_Salario] = useState(false);
    const [atualizar_Criterio_Desempate, setAtualizar_Criterio_Desempate] = useState(false);
    const [atualizar_Regra_Desempate_Classificacao, setAtualizar_Regra_Desempate_Classificacao] = useState(false);
    const [botaoDuplicarLiga, setBotaoDuplicarLiga] = useState(false);

    const [listaStats, setListaStats] = useState<IDadosStats[]>([]);
    const [dropStats, setDropStats] = useState<TStatsOptions[]>([]);
    const [itensPlayerOption, setItensPlayerOption] = useState<IDadosItensOptions[]>([]);
    const [dropItensPlayerOption, setDropItensPlayerOption] = useState<TStatsOptions[]>([]);

    const [valorCAP, setvalorCAP] = useState("");

    const nomeRef = useRef<null | HTMLElement>(null);
    const quantidade_FranquiaRef = useRef<null | HTMLElement>(null);
    const tipoRef = useRef<null | HTMLElement>(null);
    const codigo_TemporadaRef = useRef<null | HTMLElement>(null);
    const tipo_LigaRef = useRef<null | HTMLElement>(null);
    const capRef = useRef<null | HTMLElement>(null);
    const num_Min_JogadoresRef = useRef<null | HTMLElement>(null);
    const cap_MinimoRef = useRef<null | HTMLElement>(null);
    const num_Max_JogadoresRef = useRef<null | HTMLElement>(null);
    const cap_MaximoRef = useRef<null | HTMLElement>(null);
    const [possuiErrors, setPossuiErrors] = useState(false);

    const qtdDireitosRegressivoRef = useRef<null | HTMLElement>(null);
    const qtdDireitosRegressivoSemRef = useRef<null | HTMLElement>(null);
    const qtdDireitosApartirRef = useRef<null | HTMLElement>(null);
    const qtdDireitosApartirSemRef = useRef<null | HTMLElement>(null);

    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [tipoLigaStats, setTipoLigaStats] = useState(true);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const busca = useMemo(() => {
        return searchParams.get("busca") || "";
    }, [searchParams]);

    const pagina = useMemo(() => {
        return Number(searchParams.get("pagina") || "1");
    }, [searchParams]);

    const {
        //register,
        handleSubmit,
        control,
        //watch,
        setValue,
        getValues,
        reset,
        formState: { errors }
    }
        = useForm<IDadosSaveLiga>();

    useEffect(() => {
        setIsLoading(true);
        setAdm(user.administrador);
        if (id !== "nova") {
            const resultCrypt = UtilidadeService.decrypt(id);

            if (resultCrypt === "" || resultCrypt === undefined) {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                setIsLoading(false);

                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "info",
                    mensagem: "Dados inválidos! ",
                    display: "none",
                    titulo: "Atenção"
                });
                setRedirecionar("-1");
                return;

            }
            let parametros1 = resultCrypt === undefined ? setRedirecionar("/dashboard") : resultCrypt.split("/")[0];
            let parametros2 = resultCrypt === undefined ? setRedirecionar("/dashboard") : resultCrypt.split("/")[1];

            setEdicao(true);
            const fetchData = async () => {
                setIsLoading(false);
                carregarLigaPorCodigo(Number(parametros1), false);
            }
            fetchData();
        }
        else {
            setIsLoading(false);
            setRemoveLoading(true);
            //formRef.current?.reset();
        }

        UtilidadeService.getStats()
            .then((result) => {
                setIsLoading(false);
                const lstStats = result.data.dado;
                //console.log("lstStats");
                //console.log(lstStats);
                setListaStats(lstStats);
                setDropStats(lstStats.filter(f => Number(f.peso_Padrao) > 0).map(p => ({ codigo: p.codigo, label: p.descricao + " (" + p.nome + ")", peso: p.peso_Padrao, outros: false })));

            }).catch((errors) => {
                setShowModalMensagem(true);
                if (errors.response !== undefined && errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
            });

        UtilidadeService.getItensPlayerOption()
            .then((result) => {
                setIsLoading(false);
                const lstPlayerOption = result.dado;
                setItensPlayerOption(lstPlayerOption);
                setDropItensPlayerOption(lstPlayerOption.map(p => ({ codigo: p.codigo, label: p.descricao, peso: "", outros: p.repetir })));

            }).catch((errors) => {
                setShowModalMensagem(true);
                if (errors.response !== undefined && errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
            });

    }, [id]);

    const carregarLigaPorCodigo = async (codigo: number, novo: boolean) => {
        setRemoveLoading(false);
        setIsLoading(true);
        if (novo) {
            setExibeConfiguracao(true);
            setShowLigasCadastradas(true);
        }
        await LigaService.getById(codigo)
            .then((result) => {
                let lig = result.dado;                
                setNome(novo ? "" : lig.nome);
                setChkRestrita(lig.restrito);
                setShowLogoImg(novo ? "" : lig.caminho_Logo);
                setLogoImg(novo ? "" : lig.logo);
                setCodigoLiga(Number(lig.codigo));
                lig = {
                    ...lig, codigo: novo ? 0 : lig.codigo,
                    nome: novo ? "" : lig.nome
                };
                setPrimeiraTemporada(lig.primeira_Temporada);
                setCodigo(lig.codigo && !novo ? lig.codigo : 0);
                setvalorCAP(lig.configuracao_Liga.cap);
                setStatusLiga(lig.status);
                setCodigoTemporada(lig.configuracao_Liga.codigo_Temporada);
                setCodigoTipoPontuacao(lig.configuracao_Liga.codigo_Tipo_Pontuacao);
                setCodigoStatus(lig.status);
                reset(lig);
                setValue("logo", lig.logo);
                //  console.log("configuracao_Liga");
                //  console.log(lig.configuracao_Liga);
                setValue("configuracao_Liga", lig.configuracao_Liga);
                setCodigoTipoLiga(lig.tipo);
                setQuantidadeFranquia(lig.quantidade_Franquia);
                setValue("usuario_Comissario", novo ? [] : lig.usuario_Comissario);
                setValue("usuario_General_Manager", novo ? [] : lig.usuario_General_Manager);

                //console.log(lig.configuracao_Disputa);
                setValue("configuracao_Disputa", lig.configuracao_Disputa);
                setValue("configuracao_Multas", lig.configuracao_Multas);
                setValue("bonusCAP_Liga", lig.bonusCAP_Liga);
                setComissariosRows(lig.usuario_Comissario && !novo ? lig.usuario_Comissario : []);
                setGmsRows(lig.usuario_General_Manager && !novo ? lig.usuario_General_Manager : []);
                setMetodosRows(lig.configuracao_Disputa ? lig.configuracao_Disputa : []);
                setTotalCountDisputa(lig.configuracao_Disputa ? lig.configuracao_Disputa?.length : 0)
                setMultaRows(lig.configuracao_Multas ? lig.configuracao_Multas : []);
                setTotalCountMultas(lig.configuracao_Multas ? lig.configuracao_Multas?.length : 0);
                setTipoLigaStats(lig.configuracao_Liga.codigo_Tipo_Pontuacao === 1);
                setDraftSimRows(lig.salarios_NBA_Porcentagem ? lig.salarios_NBA_Porcentagem : []);

                setDraftSimTotalCount(lig.salarios_NBA_Porcentagem ? lig.salarios_NBA_Porcentagem.length : 0);
                setValue("separar_Multa_Temporada", lig.separar_Multa_Temporada);
                setMetodo_Configuracao_Jogador(lig.bonusCAP_Liga?.votacao ? 1 : 2);
                setChkEmpate(lig.configuracao_Liga.aceita_Empate);
                setChkFirstPropria(lig.configuracao_Liga.first_Propria);
                setChkBloquearCalouroPrimeiraRodada(lig.configuracao_Liga.bloquear_Calouro_Primeira_Rodada);
                setChkBloquearCalouroSegundaRodada(lig.configuracao_Liga.bloquear_Calouro_Segunda_Rodada);
                setBonusCAPJogadoresRows(lig.bonusCAP_Jogadores ? lig.bonusCAP_Jogadores : []);
                setTotalCountBonusCapJogadores(lig.bonusCAP_Jogadores ? lig.bonusCAP_Jogadores?.length : 0);
                setPosConfrontoRows(lig.posicao_Conversao ? lig.posicao_Conversao : []);
                setTotalCountPosConfronto(lig.posicao_Conversao ? lig.posicao_Conversao.length : 0);
                setValue("picks_Rodada_Inicial", lig.picks_Rodada_Inicial);
                setTipoPosicaoConfronto(lig.configuracao_Liga.codigo_Tipo_Posicao_Confronto);
                setDraftNaoRows(lig.picks_Rodada_Inicial ? lig.picks_Rodada_Inicial : []);
                setDraftNaoTotalCount(lig.picks_Rodada_Inicial ? lig.picks_Rodada_Inicial.length : 0);
                setSalarios_Reais_NBA(lig.configuracao_Liga.salarios_Reais_NBA ? 1 : 2);
                setIncluir_Calouros(lig.configuracao_Liga.incluir_Calouros ? 1 : 2);
                setValue("configuracao_Salario", lig.configuracao_Salario);
                //setQtdRodadas(lig.configuracao_Liga.quantidade_Rodada_Draft);
                CarregarDadosCheckRodadas(lig.configuracao_Liga.quantidade_Rodada_Draft, lig.picks_Rodada_Inicial ? lig.picks_Rodada_Inicial : []);
                setDraftCalourosRows(lig.draft_Salario ? lig.draft_Salario : []);
                setTotalCountDraftCalouros(lig.draft_Salario ? lig.draft_Salario?.length : 0);

                setValue("free_Agency", lig.free_Agency);
                setDuracaoRows(lig.configuracao_Salario ? lig.configuracao_Salario : []);
                setTotalCountRowsDuracao(lig.configuracao_Salario?.length > 0 ? lig.configuracao_Salario.length : 0);
                setTrocaPosicaoRows(lig.limites_Troca_Posicao ? lig.limites_Troca_Posicao : []);
                setTotalCountTrocaPosicao(lig.limites_Troca_Posicao.length > 0 ? lig.limites_Troca_Posicao.length : 0);
                setValue("configuracao_Contusao", lig.configuracao_Contusao);

                setTemporada(lig.configuracao_Contusao.temporada);
                setLiberaSlot(lig.configuracao_Contusao.libera_Slote);
                setAutomatico(lig.configuracao_Contusao.automatico);
                setAutoriza_Contratacao(lig.configuracao_Contusao.autoriza_Contratacao);

                setEmpateRows(lig.criterio_Desempate ? lig.criterio_Desempate : []);
                setRegraDesempateRows(lig.regra_Desempate_Classificacao ? lig.regra_Desempate_Classificacao : []);
                setTotalCountRegrasDesempate(lig.regra_Desempate_Classificacao.length);
                setEmpateTotalCount(lig.criterio_Desempate.length > 0 ? lig.criterio_Desempate?.length : 0);
                setChkSetimoJogador(lig.criterio_Desempate ? lig.criterio_Desempate.find(f => f.setimo_Homem === true) ? true : false : false);
                setIsLoading(false);
                setRemoveLoading(true);

                //setipo: dados.configuracao_Free_Agency?.tipo !== undefined ? dados.configuracao_Free_Agency.tipo : 1,
                setBloqueio_Maximo_Multa(lig.bloqueio_Maximo_Multa);
                setPorcentagem_Bloqueio_Maximo_Multa(lig.porcentagem_Bloqueio_Maximo_Multa !== undefined && lig.porcentagem_Bloqueio_Maximo_Multa !== null ? lig.porcentagem_Bloqueio_Maximo_Multa : "");
                setResetar_Bloqueio_Franquias(lig.configuracao_Free_Agency?.resetar_Bloqueio_Franquia ? lig.configuracao_Free_Agency.resetar_Bloqueio_Franquia : false);

                setResetar_Posicao_Jogadores(lig.configuracao_Free_Agency?.resetar_Posicao_Jogadores ? lig.configuracao_Free_Agency?.resetar_Posicao_Jogadores : false);
                setDivisao_Lotes(lig.configuracao_Free_Agency?.divisao_Lote ? lig.configuracao_Free_Agency?.divisao_Lote : false);
                setPlayer_Option(lig.configuracao_Free_Agency?.player_Option ? lig.configuracao_Free_Agency?.player_Option : false);
                setTeam_Option(lig.configuracao_Free_Agency?.team_Option ? lig.configuracao_Free_Agency?.team_Option : false);
                setMatch_Desconto(lig.configuracao_Free_Agency?.match_Desconto ? lig.configuracao_Free_Agency?.match_Desconto : false);
                setLanceDescontoRestrito(lig.configuracao_Free_Agency?.lance_Desconto_Restrito ? lig.configuracao_Free_Agency?.lance_Desconto_Restrito : false);
                setLanceDescontoDireito(lig.configuracao_Free_Agency?.lance_Desconto_Direito ? lig.configuracao_Free_Agency?.lance_Desconto_Direito : false);
                setTwo_Way(lig.configuracao_Free_Agency?.two_Way ? lig.configuracao_Free_Agency?.two_Way : false)
                setIncluir_Calouro_Two_Way(lig.configuracao_Free_Agency?.incluir_Calouro_Two_Way ? lig.configuracao_Free_Agency?.incluir_Calouro_Two_Way : false)
                setCobrirTemporada(lig.configuracao_Free_Agency?.cobrir_Temporada ? lig.configuracao_Free_Agency?.cobrir_Temporada : false)
                setCobrirTemporadaDireito(lig.configuracao_Free_Agency?.cobrir_Temporada_Direito ? lig.configuracao_Free_Agency?.cobrir_Temporada_Direito : false)

                setSign_Trade(lig.configuracao_Free_Agency?.sign_Trade ? lig.configuracao_Free_Agency?.sign_Trade : false);
                //setIntervaloLanceRows(lig.configuracao_Free_Agency?.intervalo_Lance_Free_Agency ? lig.configuracao_Free_Agency.intervalo_Lance_Free_Agency : [])
                setTempoPeriodoRows(lig.configuracao_Free_Agency?.tempo_Periodo_Free_Agency ? lig.configuracao_Free_Agency.tempo_Periodo_Free_Agency : []);
                setTipoContratoAjustavel(Number(lig.configuracao_Free_Agency?.tipo_Contrato_Ajustavel));
                setCodigoTipoDescontoRestrito(Number(lig.configuracao_Free_Agency?.desconto_Renovacao_Restrito))
                setTipoFreeAgency(lig.configuracao_Free_Agency?.tipo ? lig.configuracao_Free_Agency?.tipo : 0);
                setQuantidade_Ano_Partir_Direito(lig.configuracao_Free_Agency?.quantidade_Ano_Partir_Direito);
                setNewLstQuantidadeDireitos(lstQuantidadeDireitos.filter(f => f.codigo >= Number(lig.configuracao_Free_Agency?.quantidade_Ano_Regressivo_Direito)));
                setQuantidade_Ano_Partir_Sem_Direito(lig.configuracao_Free_Agency?.quantidade_Ano_Partir_Sem_Direito);
                setNewLstQuantidadeDireitosSem(lstQuantidadeDireitos.filter(f => f.codigo >= Number(lig.configuracao_Free_Agency?.quantidade_Ano_Regressivo_Sem_Direito)));
                setPlayerOptionRows(lig.configuracao_Player_Option ? lig.configuracao_Player_Option : []);
                setPlayerOptionTotalCount(lig.configuracao_Player_Option ? lig.configuracao_Player_Option?.length : 0)
                setRemoveLoading(true);
                setIsLoading(false);
            })
            .catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados da Liga! Favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }

    useEffect(() => {
        setIsLoading(true);
        debounce(() => {
            const fetchData2 = async () => {
                await UtilidadeService.getTemporadas(true, Number(codigoLiga))
                    .then((result) => {
                        setIsLoading(false);
                        const tmps = result.data.dado;
                        let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));

                        setLstTemporadas(lstTemporadasAux);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response.status === 401) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    });

                await UtilidadeService.getTemporadas(true, 0)
                    .then((result) => {
                        setIsLoading(false);
                        const tmps = result.data.dado;
                        let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));

                        setLstTodasTemporadas(lstTemporadasAux);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response.status === 401) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    });

                await UtilidadeService.getTemporadasLigaPorTipoQtd(Number(codigoLiga), 1, 4, 0)
                    .then((result) => {
                        setIsLoading(false);
                        const tmps = result.data.dado;
                        let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));

                        setLstTemporadasFiltros(lstTemporadasAux);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response.status === 401) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    });
            }
            fetchData2();
            UsuarioService.getAll()
                .then((result) => {
                    setIsLoading(false);
                    const lst = result.data.dado;
                    setOpcoesAutoCompleteUsuario(lst.map(p => ({ codigo: p.codigo, label: p.nome + " - " + p.email })));
                    setOpcoesAutoCompleteUsuarioGM(lst.map(p => ({ codigo: p.codigo, label: p.nome + " - " + p.email })));
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response !== undefined ? errors.response.data.mensagem : "Não foi possível carregar os dados da Liga! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;

                });
        })
    }, [busca, codigoLiga])


    const carregarLigas = async () => {
        setBotaoDuplicarLiga(true);
        await LigaService.getAllLigas()
            .then((result) => {
                setIsLoading(false);
                const lst = result.dado;
                setShowLigasCadastradas(true);
                setOpcoesAutoCompleteLigas(lst.map(p => ({ codigo: p.codigo, label: p.nome })));

            })
            .catch((errors) => {
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
                setIsLoading(false);
            });
    }

    const VirarTemporadaLiga = async () => {
        setIsLoading(true);
        setRemoveLoading(false);
        setBotaoDuplicarLiga(true);
        await LigaService.updateByIdVirarTemporadaLiga(codigoLiga)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Liga atualizada com sucesso!",
                    display: "none",
                    titulo: "Atenção"
                });

            })
            .catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
                setIsLoading(false);
            });
    }

    const adicionaComissario = () => {
        //setValue("comissarios",  [{}]);
        if (typeof selectedIdComplete !== null && typeof selectedIdComplete !== undefined) {
            if (comissariosRows.find(f => f.codigo_Usuario === Number(selectedIdComplete))) {
                setShowModalMensagem(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "warning",
                    mensagem: "Usuário já cadastrado como comissário!",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            }

            UsuarioService.getById(Number(selectedIdComplete))
                .then((result) => {
                    setIsLoading(false);
                    const usu = result.dado;
                    setComissariosRows([...comissariosRows, { codigo_Usuario: usu.codigo, nome: usu ? usu.nome : "", email: usu.email, criador: false }]);
                    setTotalCountRowsComis(comissariosRows.length + 1);

                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });
        }
        setSelectedIdComplete(0);
    }

    const adicionaGM = () => {
        //setValue("comissarios",  [{}]);
        if (typeof selectedIdCompleteGM !== null && typeof selectedIdCompleteGM !== undefined) {
            if (comissariosRows.find(f => f.codigo_Usuario === Number(selectedIdCompleteGM))) {
                setShowModalMensagem(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "warning",
                    mensagem: "Usuário já cadastrado como comissário!",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            }
            if (gmsRows.find(f => f.codigo_Usuario === Number(selectedIdCompleteGM))) {
                setShowModalMensagem(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "warning",
                    mensagem: "Usuário já cadastrado na liga!",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            }
            localStorage.removeItem("@codigoComissario");
            UsuarioService.getById(Number(selectedIdCompleteGM))
                .then((result) => {
                    setIsLoading(false);
                    const usu = result.dado;
                    setGmsRows([...gmsRows, { codigo_Usuario: usu.codigo, nome: usu ? usu.nome : "", email: usu.email, criador: false }]);
                    setTotalCountRowsGms(gmsRows.length + 1);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });
        }
        setSelectedIdCompleteGM(0);
    }

    const deleteComissario = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            setComissariosRows(comissariosRows.filter((i) => i.codigo_Usuario != id));
            setTotalCountRowsComis(comissariosRows.length - 1);
        }
    }

    const deleteGM = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            setGmsRows(gmsRows.filter((i) => i.codigo_Usuario != id));
            setTotalCountRowsGms(gmsRows.length - 1);
        }
    }

    const autoCompleteSelectedOptionLiga = useMemo(() => {
        if (!selectedIdCompleteLiga) return null;

        const selectedOption = opcoesAutoCompleteLigas.find(opcao => opcao.codigo === selectedIdCompleteLiga);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdCompleteLiga, opcoesAutoCompleteLigas]);

    const autoCompleteSelectedOption = useMemo(() => {
        if (!selectedIdComplete) return null;

        const selectedOption = opcoesAutoCompleteUsuario.find(opcao => opcao.codigo === selectedIdComplete);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdComplete, opcoesAutoCompleteUsuario]);

    const autoCompleteSelectedOptionGM = useMemo(() => {
        if (!selectedIdCompleteGM) return null;

        const selectedOption = opcoesAutoCompleteUsuarioGM.find(opcao => opcao.codigo === selectedIdCompleteGM);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdCompleteGM, opcoesAutoCompleteUsuarioGM]);

    const handleSelectedTemporada = (e: { target: { name: string; value: any; }; }) => {
        let temp = e.target.value;
        setExibeConfiguracao(false);
        if (Number(temp) > 0) {
            setExibeConfiguracao(true);
            if (comissariosRows.find(f => f.codigo_Usuario === user.codUsuario) === undefined) {
                setComissariosRows([...comissariosRows, { codigo_Usuario: user.codUsuario, nome: user.nome, email: user.email, criador: true }]);
            }
        }

        //setErrors({ ...errors, codigo_TemporadaRef: "" })

    }

    // const handleSelect = (e: { target: { name: string; value: any; }; }) => {
    //     setStatus(e.target.value);
    // }

    //#endregion Tela Liga

    //#region Tela Metodos
    const criarMetodo = () => {

        setAtualizar_Configuracao_Disputa(true);
        let idStats = dropStats.find(f => f.codigo == Number(stats));
        if (!tipoLigaStats && (pesoStats === undefined || pesoStats === "")) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor informar o peso da Stats",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }
        
        if (idStats) {
            let peso = tipoLigaStats ? parseFloat(idStats?.peso.toString().replace(",", ".")) : parseFloat(pesoStats.toString().replace(",", "."))
            setMetodosRows([...metodosRows, { codigo: 0, nomeStats: idStats.label, stats: idStats.codigo, peso: peso, positiva: peso > 0.00 ? true : false, somatoria: true }]);
            setTotalCountDisputa(metodosRows.length + 1);
        }
    }

    const deleteMetodo = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            setMetodosRows(metodosRows.filter((_, i) => i != id));
            setTotalCountDisputa(metodosRows.length - 1);
        }
    }

    //#endregion Tela Metodos

    //#region Tela Jogo
    const [aceita_Empate, setChkEmpate] = useState(false);
    const [chkSetimoJogador, setChkSetimoJogador] = useState(false);
    const [empateRows, setEmpateRows] = useState<IDadosEmpate[]>([]);
    const [empateTotalCount, setEmpateTotalCount] = useState(0);
    const [homemDesempate, setHomemDesempate] = useState(0);

    const criarRegrasDeEmpate = () => {
        let dstats = dropStats.find(f => f.codigo == Number(statsEmpate));
        if (empateRows.find(f => f.stats === dstats?.codigo)) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Stats já incluída!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        if (dstats) {
            let ultimaOrdem = empateRows.length > 0 ? empateRows[empateRows.length - 1].ordem : 0;
            setEmpateRows([...empateRows, { ordem: ultimaOrdem + 1, stats: dstats.codigo, setimo_Homem: false, oitavo_Homem: false, nono_Homem: false, decimo_Homem: false }]);
            setEmpateTotalCount(empateRows.length + 1);
            setAtualizar_Criterio_Desempate(true);
        }
    }

    const deleteRegraDeEmpate = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            if (id === 101) {
                setEmpateRows(empateRows.filter((f) => f.stats != id && f.stats != 103 && f.stats != 104 && f.stats != 105));
            }
            if (id === 103) {
                setEmpateRows(empateRows.filter((f) => f.stats != id && f.stats != 104 && f.stats != 105));
            }
            else if (id === 104) {
                setEmpateRows(empateRows.filter((f) => f.stats != id && f.stats != 105));
            }
            else
                setEmpateRows(empateRows.filter((f) => f.stats != id));

            setEmpateTotalCount(empateRows.length - 1);
            setAtualizar_Criterio_Desempate(true);
        }
    }

    const inserirRegrasDeEmpateSetimoJogador = () => {
        empateRows.sort((a: any, b: any) => {
            if (a.ordem > b.ordem) return 1;
            if (a.ordem < b.ordem) return -1;
            return 0;
        });

        let ultimaOrdem = empateRows.length > 0 ? empateRows[empateRows.length - 1].ordem : 0;

        setEmpateRows([...empateRows, { ordem: ultimaOrdem + 1, stats: 101, setimo_Homem: true, oitavo_Homem: false, nono_Homem: false, decimo_Homem: false }]);
        setEmpateTotalCount(empateRows.length + 1);
        setAtualizar_Criterio_Desempate(true);

    }

    const inserirRegrasDeEmpateMaisJogador = (codigo: number) => {

        if (empateRows.find(f => f.stats === codigo)) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Regra já incluída!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }
        setHomemDesempate(codigo);
        empateRows.sort((a: any, b: any) => {
            if (a.ordem > b.ordem) return 1;
            if (a.ordem < b.ordem) return -1;
            return 0;
        });

        let ultimaOrdem = empateRows.length > 0 ? empateRows[empateRows.length - 1].ordem : 0;
        //103 oitavo
        //104 nono
        //105 decimo   
        setEmpateRows([...empateRows, { ordem: ultimaOrdem + 1, stats: codigo, setimo_Homem: false, oitavo_Homem: codigo === 103 ? true : false, nono_Homem: codigo === 104 ? true : false, decimo_Homem: codigo === 105 ? true : false }]);
        setEmpateTotalCount(empateRows.length + 1);
        setAtualizar_Criterio_Desempate(true);
        setHomemDesempate(0);

    }


    const removeRegraDeEmpateSetimoJogador = () => {
        if (window.confirm("Realmente deseja apagar?")) {
            setEmpateRows(empateRows.filter((e) => e.stats != 101 && e.stats != 103 && e.stats != 104 && e.stats != 105));
            setEmpateTotalCount(empateRows.length - 1);
            setChkSetimoJogador(false);
            setAtualizar_Criterio_Desempate(true);
        }
    }
    //#endregion Final tela Jogo

    //#region  Tela Draft
    const [salarios_Reais_NBA, setSalarios_Reais_NBA] = useState(1);
    const [valorSalarioMinimo, setValorSalarioMinimo] = useState("");
    const [valorDesconto, setValorDesconto] = useState("");
    const [valorSalarioMaximo, setValorSalarioMaximo] = useState("");
    const [qtdEscolhaSalario, setQtdEscolhaSalario] = useState(0);
    const [valorUtilizadoSalario, setValorUtilizadoSalario] = useState("");
    const [draftSimRows, setDraftSimRows] = useState<IDadoDraftSim[]>([]);
    const [draftSimTotalCount, setDraftSimTotalCount] = useState(0);
    const [draftNaoRows, setDraftNaoRows] = useState<IDadosDraftNao[]>([]);
    const [draftNaoTotalCount, setDraftNaoTotalCount] = useState(0);
    const [cksRodJogRest, setCksRodJogRest] = useState<ICheckRodJog[]>([]);
    const [cksRodJogEsp, setCksRodJogEsp] = useState<ICheckRodJog[]>([]);
    const [qtdRodadas, setQtdRodadas] = useState(0);
    const [incluir_Calouros, setIncluir_Calouros] = useState(1);
    const [rowsRodadasDraft, setRowsRodadasDraft] = useState<number[]>([]);
    const [rowsEscolhasDraft, setRowsEscolhasDraft] = useState<number[]>([]);
    const [escolharTempoContrato, setEscolharTempoContrato] = useState(1);

    const criarIntervaloSalarios = () => {
        let desconto = parseFloat(valorDesconto);

        if (desconto === null || desconto === undefined || valorDesconto === "") {
            desconto = 0.0;
        }

        if (desconto > 100) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "O valor máximo do desconto é 100%",
                display: "none",
                titulo: "Atenção"
            });
            setValorDesconto("100");
            desconto = 100.0;
        }

        if (parseFloat(valorSalarioMinimo.replaceAll(".", "")) > parseFloat(valorSalarioMaximo.replaceAll(".", ""))) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Valor salário mínimo está maior que o valor salário máximo",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        setDraftSimRows([...draftSimRows, {
            codigo: 0,
            minimo: valorSalarioMinimo,
            maximo: valorSalarioMaximo,
            desconto: desconto.toString()
        }]);
        setDraftSimTotalCount(draftSimRows.length + 1);
        setAtualizar_Salarios_NBA_Porcentagem(true);
    }

    const deleteIntervaloSalarios = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            setDraftSimRows(draftSimRows.filter((_, i) => i != id));
            setDraftSimTotalCount(draftNaoRows.length - 1);
        }
    }

    const deleteRegraDeSalario = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            setDraftNaoRows(draftNaoRows.filter((_, i) => i != id));
            setDraftNaoTotalCount(draftNaoRows.length - 1);
        }
    }

    const handleCheckedJogadoresRestritos = (e: any) => {
        const { name, value, checked } = e.target;
        setAtualizar_Picks_Rodada_Inicial(true);
        if (!cksRodJogRest.find((e) => e.rodada == Number(value) + 1)) {
            setCksRodJogRest([...cksRodJogRest, { rodada: Number(value) + 1, value: checked }])
        }
        // Case 2  : The user unchecks the box
        else {
            setCksRodJogRest(cksRodJogRest.filter((e) => e.rodada != Number(value) + 1));
        }
    }

    const handleCheckedJogadoresEspelhados = (e: any) => {
        const { name, value, checked } = e.target;
        cksRodJogEsp.forEach(element => {

            if (element.rodada === Number(value) + 1) {
                element.value = checked === true;
            }
        });
        setCksRodJogEsp(cksRodJogEsp);

    }

    const handleRowsRodadas = async (e: { target: { name: string; value: any; }; }) => {
        let qtd = Number(e.target.value);
        setAtualizar_Picks_Rodada_Inicial(true);


        await CriarCheckRodadas(0);
        await CriarCheckRodadas(qtd);
    }

    const CriarCheckRodadas = async (qtd: number) => {
        setQtdRodadas(qtd);
        let arr = [];
        for (let i = 1; i <= qtd; i++) {
            arr.push(i);
        }
        setRowsRodadasDraft(arr);
        setRowsEscolhasDraft(arr);
        await handleChecked(qtd);
    }

    const handleChecked = async (qtd: number) => {
        let arrEspelhada: ICheckRodJog[] = [];
        let arrRestritos: ICheckRodJog[] = [];

        for (let i = 1; i <= qtd; i++) {
            arrRestritos.push({ rodada: i, value: true });
            if (i % 2 === 0) {
                arrEspelhada.push({ rodada: i, value: true })
            }
            else {
                arrEspelhada.push({ rodada: i, value: false })
            }
        }

        setCksRodJogRest(arrRestritos);
        setCksRodJogEsp(arrEspelhada);
    }

    const CarregarDadosCheckRodadas = async (qtd: number, lista: IDadosDraftNao[]) => {
        setQtdRodadas(qtd);
        let arr = [];
        for (let i = 1; i <= qtd; i++) {
            arr.push(i);
        }
        setRowsRodadasDraft(arr);
        setRowsEscolhasDraft(arr);
        MarcarEdicaoCheckRodadas(lista);
    }

    const MarcarEdicaoCheckRodadas = (lista: IDadosDraftNao[]) => {
        let arrEspelhada: ICheckRodJog[] = [];
        let arrRestritos: ICheckRodJog[] = [];
        lista.forEach(element => {
            if (arrRestritos.length === 0) {
                arrRestritos.push({ rodada: element.rodada, value: element.restrito === true });
                if (element.escolha_Rodada === 1) {
                    arrEspelhada.push({ rodada: element.rodada, value: false })
                }
                else {
                    arrEspelhada.push({ rodada: element.rodada, value: true })
                }
            }

            if (arrRestritos.find(f => f.rodada !== element.rodada)) {
                arrRestritos.push({ rodada: element.rodada, value: element.restrito === true });
                if (element.escolha_Rodada === 1) {
                    arrEspelhada.push({ rodada: element.rodada, value: false })
                }
                else {
                    arrEspelhada.push({ rodada: element.rodada, value: true })
                }
            }
        });

        setCksRodJogRest(arrRestritos);
        setCksRodJogEsp(arrEspelhada);
    }

    const [draftSalariosRows, setDraftSalariosRows] = useState<ILstDrafSalario[]>([]);

    function randomIntFromInterval(min: number, max: number) { // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min)
    }

    const handleCalculoDraftInicio = async () => {
        setAtualizar_Picks_Rodada_Inicial(true);
        setRemoveLoading(false);
        const result = getValues(); // formRef.current?.getData();      //("quantidade_Franquia");
        let qtdFranquias = result?.quantidade_Franquia;
        let valCap = parseFloat(valorCAP);
        let qtdRodada: number = cksRodJogEsp.length;

        let lstSalarios: ILstDrafSalario[] = []
        let valorCapSalarios = parseFloat(valorUtilizadoSalario.replaceAll(".", ""));

        if (valorCapSalarios <= 0) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor informar o CAP de utilização!",
                display: "none",
                titulo: "Atenção"
            });
            setRemoveLoading(true);
            return;
        }

        if (valorCapSalarios > valCap) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "CAP utilizado não pode ser maior do que o CAP da Liga!",
                display: "none",
                titulo: "Atenção"
            });

            setRemoveLoading(true);
            return;
        }

        await LigaService.getDraftPorcentagemSalario(qtdRodada, qtdFranquias)
            .then((result) => {
                setIsLoading(false);
                const lst = result.dado;
                lstSalarios = lst;
                setDraftSalariosRows(lst);

            })
            .catch((errors) => {
                if (errors.response.status === 401) {
                    setShowModalMensagem(true);
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível criar a liga! Favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

        setTimeout(() => {

            let tipoContrato = escolharTempoContrato === 4 || escolharTempoContrato === 5 || escolharTempoContrato === 6 || escolharTempoContrato === 7 ? true : false;
            let tempoContrato = escolharTempoContrato === 4 ? 4 : escolharTempoContrato === 5 ? 3 : escolharTempoContrato === 6 ? 2 : escolharTempoContrato === 7 ? 1 : escolharTempoContrato === 1 ? 4 : escolharTempoContrato === 2 ? 3 : 2

            let tempoContratoRandon = 4;
            if (!tipoContrato && tempoContrato >= 0) {
                tempoContratoRandon = randomIntFromInterval(1, 4);
            }
            let primeiraTempoContrato = tempoContratoRandon;
            let arrRegra: IDadosDraftNao[] = [];
            let cont = 1;
            cksRodJogEsp.forEach((f) => {
                for (let i = 1; i <= qtdFranquias; i++) {
                    let porcentagem: any = lstSalarios !== null && lstSalarios.find(s => s.escolha === i && s.rodada === f.rodada) !== undefined ? lstSalarios.find(s => s.escolha === i && s.rodada === f.rodada)?.porcentagem : 1;
                    arrRegra.push({
                        codigo: cont++,
                        escolha_Inicial: i,
                        rodada: f.rodada,
                        escolha_Rodada: !f.value ? i : (qtdFranquias + 1) - i,
                        posicao_Geral: ((f.rodada * qtdFranquias) - qtdFranquias + (!f.value ? i : (qtdFranquias + 1) - i)),
                        tempo_Contrato: tipoContrato ? tempoContrato : tempoContratoRandon,
                        salario: ((valorCapSalarios * parseFloat(porcentagem)) / 100),
                        restrito: cksRodJogRest.length > 0 ? cksRodJogRest.find(j => j.rodada === f.rodada)?.value : false
                    });
                    tempoContratoRandon = tempoContratoRandon + 1 > tempoContrato ? 1 : tempoContratoRandon + 1;
                }
                tempoContratoRandon = primeiraTempoContrato + 1 > tempoContrato ? 1 : primeiraTempoContrato + 1;
                primeiraTempoContrato = tempoContratoRandon;
            });

            setDraftNaoRows(arrRegra);
            setDraftNaoTotalCount(draftNaoRows.length + 1);

            setRemoveLoading(true);
        }, 3500);

        //clearTextField();
    }

    const handleCalculoDraftInicioNao = async () => {
        setRemoveLoading(false);
        const result = getValues();  // formRef.current?.getData();      //("quantidade_Franquia");
        let qtdFranquias = result?.quantidade_Franquia;

        let valCap = parseFloat(valorCAP);

        let qtdRodada: number = cksRodJogEsp.length;
        let valorSalarioMax = parseFloat(valorSalarioMaximo.replaceAll(".", ""));

        if (valorSalarioMax > valCap) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "CAP utilizado não pode ser maior do que o CAP da Liga!",
                display: "none",
                titulo: "Atenção"
            });

            setRemoveLoading(true);
            return;
        }
        let arrRegra: IDadosDraftNao[] = [];

        cksRodJogEsp.forEach((f) => {
            for (let i = 1; i <= qtdFranquias; i++) {
                arrRegra.push({
                    escolha_Inicial: i,
                    rodada: f.rodada,
                    escolha_Rodada: !f.value ? i : (qtdFranquias + 1) - i,
                    posicao_Geral: ((f.rodada * qtdFranquias) - qtdFranquias + (!f.value ? i : (qtdFranquias + 1) - i)),
                    tempo_Contrato: 0,
                    salario: 0,
                    restrito: cksRodJogRest.length > 0 ? cksRodJogRest.find(j => j.rodada === f.rodada)?.value : false
                });
            }
        });

        setDraftNaoRows(arrRegra);
        setDraftNaoTotalCount(arrRegra.length + 1);
        setValorSalarioMinimo("");
        setValorSalarioMaximo("");
        return arrRegra;
    }

    const [searchParamsDraftNao, SetSearchParamsDraftNao] = useSearchParams();
    const paginaDraftNao = useMemo(() => {
        return Number(searchParamsDraftNao.get("paginaDraftNao") || "1");
    }, [searchParamsDraftNao]);

    //#endregion draft Inicial

    //#region Tela Draft Calourso    

    const [lstTempoDriftCalouros, setLstTempoDriftCalouros] = useState("");
    const [tempoDrftCalouroFirst, setTempoDrftCalouroFirst] = useState("");
    const [draftCalourosRows, setDraftCalourosRows] = useState<IDadosDraftCalouros[]>([]);
    const [totalCountDraftCalouros, setTotalCountDraftCalouros] = useState(0);
    const [primeiroSalarioFirst, setPrimeiroSalarioFirst] = useState("");
    const [registroDrftCalouroFirst, setRegistroDrftCalouroFist] = useState("");
    const [intervDriftCalouroFirst, setIntervDriftCalouroFirst] = useState("");
    const [chkRestritaDraftCalourosFirst, setChkRestritaDraftCalourosFirst] = useState(false);
    const [tempoDraftCalouroSecond, setTempoDraftCalouroSecond] = useState(0);
    const [registroDrftCalouroSecond, setRegistroDraftCalouroSecond] = useState("");
    const [primeiroSalarioSecond, setPrimeiroSalarioSecond] = useState("");
    const [intervDriftCalouroSecond, setIntervDriftCalouroSecond] = useState("");
    const [chkRestritaDraftCalourosSecond, setChkRestritaDraftCalourosSecond] = useState(false);

    const [tempoDraftCalouros, setTempoDraftCalouros] = useState(0);

    const handleCalculoDraftCalouros = async () => {

        const result = getValues(); // formRef.current?.getData();      //("quantidade_Franquia");
        let qtdEscolhas = result?.quantidade_Franquia;
        let restritoFirst = chkRestritaDraftCalourosFirst;
        let restritoSecond = chkRestritaDraftCalourosSecond;

        let lstSalariosCalouros: IDadosDraftCalouros[] = []
        let primeiroSalario = parseFloat(primeiroSalarioFirst.replaceAll(".", ""));
        let primeiroIntervalo = parseFloat(intervDriftCalouroFirst.replaceAll(".", ""));

        let segundoSalario = parseFloat(primeiroSalarioSecond.replaceAll(".", ""));
        let segundoIntervalo = parseFloat(intervDriftCalouroSecond.replaceAll(".", ""));
        let tempoDraft = tempoDraftCalouros;
        let tempoDraftSecond = tempoDraftCalouroSecond;

        let valCap = parseFloat(valorCAP);
        if (primeiroSalario > valCap || valCap === 0 || valCap === undefined) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "O valor do primeiro salário está maior que o CAP!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        if (tempoDraft === 0 || tempoDraft === undefined) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor informar o tempo first!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        //first
        for (let index = 1; index <= qtdEscolhas; index++) {
            lstSalariosCalouros.push({

                pick: index,
                restrito: restritoFirst ? true : false,
                ano1: primeiroSalario,
                ano2: tempoDraft === 1 ? 0 : primeiroSalario + primeiroIntervalo,
                ano3: tempoDraft === 1 || tempoDraft === 2 ? 0 : primeiroSalario + (primeiroIntervalo * 2),
                ano4: tempoDraft === 1 || tempoDraft === 2 || tempoDraft === 3 ? 0 : primeiroSalario + (primeiroIntervalo * 3),
                ano5: tempoDraft === 1 || tempoDraft === 2 || tempoDraft === 3 || tempoDraft === 4 ? 0 : primeiroSalario + (primeiroIntervalo * 4)

            });
            primeiroSalario = primeiroSalario - primeiroIntervalo;
        }

        if (lstSalariosCalouros.length === 0) {
            return;
        }
        let ultimoFirst = lstSalariosCalouros.length > 0 ? lstSalariosCalouros.length + 1 : 1;

        let ultimoValorFirst = lstSalariosCalouros[lstSalariosCalouros.length - 1].ano1;

        if (ultimoValorFirst < segundoSalario) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "O valor do segundo salário não pode ser maior do que da última escolha do primeiro salário!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        if (segundoSalario > 0 && (tempoDraftSecond === 0 || tempoDraftSecond === undefined)) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor informar o tempo second!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        //Second
        for (let index = ultimoFirst; index <= (qtdEscolhas * 2); index++) {
            lstSalariosCalouros.push({

                pick: index,
                restrito: restritoSecond ? true : false,
                ano1: segundoSalario,
                ano2: tempoDraftSecond === 1 ? 0 : segundoSalario + segundoIntervalo,
                ano3: tempoDraftSecond === 1 || tempoDraftSecond === 2 ? 0 : segundoSalario + (segundoIntervalo * 2),
                ano4: tempoDraftSecond === 1 || tempoDraftSecond === 2 || tempoDraftSecond === 3 ? 0 : segundoSalario + (segundoIntervalo * 3),
                ano5: tempoDraftSecond === 1 || tempoDraftSecond === 2 || tempoDraftSecond === 3 || tempoDraftSecond === 4 ? 0 : segundoSalario + (segundoIntervalo * 4)

            });
            segundoSalario = segundoSalario - segundoIntervalo;
        }

        setDraftCalourosRows(lstSalariosCalouros);
        setTotalCountDraftCalouros(lstSalariosCalouros.length);
        setAtualizar_Draft_Salario(true);
    }

    const deleteEscolhasDraftCalouros = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            setDraftCalourosRows(draftCalourosRows.filter((_, i) => i != id));
            setTotalCountDraftCalouros(draftCalourosRows.length - 1);

        }
    }

    //#endregion

    //#region tela Outras Configurações
    const [first_Propria, setChkFirstPropria] = useState(false);
    const [chkBloquearCalouroSegundaRodada, setChkBloquearCalouroSegundaRodada] = useState(false);
    const [chkBloquearCalouroPrimeiraRodada, setChkBloquearCalouroPrimeiraRodada] = useState(false);

    const [intervalo_Minimo, setIntervalo_Minimo] = useState(0);
    const [tempo_Final_Lance, setTempo_Final_Lance] = useState(0);


    const [min_Valor, setMin_Valor] = useState("");
    const [max_Valor, setMax_Valor] = useState("");
    const [min_Duracao, setMin_Duracao] = useState(0);
    const [max_Duracao, setMax_Duracao] = useState(0);
    const [chkPermite_Ano_Adicional, setChkPermite_Ano_Adicional] = useState(false);


    const [duracaoRows, setDuracaoRows] = useState<IDadosDuracao[]>([]);
    const [totalCountRowsDuracao, setTotalCountRowsDuracao] = useState(0);
    const [temporada, setTemporada] = useState(false);


    const [autoriza_Contratacao, setAutoriza_Contratacao] = useState(false);
    const [automatico, setAutomatico] = useState(false);
    const [libera_Slote, setLiberaSlot] = useState(false);



    const criarDuracao = () => {

        if (min_Duracao > max_Duracao) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Valor de tempo de duração mínimo maior que o tempo de duração máximo",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        let minVal = parseFloat(min_Valor.replaceAll(".", ""));
        let maxVal = parseFloat(max_Valor.replaceAll(".", ""));

        if (isNaN(minVal) || isNaN(maxVal)) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor informar todos os campos!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }
        if (min_Duracao === 0 || max_Duracao === 0) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor informar todos os campos!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }
        if (minVal > maxVal) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Valor mínimo está maior que o valor máximo de duração",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }
        setDuracaoRows([...duracaoRows,
        {
            codigo: 0,
            valor_Minimo: minVal,
            valor_Maximo: maxVal,
            tempo_Minimo: min_Duracao,
            tempo_Maximo: max_Duracao,
            permite_Ano_Adicional: chkPermite_Ano_Adicional

        }]);
        setTotalCountRowsDuracao(duracaoRows.length + 1);
        setAtualizar_Configuracao_Salario(true);
    }

    const deleteDuracao = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            setDuracaoRows(duracaoRows.filter((_, i) => i != id));
            setTotalCountRowsDuracao(duracaoRows.length - 1);
            setAtualizar_Configuracao_Salario(true);
        }
    }

    //#endregion

    //#region Configurações Free Agency
    const [tipoFreeAgency, setTipoFreeAgency] = useState(1);
    const [min_Valor_Lance, setMin_Valor_Lance] = useState("");
    const [max_Valor_Lance, setMax_Valor_Lance] = useState("");
    const [aumento_Minimo_Lance, setAumento_Minimo_Lance] = useState(0);
    const [atualizar_Intervalo_Lance_Free_Agency, setAtualizar_Intervalo_Lance_Free_Agency] = useState(false);
    const [atualizar_Tempo_Periodo_Free_Agency, setAtualizar_Tempo_Periodo_Free_Agency] = useState(false);

    const [min_Valor_Periodo, setMin_Valor_Periodo] = useState(0);
    const [max_Valor_Periodo, setMax_Valor_Periodo] = useState(0);
    const [aumento_Minimo_Periodo, setAumento_Minimo_Periodo] = useState(0);

    const [valor_Contrato_Maximo_Two_Way, setValor_Contrato_Maximo_Two_Way] = useState(0);
    const [tempo_Contrato_Maximo_Two_Way, setTempo_Contrato_Maximo_Two_Way] = useState(0);
    const [quantidade_Jogos_Maximo_Two_Way, setQuantidade_Jogos_Maximo_Two_Way] = useState(0);
    const [quantidade_Jogadores_Maximo_Two_Way, setQuantidade_Jogadores_Maximo_Two_Way] = useState(0);
    const [incluir_Calouro_Two_Way, setIncluir_Calouro_Two_Way] = useState(false);
    const [two_Way, setTwo_Way] = useState(false);
    const [lanceDescontoRestrito, setLanceDescontoRestrito] = useState(false);
    const [lanceDescontoDireito, setLanceDescontoDireito] = useState(false);
    const [cobrirTemporada, setCobrirTemporada] = useState(false);
    const [cobrirTemporadaDireito, setCobrirTemporadaDireito] = useState(false);

    const [intervaloLanceRows, setIntervaloLanceRows] = useState<IIntervalo_Lance_Free_Agency[]>([]);
    const [totalCountRowsIntervaloLance, setTotalCountRowsIntervaloLance] = useState(0);
    const [totalCountRowsTempoPeriodo, setTotalCountRowsTempoPeriodo] = useState(0);
    const [tempoPeriodoRows, setTempoPeriodoRows] = useState<ITempo_Periodo_Free_Agency[]>([]);

    const handleCriarIntervaloLance = () => {


        let minVal = parseFloat(min_Valor_Lance.replaceAll(".", ""));
        let maxVal = parseFloat(max_Valor_Lance.replaceAll(".", ""));

        if (minVal > maxVal) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Valor de tempo de lance mínimo maior que o tempo de lance máximo",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }


        if (isNaN(minVal) || isNaN(maxVal)) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor informar todos os campos!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }
        if (minVal === 0 || maxVal === 0) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor informar todos os campos!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }
        if (minVal > maxVal) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Valor mínimo está maior que o valor máximo de lance",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }
        setIntervaloLanceRows([...intervaloLanceRows,
        {
            valor_Minimo: minVal,
            valor_Maximo: maxVal,
            aumento_Minimo: aumento_Minimo_Lance

        }]);
        setTotalCountRowsIntervaloLance(intervaloLanceRows.length + 1);
        setAtualizar_Intervalo_Lance_Free_Agency(true);
        setMin_Valor_Lance("");
        setMax_Valor_Lance("");
        setAumento_Minimo_Lance(0);
    }

    const deleteIntervaloLance = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            setIntervaloLanceRows(intervaloLanceRows.filter((_, i) => i != id));
            setTotalCountRowsIntervaloLance(intervaloLanceRows.length - 1);
            setAtualizar_Intervalo_Lance_Free_Agency(true);
        }
    }

    const handleCriarTempoPeriodo = () => {

        let minVal = min_Valor_Periodo;
        let maxVal = max_Valor_Periodo;
        if (minVal > maxVal) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Valor de tempo de período mínimo maior que o tempo de período máximo",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        if (isNaN(minVal) || isNaN(maxVal)) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor informar todos os campos!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }
        if (minVal === 0 || maxVal === 0) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor informar todos os campos!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }
        if (minVal > maxVal) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Valor mínimo está maior que o valor máximo de lance",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }
        setTempoPeriodoRows([...tempoPeriodoRows,
        {
            tempo_Final_Lance: minVal,
            tempo_Restrito_Aprovacao: maxVal,
            periodo_Horas: aumento_Minimo_Periodo

        }]);
        setTotalCountRowsTempoPeriodo(tempoPeriodoRows.length + 1);
        setAtualizar_Tempo_Periodo_Free_Agency(true);
        setMin_Valor_Periodo(0);
        setMax_Valor_Periodo(0);
        setAumento_Minimo_Periodo(0);
    }

    const deleteTempoPeriodo = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            setTempoPeriodoRows(tempoPeriodoRows.filter((_, i) => i != id));
            setTotalCountRowsTempoPeriodo(tempoPeriodoRows.length - 1);
            setAtualizar_Tempo_Periodo_Free_Agency(true);
        }
    }


    //#endregion

    //#region Tela de Multas 

    const [porcentagemMulta, setPorcentagemMulta] = useState("");
    const [totalCountMultas, setTotalCountMultas] = useState(0);
    const [multaRows, setMultaRows] = useState<IConfiguracao_multas_Liga[]>([]);
    const [valorMinimoMulta, setValorMinimoMulta] = useState("");
    const [valorMaximoMulta, setValorMaximoMulta] = useState("");
    const [separarMultaTemporada, setSepararMultaTemporada] = useState(1);

    const criaMulta = () => {

        let desconto = parseFloat(porcentagemMulta);
        if (isNaN(desconto) || isNaN(parseFloat(valorMinimoMulta.replaceAll(".", ""))) || isNaN(parseFloat(valorMaximoMulta.replaceAll(".", "")))) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor informar todos os campos!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        if (desconto === null || desconto === undefined) {
            desconto = 0.0;
        }

        if (desconto > 100) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "O valor máximo do desconto é 100%",
                display: "none",
                titulo: "Atenção"
            });
            setPorcentagemMulta("100,00");
            desconto = 100.0;
        }

        if (parseFloat(valorMinimoMulta.replaceAll(".", "")) > parseFloat(valorMaximoMulta.replaceAll(".", ""))) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Valor mínimo está maior que o valor máximo da multa",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        setAtualizar_Configuracao_Multas(true);
        setMultaRows([...multaRows,
        {
            codigo: 0,
            porcentagem: porcentagemMulta,
            valor_Minimo: valorMinimoMulta,
            valor_Maximo: valorMaximoMulta

        }]);
        setTotalCountMultas(multaRows.length + 1);
    }

    const deleteMulta = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            setMultaRows(multaRows.filter((_, i) => i != id));
            setTotalCountMultas(multaRows.length - 1);
        }
    }

    //#endregion

    //#region Jogabilidade

    const [posicao, setPosicao] = useState("");
    const [referenciaConfronto, setReferenciaConfronto] = useState("");
    const [totalCountPosConfronto, setTotalCountPosConfronto] = useState(0);
    const [posConfrontoRows, setPosConfrontoRows] = useState<IConfiguracao_posicao_confronto[]>([]);
    const [tipoPosicaoConfronto, setTipoPosicaoConfronto] = useState(0);

    const [totalCountTrocaPosicao, setTotalCountTrocaPosicao] = useState(0);
    const [trocaPosicaoRows, setTrocaPosicaoRows] = useState<IConfiguracao_troca_posicao[]>([]);
    const [minutosTrocaPosicao, setMinutosTrocaPosicao] = useState(0);
    const [porcentagemTrocaPosicao, setPorcentagemTrocaPosicao] = useState(0);
    const [temporadaTrocaPosicao, setTemporadaTrocaPosicao] = useState(0);
    const [isCriarPosicoes, setIsCriarPosicoes] = useState(false);


    const criaPosicaoConfronto = () => {

        if (posicao === "" || referenciaConfronto === "") {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor preencher todos os campos da posição confronto",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }


        setPosConfrontoRows([...posConfrontoRows,
        {
            posicao_Original: lstReferenciasPosicaoConfronto.find(f => f.codigo === Number(referenciaConfronto))?.label,
            posicao_Liga: posicao
        }]);
        setTotalCountPosConfronto(posConfrontoRows.length + 1);
        setAtualizar_Posicao_Conversao(true);
    }

    const deletePosicaoConfronto = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            setPosConfrontoRows(posConfrontoRows.filter((_, i) => i != id));
            setTotalCountPosConfronto(posConfrontoRows.length - 1);
            setAtualizar_Posicao_Conversao(true);
        }
    }

    const criaTrocaPosicao = () => {

        if (temporadaTrocaPosicao <= 0 || porcentagemTrocaPosicao <= 0 || minutosTrocaPosicao <= 0) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor preencher todos os campos da troca posição",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        setTrocaPosicaoRows([...trocaPosicaoRows,
        {
            codigo_Temporada: temporadaTrocaPosicao,
            porcentagem: Number(porcentagemTrocaPosicao.toString().substring(0, 3)),
            tempo_Minimo: Number(minutosTrocaPosicao.toString().substring(0, 3)),
        }]);
        setTotalCountTrocaPosicao(trocaPosicaoRows.length + 1);
        setAtualizar_Limites_Troca_Posicao(true);
    }

    const deleteTrocaPosicao = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            setTrocaPosicaoRows(trocaPosicaoRows.filter((_, i) => i != id));
            setTotalCountTrocaPosicao(trocaPosicaoRows.length - 1);
        }
    }

    const handlePosicaoConfronto = (e: any) => {
        const val = e.target.value;
        let dados: IConfiguracao_posicao_confronto[] = [];
        setTipoPosicaoConfronto(val);
        setTotalCountPosConfronto(0);
        if (val === 1) {
            setIsCriarPosicoes(false);
            lstReferenciasPosicaoConfronto.filter(f => f.codigo !== 7 && f.codigo !== 8 && f.codigo !== 9 && f.codigo !== 10).forEach((f) => {
                dados.push({
                    posicao_Original: f.label,
                    posicao_Liga: f.label.toString()
                });
            })
            setPosConfrontoRows(dados);
        }
        else if (val === 2) {
            setIsCriarPosicoes(false);
            lstReferenciasPosicaoConfronto.filter(f => f.codigo !== 7 && f.codigo !== 8 && f.codigo !== 9 && f.codigo !== 10).forEach((f) => {
                dados.push({
                    posicao_Original: f.label === "PG" || f.label === "SG" ? "G"
                        : f.label === "SF" || f.label === "PF" ? "F" : f.label === "C" ? "C" : "6º",
                    posicao_Liga: f.label.toString()
                });
            })
            setPosConfrontoRows(dados);
        }
        else if (val === 4) {
            setIsCriarPosicoes(false);
            lstReferenciasPosicaoConfronto.filter(f => f.codigo !== 6 && f.codigo !== 10).forEach((f) => {
                dados.push({
                    posicao_Original: f.label === "RC" ? "C" : f.label === "RG" ? "PG - SG" : f.label === "RF" ? "PF - SF" : f.label,
                    posicao_Liga: f.label.toString()
                });
            })
            setPosConfrontoRows(dados);
        }
        else if (val === 5) {
            setIsCriarPosicoes(false);
            lstReferenciasPosicaoConfronto.filter(f => f.codigo !== 7 && f.codigo !== 8 && f.codigo !== 9).forEach((f) => {
                dados.push({
                    posicao_Original: f.label,
                    posicao_Liga: f.label.toString()
                });
            })
            setPosConfrontoRows(dados);
        }
        else if (val === 6) {
            setIsCriarPosicoes(false);
            lstPosicaoAmericana.forEach((f) => {
                dados.push({
                    posicao_Original: f.label === "PG" || f.label === "SG" ? "G"
                        : f.label === "SF" || f.label === "PF" || f.label === "C" ? "F" : f.label === "5º" ? "5º" : "6º",
                    posicao_Liga: f.label.toString()
                });
            })
            setPosConfrontoRows(dados);
        }
        else {
            setIsCriarPosicoes(true);
            setPosConfrontoRows(dados);
        }
        setTotalCountPosConfronto(dados.length);
        setAtualizar_Posicao_Conversao(true);
    }

    //#endregion

    //#region Bonus

    const [metodo_Configuracao_Jogador, setMetodo_Configuracao_Jogador] = useState(1);
    const [bonus_Apuracao, setBonus_Apuracao] = useState(1);

    const [bonusCAPJogadoresRows, setBonusCAPJogadoresRows] = useState<IBonusCapJogadores[]>([]);
    const [totalCountBonusCapJogadores, setTotalCountBonusCapJogadores] = useState(0);

    const [boxScore, setBoxScore] = useState(0);
    const [inicio_Intervalo, setInicio_Intervalo] = useState(0);
    const [fim_Intervalo, setFim_Intervalo] = useState(0);
    const [tipo, setTipo] = useState(0);
    const [valor, setValor] = useState("");
    const [min_Jogos, setMin_Jogos] = useState(0);
    const [min_Minutos, setMin_Minutos] = useState(0);

    const criaBonusCAPJogadoresRows = () => {

        let vlr = parseFloat(valor.replaceAll(".", ""));
        if (inicio_Intervalo <= 0 || fim_Intervalo <= 0 || isNaN(vlr) || vlr <= 0 || min_Jogos <= 0 || min_Minutos <= 0 || boxScore === 0 || tipo === 0) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor informar os campos de Bônus para serem adicionados",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        if (inicio_Intervalo > fim_Intervalo) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "O campo fim intervalo está menor que o valor do campo início intervalo",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        setBonusCAPJogadoresRows([...bonusCAPJogadoresRows,
        {
            boxScore: boxScore,
            inicio_Intervalo: inicio_Intervalo,
            fim_Intervalo: fim_Intervalo,
            classificacao: tipo,
            valor: valor,
            minimo_Jogos: min_Jogos,
            minimo_Minutos: min_Minutos,
            considera_Liga: bonus_Apuracao === 1 ? true : false

        }]);
        setTotalCountBonusCapJogadores(multaRows.length + 1);
        setAtualizar_BonusCAP_Jogadores(true);
    }

    const deleteBonusCAPJogadoresRows = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            setBonusCAPJogadoresRows(bonusCAPJogadoresRows.filter((_, i) => i != id));
            setTotalCountBonusCapJogadores(bonusCAPJogadoresRows.length - 1);
        }
    }

    //#endregion

    //#region Regras Desempate Classificação
    const cadastroRegrasDesempateClassificacao = () => {

        setAtualizar_Regra_Desempate_Classificacao(true);
        let idRegra = enumLstCriterioDesempate.find(f => f.codigo == Number(valorRegraDesempate));
        // if (pesoStats === undefined || pesoStats === "") {
        //     setShowModalMensagem(true);
        //     setDadosModal({
        //         acao: true,
        //         label: "",
        //         tipo: "warning",
        //         mensagem: "Favor informar o peso da Stats",
        //         display: "none",
        //         titulo: "Atenção"
        //     });
        //     return;
        // }

        //let peso = parseFloat(pesoStats.toString().replace(",", "."))

        if (idRegra) {
            let ultimaOrdem = regraDesempateRows.length > 0 ? regraDesempateRows[regraDesempateRows.length - 1].ordem : 0;
            setRegraDesempateRows([...regraDesempateRows, { codigo: 0, ordem: ultimaOrdem + 1, codigo_Criterio_Desempate: idRegra.codigo, nomeRegra: idRegra.label }]);
            setTotalCountRegrasDesempate(regraDesempateRows.length + 1);
        }
        setValorRegraDesempate(0);
    }

    const deleteRegraDesempate = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            setRegraDesempateRows(regraDesempateRows.filter((_, i) => i != id));
            setTotalCountRegrasDesempate(metodosRows.length - 1);
        }
    }
    //#endregion

    //#region Player Option
    const [playerOptionRows, setPlayerOptionRows] = useState<IDadosPlayerOption[]>([]);
    const [playerOptionTotalCount, setPlayerOptionTotalCount] = useState(0);
    const [atualizar_Configuracao_Player_Option, setAtualizar_Configuracao_Player_Option] = useState(false);
    //const [incluiuPO, setIncluiuPO] = useState(false);
    const [showQtdJogosPO, setShowQtdJogosPO] = useState(false);

    const adicionarPlayerOption = async () => {
        if (playerOptionRows.find(f => (f.codigo_Item_Player_Option <= 7 && f.codigo_Item_Player_Option === codigo_Item_Payer_Option))?.codigo_Item_Player_Option !== undefined) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "O item já foi selecionado!",
                display: "none",
                titulo: "Atenção"
            });
            setCodigo_Item_Payer_Option(0);
            setPontuacao(0);
            setQuantidade_Jogo(0);
            return;

        }

        setPlayerOptionRows([...playerOptionRows, {
            codigo_Item_Player_Option: codigo_Item_Payer_Option,
            pontuacao: pontuacao,
            quantidade_Jogos: quantidade_Jogo === 0 ? null : quantidade_Jogo,
            repetir: dropItensPlayerOption.filter(f => f.codigo === codigo_Item_Payer_Option).length === 0 ? false : dropItensPlayerOption.filter(f => f.codigo === codigo_Item_Payer_Option)[0].outros
        }]);
        setPlayerOptionTotalCount(playerOptionRows.length + 1);
        setAtualizar_Configuracao_Player_Option(true);
        setCodigo_Item_Payer_Option(0);
        setPontuacao(0);
        setQuantidade_Jogo(0);
    }

    const deletePlayerOption = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            setPlayerOptionRows(playerOptionRows.filter((_, i) => i != id));
            setPlayerOptionTotalCount(playerOptionRows.length - 1);
            setAtualizar_Configuracao_Player_Option(true);
        }
    }

    const handleShowQuantidadeJogosPO = (codigo: number) => {
        setShowQtdJogosPO(false);
        if (codigo === 8 || codigo === 9) {
            setShowQtdJogosPO(true);
        }
    }
    //#endregion

    const formSubmitHandler: SubmitHandler<IDadosSaveLiga> = async (dados: IDadosSaveLiga) => {
        //const handleSave = async (dados: IDadosSaveLiga, { reset }: any) => {

        //#region controla Dados
        setIsLoading(true);
        setRemoveLoading(false);

        try {
            dados = {
                ...dados, codUsuCriacao: user.codUsuario,
                status: statusLiga
            };
            if (edicao) {
                dados = { ...dados, codUsuModificacao: user.codUsuario };
            }

            //Insere a lista de códigos dos comissionados nos dados para salvar
            const lstComiss: any = comissariosRows.length > 0 ? comissariosRows.map(comissario => (comissario.codigo_Usuario)) : [];
            //setValue("usuario_Comissario", lstComiss);
            dados = { ...dados, codigos_Comissarios: lstComiss }

            //Insere a lista de códigos dos comissionados nos dados para salvar
            const lstGMs: any = gmsRows.length > 0 ? gmsRows.map(gm => (gm.codigo_Usuario)) : [];
            //setValue("usuario_Gm", lstGMs);
            dados = { ...dados, codigos_Gms: lstGMs }

            //Insere dados modo de disputa nos dados para salvar
            const lstModoDisputa: any = metodosRows.length > 0
                ? metodosRows.map(met => ({
                    stats: met.stats,
                    peso: met.peso,
                    positiva: met.peso > 0 ? true : false,
                    somatoria: dados.configuracao_Liga.codigo_Tipo_Pontuacao === 2 ? true : false
                })) : [];

            setValue("configuracao_Disputa", lstModoDisputa);
            dados = { ...dados, configuracao_Disputa: lstModoDisputa }

            //Insere a lista de códigos dos stats de desempate nos dados para salvar
            const lstRegraEmpates = tipoPosicaoConfronto === 5 ? empateRows.filter(f => f.stats !== 101 && f.stats !== 103 && f.stats !== 104 && f.stats !== 105) : empateRows;
            const lstEmpate: any = lstRegraEmpates.length > 0 ? lstRegraEmpates.filter(f => f.stats !== 102).map(emp => ({
                ordem: emp.ordem,
                stats: emp.stats,
                setimo_Homem: emp.setimo_Homem,
                oitavo_Homem: emp.oitavo_Homem,
                nono_Homem: emp.nono_Homem,
                decimo_Homem: emp.decimo_Homem

            })) : [];

            dados = { ...dados, criterio_Desempate: lstEmpate }

            const lstRegrasDesempateClass: any = regraDesempateRows.map(reg => ({
                codigo_Liga: codigoLiga,
                codigo_Temporada: codigoTemporada,
                codigo_Criterio_Desempate: reg.codigo_Criterio_Desempate,
                ordem: reg.ordem
            }))

            dados = { ...dados, regra_Desempate_Classificacao: lstRegrasDesempateClass }

            let atualizar_Picks_Rod_Ini = atualizar_Picks_Rodada_Inicial;

            if (primeiraTemporada) {
                let picks_Rodada_Inicial: IDadosDraftNao[] = [];
                if (salarios_Reais_NBA === 1) {
                    if (atualizar_Picks_Rodada_Inicial) {
                        let result = await handleCalculoDraftInicioNao();
                        picks_Rodada_Inicial = result !== undefined ? result : [];
                        atualizar_Picks_Rod_Ini = true;
                    }
                }
                else {
                    if (draftNaoRows.length === 0) {
                        setShowModalMensagem(true);
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "warning",
                            mensagem: "Favor gerar o limite de salários dos jogadores na aba Draft Inicial!",
                            display: "none",
                            titulo: "Atenção"
                        });

                        setRemoveLoading(true);
                        return;
                    }
                    if (atualizar_Picks_Rodada_Inicial) {
                        picks_Rodada_Inicial = draftNaoRows;
                    }
                }
                dados = { ...dados, picks_Rodada_Inicial: picks_Rodada_Inicial }
            }

            //console.log(dados);
            const lstPosicao: any = posConfrontoRows.length > 0 ?
                posConfrontoRows.map(m => ({
                    posicao_Original: m.posicao_Original === "PG - SG" ? "G" : m.posicao_Original === "PF - SF" ? "F" : m.posicao_Original,
                    posicao_Liga: m.posicao_Liga
                })) : [];
            dados = { ...dados, posicao_Conversao: lstPosicao }

            dados = {
                ...dados, configuracao_Liga: {
                    ...dados.configuracao_Liga,
                    cap: dados.configuracao_Liga.cap.toString().replaceAll(".", ","),
                    cap_Maximo: dados.configuracao_Liga.cap_Maximo.toString().replaceAll(".", ","),
                    cap_Minimo: dados.configuracao_Liga.cap_Minimo.toString().replaceAll(".", ","),
                    maximo_Jogadores_Escalacao: 3,
                    max_Posicao: 12,
                    salarios_Reais_NBA: salarios_Reais_NBA === 1 ? true : false,
                    incluir_Calouros: incluir_Calouros === 1 ? true : false,
                    retorno_Jogador: dados.configuracao_Liga.retorno_Jogador === undefined ? 1 : dados.configuracao_Liga.retorno_Jogador,
                    retorno_Jogador_Dispensado: dados.configuracao_Liga.retorno_Jogador_Dispensado === undefined ? 0 : dados.configuracao_Liga.retorno_Jogador_Dispensado,
                    min_First_Tempo: dados.configuracao_Liga.min_First_Tempo === undefined ? 0 : dados.configuracao_Liga.min_First_Tempo,
                    codigo_Tipo_Posicao_Confronto: tipoPosicaoConfronto
                }
            }

            //Outras configurações Duração Salários
            const lstDuracaoSalarios: any = duracaoRows.length > 0 ?
                duracaoRows.map(m => ({
                    tempo_Maximo: m.tempo_Maximo,
                    tempo_Minimo: m.tempo_Minimo,
                    valor_Maximo: m.valor_Maximo,
                    valor_Minimo: m.valor_Minimo,
                    permite_Ano_Adicional: m.permite_Ano_Adicional
                })) : [];

            dados = { ...dados, configuracao_Salario: lstDuracaoSalarios }

            dados = { ...dados, tipo: codigoTipoLiga }

            dados = {
                ...dados, bonusCAP_Liga: {
                    ...dados.bonusCAP_Liga,
                    votacao: metodo_Configuracao_Jogador === 1 ? true : false
                }
            }

            dados = {
                ...dados, free_Agency: {
                    ...dados.free_Agency,
                    intervalo_Lance_Minimo: dados.free_Agency.intervalo_Lance_Minimo === undefined ? "" : dados.free_Agency.intervalo_Lance_Minimo.toString(),
                    porcentagem_Aumento: dados.free_Agency.porcentagem_Aumento === undefined ? "" : dados.free_Agency.porcentagem_Aumento.toString()
                }
            }

            dados = {
                ...dados, configuracao_Contusao: {
                    ...dados.configuracao_Contusao,
                    porcentagem: dados.configuracao_Contusao.porcentagem === undefined ? "" : dados.configuracao_Contusao.porcentagem.toString()
                }
            }


            const lstMultas: any = multaRows.length > 0
                ? multaRows.map(m => ({
                    porcentagem: moedaRealLocaleValue(m.porcentagem),
                    valor_Maximo: moedaRealLocaleValue(m.valor_Maximo.toString()),
                    valor_Minimo: moedaRealLocaleValue(m.valor_Minimo.toString())
                })) : [];

            setValue("configuracao_Multas", lstMultas);
            dados = { ...dados, configuracao_Multas: lstMultas }
            dados = {
                ...dados, separar_Multa_Temporada: separarMultaTemporada,
                bloqueio_Maximo_Multa: bloqueio_Maximo_Multa,
                porcentagem_Bloqueio_Maximo_Multa: porcentagem_Bloqueio_Maximo_Multa !== undefined && porcentagem_Bloqueio_Maximo_Multa !== "" ? porcentagem_Bloqueio_Maximo_Multa : null
            };

            const lstSalariosPorcentagem: any = draftSimRows.length > 0
                ? draftSimRows.map(m => ({
                    maximo: moedaRealLocaleValue(m.maximo.toString()),
                    minimo: moedaRealLocaleValue(m.minimo.toString()),
                    desconto: m.desconto.toString().replace(".", ""),
                })) : [];

            dados = { ...dados, salarios_NBA_Porcentagem: lstSalariosPorcentagem }

            const lstBonusCapJogadores: any = bonusCAPJogadoresRows.length > 0
                ? bonusCAPJogadoresRows.map(m => ({
                    boxScore: m.boxScore,
                    inicio_Intervalo: m.inicio_Intervalo,
                    fim_Intervalo: m.fim_Intervalo,
                    classificacao: m.classificacao,
                    valor: moedaRealLocaleValue(m.valor.toString()),
                    minimo_Jogos: m.minimo_Jogos,
                    minimo_Minutos: m.minimo_Minutos,
                    considera_Liga: m.considera_Liga
                })) : [];

            setValue("bonusCAP_Jogadores", lstBonusCapJogadores);
            dados = { ...dados, bonusCAP_Jogadores: lstBonusCapJogadores };

            //troca posição
            const lstTrocaPosicao: any = trocaPosicaoRows.length > 0
                ? trocaPosicaoRows.map(m => ({
                    codigo_Temporada: m.codigo_Temporada,
                    tempo_Minimo: m.tempo_Minimo,
                    porcentagem: m.porcentagem

                })) : [];
            dados = { ...dados, limites_Troca_Posicao: lstTrocaPosicao };

            //Draft Calouros
            dados = { ...dados, draft_Salario: draftCalourosRows }

            const lstPeriodoFA: any = tempoPeriodoRows.length > 0
                ? tempoPeriodoRows.map(m => ({
                    tempo_Final_Lance: m.tempo_Final_Lance,
                    tempo_Restrito_Aprovacao: m.tempo_Restrito_Aprovacao,
                    periodo_Horas: m.periodo_Horas

                })) : [];

            //Insere dados modo de disputa nos dados para salvar
            const lstPlayerOption: any = playerOptionRows.length > 0
                ? playerOptionRows.map(po => ({
                    codigo_Item_Player_Option: po.codigo_Item_Player_Option,
                    pontuacao: po.pontuacao,
                    quantidade_Jogos: po.quantidade_Jogos
                })) : [];

            setValue("configuracao_Player_Option", lstPlayerOption);
            dados = { ...dados, configuracao_Player_Option: lstPlayerOption }

            setValue("configuracao_Disputa", lstModoDisputa);
            dados = { ...dados, configuracao_Disputa: lstModoDisputa }

            dados = {
                ...dados, configuracao_Free_Agency: {
                    ...dados.configuracao_Free_Agency,

                    ano_Adicional_Direito_Jogador: dados.configuracao_Free_Agency?.ano_Adicional_Direito_Jogador,
                    ano_Adicional_Restrito_Jogador: dados.configuracao_Free_Agency?.ano_Adicional_Restrito_Jogador,
                    desconto_Renovacao_Direito: dados.configuracao_Free_Agency?.desconto_Renovacao_Direito ? dados.configuracao_Free_Agency?.desconto_Renovacao_Direito : null,
                    desconto_Renovacao_Draftado: dados.configuracao_Free_Agency?.desconto_Renovacao_Draftado ? dados.configuracao_Free_Agency?.desconto_Renovacao_Draftado : null,
                    desconto_Renovacao_Restrito: dados.configuracao_Free_Agency?.desconto_Renovacao_Restrito ? dados.configuracao_Free_Agency?.desconto_Renovacao_Restrito : null,
                    porcentagem_Contrato_Ajustavel: dados.configuracao_Free_Agency?.porcentagem_Contrato_Ajustavel !== undefined && dados.configuracao_Free_Agency?.porcentagem_Contrato_Ajustavel !== "" ? dados.configuracao_Free_Agency?.porcentagem_Contrato_Ajustavel : null,
                    tipo: dados.configuracao_Free_Agency?.tipo !== undefined ? dados.configuracao_Free_Agency.tipo : 1,
                    tipo_Contrato_Ajustavel: dados.configuracao_Free_Agency?.tipo === 3 ? tipoContratoAjustavel : null,
                    resetar_Bloqueio_Franquia: resetar_Bloqueio_Franquias,
                    resetar_Posicao_Jogadores: resetar_Posicao_Jogadores,
                    divisao_Lote: divisao_Lotes,
                    player_Option: player_Option,
                    team_Option: team_Option,
                    match_Desconto: match_Desconto,
                    lance_Desconto_Restrito: lanceDescontoRestrito,
                    lance_Desconto_Direito: lanceDescontoDireito,
                    cobrir_Temporada: cobrirTemporada,
                    cobrir_Temporada_Direito: cobrirTemporadaDireito,
                    sign_Trade: sign_Trade,
                    tempo_Periodo_Free_Agency: lstPeriodoFA,
                    atualizar_Intervalo_Lance_Free_Agency: (botaoDuplicarLiga || atualizar_Intervalo_Lance_Free_Agency),
                    atualizar_Tempo_Periodo_Free_Agency: (botaoDuplicarLiga || atualizar_Tempo_Periodo_Free_Agency),
                    two_Way: two_Way,
                    tempo_Contrato_Maximo_Two_Way: dados.configuracao_Free_Agency?.tempo_Contrato_Maximo_Two_Way ? dados.configuracao_Free_Agency?.tempo_Contrato_Maximo_Two_Way : null,
                    valor_Contrato_Maximo_Two_Way: dados.configuracao_Free_Agency?.valor_Contrato_Maximo_Two_Way ? dados.configuracao_Free_Agency?.valor_Contrato_Maximo_Two_Way : null,
                    quantidade_Jogos_Maximo_Two_Way: dados.configuracao_Free_Agency?.quantidade_Jogos_Maximo_Two_Way ? dados.configuracao_Free_Agency?.quantidade_Jogos_Maximo_Two_Way : null,
                    quantidade_Jogadores_Maximo_Two_Way: dados.configuracao_Free_Agency?.quantidade_Jogadores_Maximo_Two_Way ? dados.configuracao_Free_Agency?.quantidade_Jogadores_Maximo_Two_Way : null,
                    incluir_Calouro_Two_Way: incluir_Calouro_Two_Way
                }
            }

            dados = {
                ...dados,

                atualizar_Configuracao_Disputa: (botaoDuplicarLiga || atualizar_Configuracao_Disputa),
                atualizar_Configuracao_Multas: (botaoDuplicarLiga || atualizar_Configuracao_Multas),
                atualizar_Configuracao_Salario: (botaoDuplicarLiga || atualizar_Configuracao_Salario),
                atualizar_BonusCAP_Jogadores: (botaoDuplicarLiga || atualizar_BonusCAP_Jogadores),
                atualizar_Salarios_NBA_Porcentagem: (botaoDuplicarLiga || atualizar_Salarios_NBA_Porcentagem),
                atualizar_Posicao_Conversao: (botaoDuplicarLiga || atualizar_Posicao_Conversao),
                atualizar_Picks_Rodada_Inicial: (botaoDuplicarLiga || atualizar_Picks_Rod_Ini),
                atualizar_Limites_Troca_Posicao: (botaoDuplicarLiga || atualizar_Limites_Troca_Posicao),
                atualizar_Draft_Salario: (botaoDuplicarLiga || atualizar_Draft_Salario),
                atualizar_Criterio_Desempate: (botaoDuplicarLiga || atualizar_Criterio_Desempate),
                atualizar_Configuracao_Player_Option: (botaoDuplicarLiga || atualizar_Configuracao_Player_Option),
                atualizar_Regra_Desempate_Classificacao: (botaoDuplicarLiga || atualizar_Regra_Desempate_Classificacao),
            }

            dados = {
                ...dados, bonusCAP_Liga: {
                    treinador_Liga: dados.bonusCAP_Liga?.treinador_Liga?.toString(),
                    calouros_Liga: dados.bonusCAP_Liga?.calouros_Liga?.toString(),
                    votacao: dados.bonusCAP_Liga?.votacao !== undefined ? dados.bonusCAP_Liga?.votacao : false,
                    campeao_Liga: dados.bonusCAP_Liga?.campeao_Liga?.toString(),
                    vice_Campeao_Liga: dados.bonusCAP_Liga?.vice_Campeao_Liga?.toString(),
                    campeao_Conferencia_Liga: dados.bonusCAP_Liga?.campeao_Conferencia_Liga?.toString(),
                    vice_Conferencia_Liga: dados.bonusCAP_Liga?.vice_Conferencia_Liga?.toString(),
                    semifinalista_Liga: dados.bonusCAP_Liga?.semifinalista_Liga?.toString(),
                    playoffs_Liga: dados.bonusCAP_Liga?.playoffs_Liga?.toString(),
                    campeao_Divisao_Liga: dados.bonusCAP_Liga?.campeao_Divisao_Liga?.toString(),
                    vice_Divisao_Liga: dados.bonusCAP_Liga?.vice_Divisao_Liga?.toString(),
                    terceiro_Divisao_Liga: dados.bonusCAP_Liga?.terceiro_Divisao_Liga?.toString(),
                    mvp_Liga: dados.bonusCAP_Liga?.mvp_Liga?.toString(),
                    roy_Liga: dados.bonusCAP_Liga?.roy_Liga?.toString(),
                    dpoy_Liga: dados.bonusCAP_Liga?.dpoy_Liga?.toString(),
                    all_Star_Liga_First: dados.bonusCAP_Liga?.all_Star_Liga_First?.toString(),
                    all_Star_Liga_Second: dados.bonusCAP_Liga?.all_Star_Liga_Second?.toString(),
                }
            }

            dados = {
                ...dados, bonusCAP_NBA: {
                    calouros_NBA: dados.bonusCAP_NBA?.calouros_NBA?.toString(),
                    campeao_NBA: dados.bonusCAP_NBA?.campeao_NBA?.toString(),
                    vice_Campeao_NBA: dados.bonusCAP_NBA?.vice_Campeao_NBA?.toString(),
                    campeao_Conferencia_NBA: dados.bonusCAP_NBA?.campeao_Conferencia_NBA?.toString(),
                    vice_Conferencia_NBA: dados.bonusCAP_NBA?.vice_Conferencia_NBA?.toString(),
                    semifinalista_NBA: dados.bonusCAP_NBA?.semifinalista_NBA?.toString(),
                    playoffs_NBA: dados.bonusCAP_NBA?.playoffs_NBA?.toString(),
                    campeao_Divisao_NBA: dados.bonusCAP_NBA?.campeao_Divisao_NBA?.toString(),
                    vice_Campeao_Divisao_NBA: dados.bonusCAP_NBA?.vice_Campeao_Divisao_NBA?.toString(),
                    terceiro_Divisao_NBA: dados.bonusCAP_NBA?.terceiro_Divisao_NBA?.toString(),
                    mvp_NBA: dados.bonusCAP_NBA?.mvp_NBA?.toString(),
                    roy_NBA: dados.bonusCAP_NBA?.roy_NBA?.toString(),
                    dpoy_NBA: dados.bonusCAP_NBA?.dpoy_NBA?.toString(),
                    all_Star_NBA_First: dados.bonusCAP_NBA?.all_Star_NBA_First?.toString(),
                    all_Star_NBA_Second: dados.bonusCAP_NBA?.all_Star_NBA_Second?.toString(),
                }
            }

            if (logoImg !== null && logoImg !== "" && logoImg !== dados.logo) {
                const respImg = await LigaService.upLoadImage(logoImg);
                dados = { ...dados, logo: respImg.data.dado.nome }
            }
            else if (dados.logo === null || dados.logo === "") {
                setShowModalMensagem(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "warning",
                    mensagem: "Logo não informada!",
                    display: "none",
                    titulo: "Atenção"
                });
                setIsLoading(false);
                return;
            }

            //#endregion
            // console.log("dados");
            // console.log(dados);

            if (await validacaoDosValores(dados)) {
                setShowModalMensagem(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "warning",
                    mensagem: "Existe campo obrigatório não preenchido ou valor inválido. Favor verificar!",
                    display: "none",
                    titulo: "Atenção"
                });
                setIsLoading(false);
                setRemoveLoading(true);
                return;
            }
            else {
                if (id === 'nova') {
                    LigaService.Create(dados)
                        .then((result) => {
                            var crp = UtilidadeService.crypt(result.dado.toString());

                            if (botaoDuplicarLiga && result.dado > 0 && (dados.codigo === 0 || dados.codigo === null && dados.codigo === undefined)) {
                                dados = {
                                    ...dados,
                                    codigo: result.dado,
                                    codUsuModificacao: user.codUsuario
                                };
                                LigaService.updateById(dados)
                                    .then((result) => {
                                        setIsLoading(false);
                                        setRemoveLoading(true);
                                        setShowModalMensagem(true);
                                        setDadosModal({
                                            acao: true,
                                            label: "",
                                            tipo: "success",
                                            mensagem: "Liga duplicada com sucesso!",
                                            display: "none",
                                            titulo: "Atenção"
                                        });
                                        //  if (isSaveAndClose()) {
                                        //setRedirecionar(`/usuario/ligas`);
                                        return;
                                        //}
                                    })
                                    .catch((errors) => {
                                        setIsLoading(false);
                                        setRemoveLoading(true);
                                        setShowModalMensagem(true);
                                        if (errors.response.status === 401) {
                                            setDadosModal({
                                                acao: true,
                                                label: "",
                                                tipo: "info",
                                                mensagem: "Sessão expirada!",
                                                display: "none",
                                                titulo: "Atenção"
                                            });
                                            logout();
                                            setRedirecionar("0");
                                            return;
                                        }
                                        setDadosModal({
                                            acao: true,
                                            label: "",
                                            tipo: "error",
                                            mensagem: errors.response !== undefined ? errors.response.data.mensagem : "Não foi possível salvar os dados da liga! Favor entrar em contato com a TI.",
                                            display: "none",
                                            titulo: "Atenção"
                                        });
                                    });
                            }
                            else {

                                setShowModalMensagem(true);
                                setDadosModal({
                                    acao: true,
                                    label: "",
                                    tipo: "success",
                                    mensagem: "Liga criada com sucesso!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                setIsLoading(false);
                                setRemoveLoading(true);
                            }
                            navigate(`/usuario/liga/detalhe/${crp}`);
                        })
                        .catch((errors) => {
                            setIsLoading(false);
                            setRemoveLoading(true);
                            setShowModalMensagem(true);
                            if (errors.response.status === 401) {
                                setDadosModal({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                            }
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response !== undefined ? errors.response.data.mensagem : "Não foi possível criar a liga! Favor entrar em contato com a TI.",
                                display: "none",
                                titulo: "Atenção"
                            });
                        });

                } else {
                    LigaService.updateById(dados)
                        .then((result) => {
                            setIsLoading(false);
                            setRemoveLoading(true);
                            setShowModalMensagem(true);
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "success",
                                mensagem: "Registro atualizado com sucesso!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            // if (isSaveAndClose()) {
                            //setRedirecionar(`/usuario/ligas`);
                            // }
                        })
                        .catch((errors) => {
                            setIsLoading(false);
                            setRemoveLoading(true);
                            setShowModalMensagem(true);
                            if (errors.response.status === 401) {
                                setDadosModal({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response !== undefined ? errors.response.data.mensagem : "Não foi possível salvar os dados da liga! Favor entrar em contato com a TI.",
                                display: "none",
                                titulo: "Atenção"
                            });
                        });
                }
            }
        } catch (err) {
            setRemoveLoading(true);
            setIsLoading(false);
        }
    }

    // const [errors, setErrors] = useState({
    //     error: false,
    //     nomeRef: "",
    //     quantidade_FranquiaRef: "",
    //     codigo_TemporadaRef: "",
    //     showLogoImg: "",
    //     tipo_LigaRef: "",
    //     num_Max_JogadoresRef: "",
    //     num_Min_JogadoresRef: "",
    //     capRef: "",
    //     cap_MinimoRef: "",
    //     cap_MaximoRef: "",
    //     mensagemErro: "",
    //     qtdDireitosRegressivoRef: "",
    //     qtdDireitosRegressivoSemRef: "",
    //     qtdDireitosApartirRef: "",
    //     qtdDireitosApartirSemRef: "",
    // });

    async function validacaoDosValores(valores: IDadosSaveLiga) {

        let objError = await verificarCamposObrigatorios(valores);
        // setErrors(objError);

        return objError.error;
    }

    async function verificarCamposObrigatorios(dados: IDadosSaveLiga) {
        const errors: any = {};
        let err = false;
        if (dados.nome === "" || dados.nome === undefined) {

            nomeRef.current?.focus();
            errors.nomeRef = dados.nome === undefined ? "Campo obrigatório" : dados.nome.length < 3 ? "Favor informar o nome completo" : "Campo obrigatório";
            errors.error = err = true;
        };
        if (dados.quantidade_Franquia <= 0 || dados.quantidade_Franquia === undefined) {

            quantidade_FranquiaRef.current?.focus();
            errors.quantidade_FranquiaRef = "Campo obrigatório";
            errors.error = err = true;
        };

        if (dados.tipo <= 0 || dados.tipo === undefined) {

            tipoRef.current?.focus();
            errors.tipoRef = "Campo obrigatório";
            errors.error = err = true;
        };
        if (dados.configuracao_Liga.codigo_Temporada <= 0 || dados.configuracao_Liga.codigo_Temporada === undefined) {

            codigo_TemporadaRef.current?.focus();
            errors.codigo_TemporadaRef = "Campo obrigatório";
            errors.error = err = true;
        };
        if (dados.configuracao_Liga.codigo_Tipo_Pontuacao <= 0 || dados.configuracao_Liga.codigo_Tipo_Pontuacao === undefined) {

            tipo_LigaRef.current?.focus();
            errors.tipo_LigaRef = "Campo obrigatório";
            errors.error = err = true;
        };
        if (parseFloat(dados.configuracao_Liga.cap.toString().replace("R$", "").replaceAll(".", "")) <= 0 || dados.configuracao_Liga.cap === undefined) {

            capRef.current?.focus();
            errors.capRef = "Campo obrigatório";
            errors.error = err = true;
        };
        if (dados.configuracao_Liga.num_Min_Jogadores <= 0 || dados.configuracao_Liga.num_Min_Jogadores === undefined) {

            dados.configuracao_Liga.num_Min_Jogadores = 12;
            //num_Min_JogadoresRef.current?.focus();
            //errors.num_Min_JogadoresRef = "Campo obrigatório";
            //errors.error = err = true;
        };
        if (dados.configuracao_Liga.num_Min_Jogadores < 7) {

            dados.configuracao_Liga.num_Min_Jogadores = 8;
            num_Min_JogadoresRef.current?.focus();
            errors.num_Min_JogadoresRef = "Mínimo de jogador tem que ser maior que sete (7)";
            errors.error = err = true;
        };
        if (Number(dados.configuracao_Liga.num_Max_Jogadores) <= 0 || Number(dados.configuracao_Liga.num_Max_Jogadores) === undefined) {

            dados.configuracao_Liga.num_Max_Jogadores = 17;
            //num_Max_JogadoresRef.current?.focus();
            //errors.num_Max_JogadoresRef = "Campo obrigatório";
            //errors.error = err = true;
        };

        if (Number(dados.configuracao_Liga.num_Max_Jogadores) < Number(dados.configuracao_Liga.num_Min_Jogadores)) {

            num_Min_JogadoresRef.current?.focus();
            errors.num_Min_JogadoresRef = "Mínimo de jogadores tem que ser menor que o máximo!";
            errors.error = err = true;
        };
        if (parseFloat(dados.configuracao_Liga.cap_Maximo.toString().replace("R$", "").replaceAll(".", "")) <= 0 || dados.configuracao_Liga.cap_Maximo === undefined || dados.configuracao_Liga.cap_Maximo === "") {

            dados.configuracao_Liga.cap_Maximo = dados.configuracao_Liga.cap;
        };

        if (Number(dados.configuracao_Liga.cap_Minimo) < 0 || dados.configuracao_Liga.cap_Minimo === undefined || dados.configuracao_Liga.cap_Minimo === "") {

            dados.configuracao_Liga.cap_Minimo = "0";
        };

        if (parseFloat(dados.configuracao_Liga.cap_Minimo.toString().replaceAll(".", "")) > parseFloat(dados.configuracao_Liga.cap_Maximo.toString().replaceAll(".", ""))) {

            cap_MaximoRef.current?.focus();
            errors.cap_MaximoRef = "Campo CAP máximo está menor que o CAP mínimo";
            errors.error = err = true;
        };

        if (dados.configuracao_Free_Agency?.codigo_Opcao_Direito != null && dados.configuracao_Free_Agency?.codigo_Opcao_Direito != undefined && dados.configuracao_Free_Agency?.codigo_Opcao_Direito > 0) {

            if (dados.configuracao_Free_Agency?.quantidade_Ano_Regressivo_Direito === null || dados.configuracao_Free_Agency?.quantidade_Ano_Regressivo_Direito === 0) {
                qtdDireitosRegressivoRef.current?.focus();
                errors.qtdDireitosRegressivoRef = "Campor Obrigatório" //"Favor informar o campo Regressivo na aba configutação de Free Agency";
                errors.error = err = true;

            }
            if (dados.configuracao_Free_Agency?.quantidade_Ano_Partir_Direito === undefined || dados.configuracao_Free_Agency?.quantidade_Ano_Partir_Direito === null || dados.configuracao_Free_Agency?.quantidade_Ano_Partir_Direito === 0) {
                qtdDireitosApartirRef.current?.focus();
                errors.qtdDireitosApartirRef = "Campor Obrigatório" // "Favor informar o campo A Partir na aba configutação de Free Agency";
                errors.error = err = true;

            }
        }

        if (dados.configuracao_Free_Agency?.codigo_Opcao_Sem_Direito != null && dados.configuracao_Free_Agency?.codigo_Opcao_Sem_Direito != undefined && dados.configuracao_Free_Agency?.codigo_Opcao_Sem_Direito > 0) {

            if (dados.configuracao_Free_Agency?.quantidade_Ano_Regressivo_Sem_Direito === null || dados.configuracao_Free_Agency?.quantidade_Ano_Regressivo_Sem_Direito === 0) {
                qtdDireitosRegressivoSemRef.current?.focus();
                errors.qtdDireitosRegressivoSemRef = "Campor Obrigatório" //"Favor informar o campo Regressivo na aba configutação de Free Agency";
                errors.error = err = true;

            }
            if (dados.configuracao_Free_Agency?.quantidade_Ano_Partir_Sem_Direito === undefined || dados.configuracao_Free_Agency?.quantidade_Ano_Partir_Sem_Direito === null || dados.configuracao_Free_Agency?.quantidade_Ano_Partir_Sem_Direito === 0) {
                qtdDireitosApartirSemRef.current?.focus();
                errors.qtdDireitosApartirSemRef = "Campor Obrigatório" //"Favor informar o campo A Partir na aba configutação de Free Agency";
                errors.error = err = true;

            }
        }

        if (showLogoImg === "" || showLogoImg === undefined) {
            errors.showLogoImg = "Campo obrigatório";
            errors.error = err = true;
        };

        setPossuiErrors(err);
        return errors;
    };

    const handleDelete = (id: number) => {
        if (id > 0 && window.confirm("Realmente deseja apagar?")) {
            LigaService.deleteById(id)
                .then((result) => {
                    setShowModalMensagem(true);
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "success",
                        mensagem: "Registro excluido com sucesso!",
                        display: "none",
                        titulo: "Sucesso!"
                    });
                    navigate(adm ? "/adm/ligas" : voltarLigaSelecionada ? `/usuario/liga/${localStorage.getItem("@codigoLiga")}` : "/usuario/ligas")

                }).catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        logout();
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response !== undefined ? errors.response.data.mensagem : "Não foi possível efetuar a exclusão. Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar("");
                });
        }
    };

    const handleInputChangeImage = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            let imageFile = e.target.files[0];
            const reader = new FileReader();
            reader.onload = x => {
                setDadosImg({
                    imageFile: imageFile,
                    Imagem: e.target.name,
                    SrcImagem: x.target ? x.target?.result : img
                });
                setShowLogoImg(x.target?.result);
            };
            reader.readAsDataURL(imageFile);
            setLogoImg(e.target.files[0]);
        }
        else {
            setDadosImg({
                imageFile: null,
                Imagem: "",
                SrcImagem: img
            })
            setShowLogoImg(null);
            setLogoImg("");
        }
    };

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };

    const handleChangeStats = (e: any) => {        
        setStats(e.target.value);
        if (tipoLigaStats === true) {

            // let peso = listaStats.length > 0 ? listaStats.find(f => f.codigo === e.target.value)?.peso_Padrao : "0,00";
            // setPesoStats(peso !== undefined ? peso.toString().replaceAll(".", ",") : "0,00");
            // let dados = formRef.current?.getData();
            // dados = {
            //     ...dados, pesoStats: peso
            // }
            // formRef.current?.setData(dados);
        }
        else {
            setPesoStats( "0,00");
        }
    }

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            padding: "8px "
        },
        [`&.${tableCellClasses.footer}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        }
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td': {
            border: 0,
        },
        '&:last-child th': {
            border: 0,
            padding: "16px 10px "
        },
    }));

    const toggleModalMensagem = () => {

        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(-1) : navigate(redirecionar);
        }
    }

    const columns: GridColDef[] = [
        {
            field: 'codigo',
            headerName: 'ID',
            flex: 1,
            width: 50,
            headerClassName: 'super-app-theme--header',

        },
        {
            field: 'rodada',
            headerName: 'Rodada',
            flex: 1,
            width: 50,
            headerClassName: 'super-app-theme--header'
        },
        {
            field: 'escolha_Rodada',
            headerName: 'Escolha Rodada',
            editable: false,
            flex: 1,
            headerClassName: 'super-app-theme--header',
            align: 'center'
        },
        {
            field: 'posicao_Geral',
            headerName: 'Escolha Geral',
            headerClassName: 'super-app-theme--header',
            width: 30,
            editable: false,
            flex: 1,
            align: 'center',
            headerAlign: 'center'

        },
        {
            field: 'salario',
            headerName: 'Salário',
            editable: true,
            width: 30,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            //moedaRealLocaleValue(row.salario?.toString())
            renderCell: (params) => moedaRealLocaleValue(params.value),

        },
        {
            field: 'tempo_Contrato',
            headerName: 'Tempo Contrato',
            editable: true,
            width: 30,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            align: 'center',
            type: 'number',
            headerAlign: 'center',

        },
        {
            field: 'restrito',
            headerName: 'Restrito',
            editable: false,
            width: 30,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            //row.restrito ? "Sim" : "Não"
            renderCell: (params) => (params.value ? "Sim" : "Não"),
        }
    ];

    const [columnVisibilityModel, setColumnVisibilityModel] = useState<GridColumnVisibilityModel>({
        codigo: false,
    });

    const handleProcessRowUpdate = (updatedRow: any, originalRow: any) => {
        // Find the index of the row that was edited
        const rowIndex = draftNaoRows.findIndex((row) => row.codigo === updatedRow.codigo);

        // Replace the old row with the updated row
        const updatedRows = [...draftNaoRows];
        updatedRows[rowIndex] = updatedRow;
        updatedRows[rowIndex].salario = Number(updatedRows[rowIndex].salario);
        // Update the state with the new rows
        setDraftNaoRows(updatedRows);
        setAtualizar_Picks_Rodada_Inicial(true);

        // Return the updated row to update the internal state of the DataGrid
        return updatedRow;
    };

    const handleSelectedAPartir = async (e: { target: { name: string; value: any; }; }) => {
        setQuantidade_Ano_Partir_Direito(0);
        setNewLstQuantidadeDireitos(lstQuantidadeDireitos.filter(f => f.codigo >= e.target.value));

    };

    const handleSelectedAPartirSem = async (e: { target: { name: string; value: any; }; }) => {
        setQuantidade_Ano_Partir_Sem_Direito(0);
        setNewLstQuantidadeDireitosSem(lstQuantidadeDireitos.filter(f => f.codigo >= e.target.value));

    };



    return (
        <LayoutBaseDePagina titulo={id !== "nova" ? nome : "Cadastro de Liga"}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={id !== "nova"}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoNovo={id !== "nova"}
                    aoClicarEmSalvar={handleSubmit(formSubmitHandler)}
                    aoClicarEmApagar={() => handleDelete(codigo)}
                    aoClicarEmNovo={() => { localStorage.removeItem("@codigoLiga"); navigate("/ligas/detalhe/nova"); window.location.reload(); }}
                    aoClicarEmVoltar={() => navigate(adm ? "/adm/ligas" : voltarLigaSelecionada ? `/usuario/liga/${localStorage.getItem("@codigoLiga")}` : `/usuario/ligas`)}
                />
            }
        >
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <form onSubmit={handleSubmit(formSubmitHandler)}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container direction="column" padding={2} spacing={2}>
                        <Grid alignItems="center" justifyContent="center" width="100%">
                            <Paper>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs value={valueTabs} onChange={handleChangeTabs} variant="scrollable"
                                        scrollButtons
                                        sx={{
                                            [`& .${tabsClasses.scrollButtons}`]: {
                                                '&.Mui-disabled': { opacity: 0.3 },
                                            },
                                        }}
                                    >
                                        <Tab label="Liga"  {...a11yProps(0)} />
                                        <Tab label="Modo Disputa"
                                            disabled={id === "nova" && !showLigasCadastradas}
                                            {...a11yProps(1)} />
                                        <Tab label="Draft"
                                            disabled={(id === "nova" && !showLigasCadastradas) || !primeiraTemporada}
                                            {...a11yProps(2)} />
                                        <Tab label="Draft Calouros" disabled={id === "nova" && !showLigasCadastradas} {...a11yProps(3)} />
                                        <Tab label="Outras Config." disabled={id === "nova" && !showLigasCadastradas} {...a11yProps(4)} />
                                        <Tab label="Multas" disabled={id === "nova" && !showLigasCadastradas} {...a11yProps(5)} />
                                        <Tab label="Jogabilidade" disabled={id === "nova" && !showLigasCadastradas} {...a11yProps(6)} />
                                        <Tab label="Bonus CAP" disabled={id === "nova" && !showLigasCadastradas}{...a11yProps(7)} />
                                        <Tab label="Bonus CAP NBA" disabled={id === "nova" && !showLigasCadastradas} {...a11yProps(8)} />
                                        <Tab label="Bonus CAP Jogadores" disabled={id === "nova" && !showLigasCadastradas} {...a11yProps(9)} />
                                        <Tab label="Config. Free Agency" disabled={id === "nova" && !showLigasCadastradas} {...a11yProps(10)} />
                                        <Tab label="Config. Player Option" disabled={id === "nova" && !showLigasCadastradas} {...a11yProps(11)} />
                                        <Tab label="Regra Classificação" disabled={id === "nova" && !showLigasCadastradas} {...a11yProps(12)} />
                                    </Tabs>
                                </Box>
                                <TabPanel value={valueTabs} index={0}>
                                    {!removeLoading && <Loading />}
                                    {adm && (
                                        <>
                                            <Grid container size={{ xs: 12, sm: 12 }}>
                                                <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                                    <Typography variant="h6">Criar Liga</Typography>
                                                    <hr />
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} margin={1} direction="row" spacing={1}>
                                                <Grid size={{ xs: 6, sm: 2, md: 2 }} >
                                                    <Button
                                                        size="small"
                                                        color="primary"
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={carregarLigas}
                                                        startIcon={<Icon>content_copy</Icon>}
                                                        disabled={!adm}
                                                    >
                                                        Ligas
                                                    </Button>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} display={showLigasCadastradas ? "block" : "none"}>
                                                    <Autocomplete
                                                        size="small"
                                                        openText="Abrir"
                                                        closeText="Fechar"
                                                        noOptionsText="Sem opções"
                                                        loadingText="Carregando..."
                                                        disablePortal
                                                        options={opcoesAutoCompleteLigas}
                                                        loading={isLoading}
                                                        disabled={isLoading}
                                                        value={autoCompleteSelectedOptionLiga}
                                                        onChange={(event, newValue) => (setSelectedIdCompleteLiga(newValue?.codigo), carregarLigaPorCodigo(Number(newValue?.codigo), true))}
                                                        popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 20 : 28} /> : undefined}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Ligas"
                                                                slotProps={{
                                                                    inputLabel: {
                                                                        style: {
                                                                            fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 6, sm: 3, md: 3 }} >
                                                    <Button
                                                        size={"small"}
                                                        color="primary"
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={VirarTemporadaLiga}
                                                        startIcon={<Icon>copy_all</Icon>}
                                                        disabled={!adm}
                                                    >
                                                        Virar Temporada Liga
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </>
                                    )}
                                    <Grid container size={{ xs: 12, sm: 12 }}>
                                        <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                            <Typography variant="h6">Geral</Typography>
                                            <hr />
                                        </Grid>
                                    </Grid>
                                    <Grid container size={{ xs: 12, sm: 12 }} margin={1} direction="row" spacing={1}>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                            <FormControl fullWidth size={"small"}>
                                                <InputLabel id="demo-simple-select-label">Tipo Liga *</InputLabel>
                                                <Controller name="tipo" control={control}
                                                    rules={{ required: true }}
                                                    render={({ field: { onChange } }) => (
                                                        <Select
                                                            size="small"
                                                            required
                                                            disabled={!adm}
                                                            label="Tipo Liga"
                                                            variant="outlined"
                                                            name="tipo"
                                                            value={codigoTipoLiga}
                                                            defaultValue={0}
                                                            onChange={(e) => { onChange(e); setCodigoTipoLiga(Number(e.target.value)); }}
                                                        >
                                                            <MenuItem value={0}>Selecione</MenuItem>
                                                            {
                                                                tiposLiga.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                            }
                                                        </Select>
                                                    )}
                                                />
                                            </FormControl >
                                        </Grid>
                                    </Grid>
                                    {/* {edicao && ( */}
                                    <Grid container size={{ xs: 12, sm: 12 }} margin={1} direction="row" spacing={1}>
                                        <Grid size={{ xs: 12, sm: 6, md: 1 }}>
                                            <Controller name="nome" control={control}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        placeholder="Codigo"
                                                        name="codigo"
                                                        disabled
                                                        label="Código"
                                                        value={codigo}
                                                        onChange={(e) => setCodigo(Number(e.target.value))}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            }
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                    {/* )} */}
                                    <Grid container size={{ xs: 12, sm: 12 }} margin={1} spacing={1}>
                                        <Grid size={{ xs: 12, sm: 12, md: 3 }} >
                                            <Controller name="nome" control={control}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        required
                                                        fullWidth
                                                        name="nome"
                                                        disabled={isLoading}
                                                        label="Nome da liga"
                                                        onChange={(e) => { setNome(e.target.value); }}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            }
                                                        }}
                                                    />
                                                )}
                                            />
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} height="24px">
                                                {errors.nome && <span style={{ fontSize: "13px", color: "red" }}>Campo Obrigatório</span>}
                                            </Grid>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                                            <FormControl fullWidth size={"small"}>
                                                <InputLabel id="demo-simple-select-label">Qtde. Franquias *</InputLabel>
                                                <Controller name="quantidade_Franquia" control={control}
                                                    rules={{ required: true }}
                                                    render={({ field: { onChange } }) => (
                                                        <Select
                                                            size="small"
                                                            required
                                                            disabled={isLoading || edicao}
                                                            label="Qtde. Franquias"
                                                            variant="outlined"
                                                            name="quantidade_Franquia"
                                                            value={quantidadeFranquia}
                                                            defaultValue={30}
                                                            onChange={(e) => { onChange(e); setQuantidadeFranquia(Number(e.target.value)); }}
                                                        >
                                                            <MenuItem value={0}>Selecione</MenuItem>
                                                            {
                                                                qtdTimesLiga.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                            }
                                                        </Select>
                                                    )}
                                                />
                                            </FormControl >
                                            {errors.quantidade_Franquia && <span style={{ fontSize: "13px", color: "red" }}>Campo Obrigatório</span>}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                                            <FormControl fullWidth size={"small"}>
                                                <InputLabel id="demo-simple-select-label">Temporada *</InputLabel>
                                                <Controller name="configuracao_Liga.codigo_Temporada" control={control}
                                                    rules={{ required: true }}
                                                    render={({ field: { onChange } }) => (
                                                        <Select
                                                            size="small"
                                                            required
                                                            //disabled={isLoading || edicao}
                                                            label="Temporada"
                                                            variant="outlined"
                                                            name="configuracao_Liga.codigo_Temporada"
                                                            value={codigoTemporada}
                                                            defaultValue={0}
                                                            onChange={(e) => { setCodigoTemporada(Number(e.target.value)); handleSelectedTemporada(e) }}
                                                        >
                                                            <MenuItem value={0}>Selecione</MenuItem>
                                                            {
                                                                lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                            }
                                                        </Select>
                                                    )}
                                                />
                                            </FormControl >
                                            <Grid size={{ xs: 12, sm: 12, md: 12 }} height="24px">
                                                {errors.configuracao_Liga?.codigo_Temporada && <span style={{ fontSize: "13px", color: "red" }}>Campo Obrigatório</span>}
                                            </Grid>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                                            <FormControl fullWidth size={"small"}>
                                                <InputLabel id="demo-simple-select-label">Status *</InputLabel>
                                                <Controller name="status" control={control}
                                                    rules={{ required: true }}
                                                    render={({ field: { onChange } }) => (
                                                        <Select
                                                            size="small"
                                                            required
                                                            //disabled={isLoading || edicao}
                                                            label="Status"
                                                            variant="outlined"
                                                            name="status"
                                                            value={codigoStatus}
                                                            defaultValue={0}
                                                            onChange={(e) => setCodigoStatus(Number(e.target.value))}
                                                        >
                                                            <MenuItem value={0}>Selecione</MenuItem>
                                                            {
                                                                lstStatus.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                            }
                                                        </Select>
                                                    )}
                                                />
                                            </FormControl >
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                            <FormControl disabled={isLoading || user.codigo_Perfil !== 1} required>
                                                <FormControlLabel
                                                    control={
                                                        <MuiCheckBox
                                                            name="restrito"
                                                            checked={restrito}
                                                            onChange={(e) => { setChkRestrita(e.target.checked) }}


                                                        />
                                                    }
                                                    label="Restrito"
                                                    labelPlacement="start"
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                    {(exibeConfiguracao || edicao) && (
                                        <Grid container size={{ xs: 12, sm: 12 }}>
                                            <Grid container size={{ xs: 12, sm: 12 }} marginTop={2}>
                                                <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                                    <Typography variant="h6">Configurações</Typography>
                                                    <hr />
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} margin={1} spacing={1} display="flex" justifyItems="center" alignItems="end">
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                                                    <FormControl fullWidth size={"small"}>
                                                        <InputLabel id="demo-simple-select-label">Tipo de Pontuação *</InputLabel>
                                                        <Controller name="configuracao_Liga.codigo_Tipo_Pontuacao" control={control}
                                                            render={({ field: { onChange } }) => (
                                                                <Select
                                                                    required
                                                                    size="small"
                                                                    disabled={isLoading || edicao}
                                                                    label="Tipo de Pontuação"
                                                                    variant="outlined"
                                                                    name="codigo_Tipo_Pontuacao"
                                                                    value={codigoTipoPontuacao}
                                                                    onChange={(e) => {
                                                                        onChange(e);
                                                                        setCodigoTipoPontuacao(Number(e.target.value));
                                                                        setTipoLigaStats(e.target.value === 1);
                                                                        setMetodosRows([]);
                                                                        setTotalCountDisputa(0);
                                                                    }}
                                                                >
                                                                    <MenuItem value={0}>Selecione</MenuItem>
                                                                    {
                                                                        lstTipoLiga.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                    }
                                                                </Select>
                                                            )}
                                                        />
                                                    </FormControl >
                                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} height="24px">
                                                        {errors.configuracao_Liga?.codigo_Tipo_Pontuacao && <span style={{ fontSize: "13px", color: "red" }}>Campo Obrigatório</span>}
                                                    </Grid>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <Controller name="configuracao_Liga.cap" control={control}
                                                        rules={{ required: true }}
                                                        render={({ field }) => (
                                                            <TextField
                                                                {...field}
                                                                size="small"
                                                                required
                                                                fullWidth
                                                                name="cap"
                                                                disabled={isLoading}
                                                                label="CAP"
                                                                //value={`R$ ${cap}`}
                                                                //onChange={(e) => { setNome(e.target.value); }}
                                                                slotProps={{
                                                                    input: {
                                                                        inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                                    },
                                                                    inputLabel: {
                                                                        shrink: edicao ? true : undefined,
                                                                        style: {
                                                                            fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} height="24px">
                                                        {errors.configuracao_Liga?.cap && <span style={{ fontSize: "13px", color: "red" }}>Campo Obrigatório</span>}
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 6, md: 4 }} spacing={1} display="flex" justifyContent="center" alignContent="center">
                                                    <Grid size={{ xs: 12, sm: 12 }} textAlign="center" >
                                                        <Typography variant="h6">Número de Jogadores</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 6 }} >
                                                        <Controller name="configuracao_Liga.num_Min_Jogadores" control={control}
                                                            rules={{ required: true }}
                                                            render={({ field }) => (
                                                                <TextField
                                                                    {...field}
                                                                    size="small"
                                                                    required
                                                                    fullWidth
                                                                    name="num_Min_Jogadores"
                                                                    disabled={isLoading}
                                                                    label="Mínimo"
                                                                    slotProps={{
                                                                        inputLabel: {
                                                                            shrink: edicao ? true : undefined,
                                                                            style: {
                                                                                fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                            }
                                                                        },
                                                                        htmlInput: {
                                                                            maxLength: 2,
                                                                            min: 0
                                                                        }
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                        <Grid size={{ xs: 12, sm: 12, md: 12 }} height="24px">
                                                            {errors.configuracao_Liga?.num_Min_Jogadores && <span style={{ fontSize: "13px", color: "red" }}>Campo Obrigadtório</span>}
                                                        </Grid>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 6 }} >
                                                        <Controller name="configuracao_Liga.num_Max_Jogadores" control={control}
                                                            rules={{ required: true }}
                                                            render={({ field }) => (
                                                                <TextField
                                                                    {...field}
                                                                    size="small"
                                                                    required
                                                                    fullWidth
                                                                    name="num_Max_Jogadores"
                                                                    disabled={isLoading}
                                                                    label="Máximo"
                                                                    slotProps={{
                                                                        inputLabel: {
                                                                            shrink: edicao ? true : undefined,
                                                                            style: {
                                                                                fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                            }
                                                                        },
                                                                        htmlInput: {
                                                                            maxLength: 2,
                                                                            min: 0
                                                                        }
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                        <Grid size={{ xs: 12, sm: 12, md: 12 }} height="24px">
                                                            {errors.configuracao_Liga?.num_Max_Jogadores && <span style={{ fontSize: "13px", color: "red" }}>Campo obrigatório</span>}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 6, md: 4 }} spacing={1} display="flex" justifyContent="center" alignContent="center">
                                                    <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                        <Typography variant="h6">Limites de CAP</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 6 }} >
                                                        <Controller name="configuracao_Liga.cap_Minimo" control={control}
                                                            rules={{ required: true }}
                                                            render={({ field }) => (
                                                                <TextField
                                                                    {...field}
                                                                    size="small"
                                                                    required
                                                                    fullWidth
                                                                    name="cap_Minimo"
                                                                    disabled={isLoading}
                                                                    label="Mínimo"
                                                                    defaultValue="0"

                                                                    slotProps={{
                                                                        input: {
                                                                            inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                                        },
                                                                        inputLabel: {
                                                                            shrink: edicao ? true : undefined,
                                                                            style: {
                                                                                fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                            }
                                                                        },
                                                                        htmlInput: {
                                                                            maxLength: 20,
                                                                            min: 0
                                                                        }
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                        <Grid size={{ xs: 12, sm: 12, md: 12 }} height="24px">
                                                            {errors.configuracao_Liga?.cap_Minimo && <span style={{ fontSize: "13px", color: "red" }}>Campo obrigatório</span>}
                                                        </Grid>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 6 }} >
                                                        <Controller name="configuracao_Liga.cap_Maximo" control={control}
                                                            rules={{ required: true }}
                                                            render={({ field }) => (
                                                                <TextField
                                                                    {...field}
                                                                    size="small"
                                                                    required
                                                                    fullWidth
                                                                    name="cap_Maximo"
                                                                    disabled={isLoading}
                                                                    label="Máximo"
                                                                    defaultValue="0"
                                                                    slotProps={{
                                                                        input: {
                                                                            inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                                        },
                                                                        inputLabel: {
                                                                            shrink: edicao ? true : undefined,
                                                                            style: {
                                                                                fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                            }
                                                                        },
                                                                        htmlInput: {
                                                                            maxLength: 20,
                                                                            min: 0
                                                                        }
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                        <Grid size={{ xs: 12, sm: 12, md: 12 }} height="24px">
                                                            {errors.configuracao_Liga?.cap_Maximo && <span style={{ fontSize: "13px", color: "red" }}>Campo Obrigatório</span>}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} marginTop={2}>
                                                <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" >
                                                    <Grid size={{ xs: 12, sm: 12 }} padding={1} textAlign="initial" >
                                                        <Typography variant="h6">Comissários</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                        <Autocomplete
                                                            openText="Abrir"
                                                            closeText="Fechar"
                                                            noOptionsText="Sem opções"
                                                            loadingText="Carregando..."
                                                            disablePortal
                                                            options={opcoesAutoCompleteUsuario}
                                                            loading={isLoading}
                                                            disabled={isLoading}
                                                            value={autoCompleteSelectedOption}
                                                            size={"small"}
                                                            onChange={(event, newValue) => setSelectedIdComplete(newValue?.codigo)}
                                                            popupIcon={isLoading ? <CircularProgress size={28} /> : undefined}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Usuário"
                                                                    slotProps={{
                                                                        inputLabel: {
                                                                            style: {
                                                                                fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 6 }} display="flex" alignItems="center" justifyContent="flex-end" justifyItems="center" textAlign="end">
                                                        <Button
                                                            size="small"
                                                            color="primary"
                                                            variant="contained"
                                                            disableElevation
                                                            onClick={adicionaComissario}
                                                            startIcon={<Icon>add</Icon>}
                                                        >
                                                            Adicionar
                                                        </Button>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }} >
                                                        <hr />
                                                        <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                            <Table>
                                                                <TableHead>
                                                                    <StyledTableRow>
                                                                        <StyledTableCell align="center" width={70}>Ações</StyledTableCell>
                                                                        {edicao && <StyledTableCell align="center">Código</StyledTableCell>}
                                                                        <StyledTableCell >Nome</StyledTableCell>
                                                                        <StyledTableCell>E-mail</StyledTableCell>
                                                                        <StyledTableCell align="center">Criador</StyledTableCell>
                                                                    </StyledTableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {comissariosRows.map((row) => (
                                                                        <StyledTableRow key={row.codigo_Usuario}>
                                                                            {!row.criador ?
                                                                                (<StyledTableCell align="center" sx={{ padding: "2px" }}>
                                                                                    <IconButton size="small" onClick={() => deleteComissario(row.codigo_Usuario)}>
                                                                                        <Icon>delete</Icon>
                                                                                    </IconButton>
                                                                                </StyledTableCell>) : <StyledTableCell></StyledTableCell>
                                                                            }
                                                                            {edicao && <StyledTableCell align="center">{row.codigo_Usuario}</StyledTableCell>}
                                                                            <StyledTableCell>{row.nome}</StyledTableCell>
                                                                            <StyledTableCell>{row.email}</StyledTableCell>
                                                                            <StyledTableCell align="center">{row.criador ? "Sim" : "Não"}</StyledTableCell>
                                                                        </StyledTableRow>
                                                                    ))
                                                                    }
                                                                </TableBody>
                                                                {totalCountRowsComis === 0 && !isLoading && (
                                                                    <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                                                )}
                                                                <TableFooter>
                                                                    {isLoading && (
                                                                        <StyledTableRow>
                                                                            <StyledTableCell colSpan={7}>
                                                                                <LinearProgress variant="indeterminate" />
                                                                            </StyledTableCell>
                                                                        </StyledTableRow>
                                                                    )}
                                                                    {(totalCountRowsComis > 0 && totalCountRowsComis > Enviroment.LIMITE_DE_LINHAS) && (
                                                                        <StyledTableRow>
                                                                            <StyledTableCell colSpan={7}>
                                                                                <Pagination
                                                                                    page={pagina}
                                                                                    count={Math.ceil(totalCountRowsComis / Enviroment.LIMITE_DE_LINHAS)}
                                                                                    onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                                                                                />
                                                                            </StyledTableCell>
                                                                        </StyledTableRow>
                                                                    )}
                                                                </TableFooter>
                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} marginTop={2}>
                                                <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" >
                                                    <Grid size={{ xs: 12, sm: 12 }} padding={1} textAlign="initial" >
                                                        <Typography variant="h6">GM</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                        <Autocomplete
                                                            openText="Abrir"
                                                            closeText="Fechar"
                                                            noOptionsText="Sem opções"
                                                            loadingText="Carregando..."
                                                            disablePortal
                                                            options={opcoesAutoCompleteUsuarioGM}
                                                            loading={isLoading}
                                                            disabled={isLoading}
                                                            value={autoCompleteSelectedOptionGM}
                                                            size={"small"}
                                                            onChange={(event, newValue) => setSelectedIdCompleteGM(newValue?.codigo)}
                                                            popupIcon={isLoading ? <CircularProgress size={28} /> : undefined}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Usuário"
                                                                    slotProps={{
                                                                        inputLabel: {
                                                                            style: {
                                                                                fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 6 }} display="flex" alignItems="center" justifyContent="flex-end" justifyItems="center" textAlign="end">
                                                        <Button
                                                            size="small"
                                                            color="primary"
                                                            variant="contained"
                                                            disableElevation
                                                            onClick={adicionaGM}
                                                            startIcon={<Icon>add</Icon>}
                                                        >
                                                            Adicionar
                                                        </Button>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }} >
                                                        <hr />
                                                        <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                            <Table>
                                                                <TableHead>
                                                                    <StyledTableRow>
                                                                        <StyledTableCell align="center" width={70}>Ações</StyledTableCell>
                                                                        {edicao && <StyledTableCell align="center">Código</StyledTableCell>}
                                                                        <StyledTableCell >Nome</StyledTableCell>
                                                                        <StyledTableCell>E-mail</StyledTableCell>
                                                                        <StyledTableCell align="center">Criador</StyledTableCell>
                                                                    </StyledTableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {gmsRows.map((row) => (
                                                                        <StyledTableRow key={row.codigo_Usuario}>
                                                                            {!row.criador ?
                                                                                (<StyledTableCell align="center" sx={{ padding: "2px" }}>
                                                                                    <IconButton size="small" onClick={() => deleteGM(row.codigo_Usuario)}>
                                                                                        <Icon>delete</Icon>
                                                                                    </IconButton>
                                                                                </StyledTableCell>) : <StyledTableCell></StyledTableCell>
                                                                            }
                                                                            {edicao && <StyledTableCell align="center">{row.codigo_Usuario}</StyledTableCell>}
                                                                            <StyledTableCell>{row.nome}</StyledTableCell>
                                                                            <StyledTableCell>{row.email}</StyledTableCell>
                                                                            <StyledTableCell align="center">{row.criador ? "Sim" : "Não"}</StyledTableCell>
                                                                        </StyledTableRow>
                                                                    ))
                                                                    }
                                                                </TableBody>
                                                                {totalCountRowsGms === 0 && !isLoading && (
                                                                    <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                                                )}
                                                                <TableFooter>
                                                                    {isLoading && (
                                                                        <StyledTableRow>
                                                                            <StyledTableCell colSpan={7}>
                                                                                <LinearProgress variant="indeterminate" />
                                                                            </StyledTableCell>
                                                                        </StyledTableRow>
                                                                    )}
                                                                    {(totalCountRowsGms > 0 && totalCountRowsGms > Enviroment.LIMITE_DE_LINHAS) && (
                                                                        <StyledTableRow>
                                                                            <StyledTableCell colSpan={7}>
                                                                                <Pagination
                                                                                    page={pagina}
                                                                                    count={Math.ceil(totalCountRowsGms / Enviroment.LIMITE_DE_LINHAS)}
                                                                                    onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                                                                                />
                                                                            </StyledTableCell>
                                                                        </StyledTableRow>
                                                                    )}
                                                                </TableFooter>
                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} marginTop={2}>
                                                <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                                    <Typography variant="h6">Logo</Typography>
                                                    <hr />
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }}>
                                                <Grid container size={{ xs: 12, sm: 12 }} margin={1} spacing={1} display="flex" justifyItems="center" alignItems="end" >
                                                    <Grid size={{ xs: 12, sm: 12 }} >
                                                        <TextField
                                                            type="file"
                                                            size={"small"}
                                                            onChange={(e: ChangeEvent<HTMLInputElement>) => { handleInputChangeImage(e) }}
                                                            slotProps={{
                                                                htmlInput: { accept: "image/*" },
                                                                input: {
                                                                    inputProps: {
                                                                        accept: "image/*",
                                                                    }
                                                                }
                                                            }}
                                                            className="classes.input"
                                                            name="imagem"
                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }} display="flex" justifyContent="start">
                                                        <img src={showLogoImg} alt="SrcImagem" width="200" height="200" />
                                                        {/* {errors.showLogoImg && <span style={{ fontSize: "13px", color: "red" }}>{errors.showLogoImg}</span>} */}
                                                    </Grid>

                                                    {edicao && <Grid display="none" >
                                                        <TextField
                                                            type="file"
                                                            size={"small"}
                                                            slotProps={{
                                                                htmlInput: { accept: "image/*" }
                                                            }}
                                                            className="classes.input"
                                                            name="imagemPerfil"
                                                        />
                                                        {/* <VInput
                                                            type="text"
                                                            name="logo"
                                                        /> */}
                                                    </Grid>
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )}
                                </TabPanel>
                                <TabPanel value={valueTabs} index={1}>
                                    {(!removeLoading || isLoading) && <Loading />}
                                    <Grid container size={{ xs: 12, sm: 12 }} direction="column">
                                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" justifyContent="left" alignContent="center">
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                <Typography variant="h6">Método de Disputa</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Stats</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        label="Stats"
                                                        value={stats}
                                                        onChange={handleChangeStats}
                                                        defaultValue={0}>
                                                        <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                                        {
                                                            dropStats.map(qtd =>
                                                                <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                            )
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ display:tipoLigaStats ? "none" : "block" }}>
                                                {tipoLigaStats ? (<TextField name={pesoStats}
                                                    disabled={true}
                                                    label="Peso"
                                                    type="text"
                                                    value={pesoStats}
                                                    onChange={e => setPesoStats("0")}
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        }
                                                    }}
                                                />)
                                                    :
                                                    (
                                                        <TextField name="pesoStats"
                                                            disabled={isLoading}
                                                            label="Peso"
                                                            type="text"
                                                            value={pesoStats}
                                                            onChange={e => setPesoStats(e.target.value)}
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                },
                                                                htmlInput: {
                                                                    maxLength: 5,
                                                                    min: 0
                                                                }
                                                            }}
                                                        />
                                                        // <VTextMaskCustom
                                                        //     fullWidth
                                                        //     name="pesoStats"
                                                        //     disabled={isLoading}
                                                        //     label="Peso"
                                                        //     type="text"
                                                        //     typeMask="currency"
                                                        //     value={pesoStats}
                                                        //     onChange={e => setPesoStats(e.target.value)}
                                                        //     slotProps={{
                                                        //         inputLabel: {
                                                        //             shrink: edicao ? true : undefined,
                                                        //         }
                                                        //     }}

                                                        //     maxLength={5}
                                                        // />
                                                    )}
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 6 }} display="flex" alignItems="center" justifyContent="flex-end" justifyItems="center" textAlign="end">
                                                <Button
                                                    color="primary"
                                                    variant="contained"
                                                    disableElevation
                                                    onClick={criarMetodo}
                                                    endIcon={<Icon>add</Icon>}
                                                >
                                                    Adicionar
                                                </Button>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                <hr />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12 }} >
                                                <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                    <Table>
                                                        <TableHead>
                                                            <StyledTableRow>
                                                                <StyledTableCell align="center" width={100}>Ações</StyledTableCell>
                                                                <StyledTableCell>Stats</StyledTableCell>
                                                                <StyledTableCell align="center">Peso</StyledTableCell>
                                                            </StyledTableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {metodosRows.map((row, index) => (
                                                                <StyledTableRow key={index}>
                                                                    <StyledTableCell align="center" sx={{ padding: "2px" }} >
                                                                        <IconButton size="small" onClick={() => deleteMetodo(index)}>
                                                                            <Icon>delete</Icon>
                                                                        </IconButton>
                                                                    </StyledTableCell>
                                                                    <StyledTableCell>{listaStats.find(f => f.codigo === row.stats)?.descricao}</StyledTableCell>
                                                                    <StyledTableCell align="center">{row.peso.toFixed(2).toString().replace(".", ",")}</StyledTableCell>
                                                                </StyledTableRow>
                                                            ))
                                                            }
                                                        </TableBody>
                                                        {totalCountDisputa === 0 && !isLoading && (
                                                            <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                                        )}
                                                        <TableFooter>
                                                            {isLoading && (
                                                                <StyledTableRow>
                                                                    <StyledTableCell colSpan={7}>
                                                                        <LinearProgress variant="indeterminate" />
                                                                    </StyledTableCell>
                                                                </StyledTableRow>
                                                            )}
                                                            {(totalCountDisputa > 0 && totalCountDisputa > (Enviroment.LIMITE_DE_LINHAS * 2)) && (
                                                                <StyledTableRow>
                                                                    <StyledTableCell colSpan={7}>
                                                                        <Pagination
                                                                            page={pagina}
                                                                            count={Math.ceil(totalCountDisputa / (Enviroment.LIMITE_DE_LINHAS * 2))}
                                                                            onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                                                                        />
                                                                    </StyledTableCell>
                                                                </StyledTableRow>
                                                            )}
                                                        </TableFooter>
                                                    </Table>
                                                </TableContainer>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid container size={{ xs: 12, sm: 12 }} direction="column" marginTop={3}>
                                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2} >
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                <Typography variant="h6">Jogo</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                <FormControl disabled={isLoading || user.codigo_Perfil !== 1} required>
                                                    <FormControlLabel
                                                        control={
                                                            <MuiCheckBox
                                                                name="configuracao_Liga.aceita_Empate"
                                                                checked={aceita_Empate}
                                                                onChange={(e) => { setChkEmpate(e.target.checked) }}


                                                            />
                                                        }
                                                        label="Não aceita empate?"
                                                        labelPlacement="start"
                                                    />
                                                </FormControl>
                                            </Grid>

                                            {aceita_Empate && (
                                                <>
                                                    <Grid container size={{ xs: 12, sm: 12 }} spacing={2} display="flex" >
                                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                            <FormControl fullWidth>
                                                                <InputLabel id="demo-simple-select-label">Stats</InputLabel>
                                                                <Select
                                                                    labelId="demo-simple-select-label"
                                                                    id="demo-simple-select"
                                                                    label="Stats"
                                                                    value={statsEmpate}
                                                                    onChange={e => setStatsEmpate(e.target.value)}
                                                                    defaultValue=""
                                                                >
                                                                    {/* <MenuItem key="0" value={0}>Selecione...</MenuItem> */}
                                                                    {
                                                                        dropStats.map(qtd =>
                                                                            <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                                        )
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 6, md: 6 }} display="flex" alignItems="center" justifyContent="start" justifyItems="center" textAlign="start">
                                                            <Button
                                                                color="primary"
                                                                variant="contained"
                                                                disableElevation
                                                                onClick={criarRegrasDeEmpate}
                                                                endIcon={<Icon>add</Icon>}>
                                                                Adicionar
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container size={{ xs: 12, sm: 12 }} spacing={2} display="flex" paddingTop={2}>
                                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} display={tipoPosicaoConfronto === 5 ? "none" : "flex"}>
                                                            <FormControl>
                                                                <FormControlLabel
                                                                    control={<MuiCheckBox
                                                                        required
                                                                        name="chkSetimoJogador"
                                                                        checked={chkSetimoJogador ? chkSetimoJogador : false}
                                                                        onChange={e => {
                                                                            setChkSetimoJogador(e.target.checked);
                                                                            e.target.checked ? inserirRegrasDeEmpateSetimoJogador() : removeRegraDeEmpateSetimoJogador()
                                                                        }}
                                                                    />}
                                                                    label="Setimo jogador?"
                                                                />
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} display={chkSetimoJogador ? "flex" : "none"}>
                                                            <FormControl fullWidth>
                                                                <InputLabel id="demo-simple-select-label">Jogador Desempate</InputLabel>
                                                                <Select
                                                                    labelId="demo-simple-select-label"
                                                                    id="demo-simple-select"
                                                                    label="Jogador Desempate"
                                                                    value={homemDesempate}
                                                                    onChange={e => { inserirRegrasDeEmpateMaisJogador(Number(e.target.value)) }}

                                                                >
                                                                    <MenuItem key={0} value={0}>{"Selecione..."}</MenuItem>
                                                                    <MenuItem key={8} value={103}>{"Oitavo Jogador"}</MenuItem>
                                                                    <MenuItem key={9} value={104} disabled={!empateRows.find(f => f.stats === 103)}>{"Nono Jogador"}</MenuItem>
                                                                    <MenuItem key={10} value={105} disabled={!empateRows.find(f => f.stats === 104)}>{"Décimo Jogador"}</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid container size={{ xs: 12, sm: 12 }} >
                                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                                <hr />
                                                            </Grid>
                                                            <Grid size={{ xs: 12, sm: 12 }} >
                                                                <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                                    <Table>
                                                                        <TableHead>
                                                                            <StyledTableRow>
                                                                                <StyledTableCell align="center" width={100}>Ações</StyledTableCell>
                                                                                {/* {edicao && <StyledTableCell  align="center">Código</StyledTableCell>} */}
                                                                                <StyledTableCell>Ordem</StyledTableCell>
                                                                                <StyledTableCell>Stats</StyledTableCell>
                                                                                {/* <StyledTableCell align="center">Stats Id</StyledTableCell> */}
                                                                                <StyledTableCell sx={{ display: "none" }}>Sétimo Homem</StyledTableCell>
                                                                            </StyledTableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {empateRows.map((row, index) => (
                                                                                <StyledTableRow key={index}>
                                                                                    <StyledTableCell align="center" sx={{ padding: "2px" }} >
                                                                                        <IconButton size="small" onClick={() => deleteRegraDeEmpate(row.stats)}>
                                                                                            <Icon>delete</Icon>
                                                                                        </IconButton>
                                                                                    </StyledTableCell>
                                                                                    {/* {edicao && <StyledTableCell  align="center">{row.codigo}</StyledTableCell>} */}
                                                                                    <StyledTableCell>{row.ordem}</StyledTableCell>
                                                                                    <StyledTableCell>{row.stats === 102 ? "Mandante"
                                                                                        : row.stats === 101 ? "Setimo Homem"
                                                                                            : row.stats === 103 ? "Oitavo Homem"
                                                                                                : row.stats === 104 ? "Nono Homem"
                                                                                                    : row.stats === 105 ? "Décimo Homem"
                                                                                                        : dropStats.find(f => f.codigo === row.stats)?.label}
                                                                                    </StyledTableCell>
                                                                                    {/* <StyledTableCell align="center">{row.stats}</StyledTableCell> */}
                                                                                    <StyledTableCell sx={{ display: "none" }}>{row.stats === 101 ? "true" : "false"}</StyledTableCell>
                                                                                </StyledTableRow>
                                                                            ))
                                                                            }
                                                                        </TableBody>
                                                                        {empateTotalCount === 0 && !isLoading && (
                                                                            <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                                                        )}
                                                                        <TableFooter>
                                                                            {isLoading && (
                                                                                <StyledTableRow>
                                                                                    <StyledTableCell colSpan={7}>
                                                                                        <LinearProgress variant="indeterminate" />
                                                                                    </StyledTableCell>
                                                                                </StyledTableRow>
                                                                            )}
                                                                            {(empateTotalCount > 0 && empateTotalCount > Enviroment.LIMITE_DE_LINHAS) && (
                                                                                <StyledTableRow>
                                                                                    <StyledTableCell colSpan={7}>
                                                                                        <Pagination
                                                                                            page={pagina}
                                                                                            count={Math.ceil(empateTotalCount / Enviroment.LIMITE_DE_LINHAS)}
                                                                                            onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                                                                                        />
                                                                                    </StyledTableCell>
                                                                                </StyledTableRow>
                                                                            )}
                                                                        </TableFooter>
                                                                    </Table>
                                                                </TableContainer>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </>
                                            )}
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={valueTabs} index={2}>
                                    {(!removeLoading || isLoading) && <Loading />}
                                    <Grid container direction="column" >
                                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2} >
                                            {/* <Scope path="configuracao_Liga"> */}
                                            <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2} >
                                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                    <Typography variant="h6">Draft Inicial</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                                                    <FormControl fullWidth size={"small"}>
                                                        <InputLabel id="demo-simple-select-label">Qtde. de Rodadas</InputLabel>
                                                        <Controller name="configuracao_Liga.quantidade_Rodada_Draft" control={control}
                                                            render={({ field: { onChange } }) => (
                                                                <Select
                                                                    size="small"
                                                                    disabled={isLoading}
                                                                    label="Qtde. de Rodadas"
                                                                    variant="outlined"
                                                                    name="quantidade_Rodada_Draft"
                                                                    //value={codigoStatus}
                                                                    defaultValue={0}
                                                                    onChange={(e) => { onChange(e); handleRowsRodadas(e); }}
                                                                >
                                                                    <MenuItem value={0}>Selecione</MenuItem>
                                                                    {
                                                                        lstRodadasDraft.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                    }
                                                                </Select>
                                                            )}
                                                        />
                                                    </FormControl >
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">Incluir Calouros</InputLabel>
                                                        <Select
                                                            size="small"
                                                            label="incluirCalouros"
                                                            name="incluir_Calouros"
                                                            value={incluir_Calouros}
                                                            onChange={e => setIncluir_Calouros(Number(e.target.value))}
                                                            defaultValue={0}
                                                        >
                                                            <MenuItem key="0" value="0">Selecione</MenuItem>
                                                            {
                                                                SimNao.map(qtd =>
                                                                    <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>)
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">Salários Reais NBA</InputLabel>
                                                        <Select
                                                            size="small"
                                                            label="Salários Reais NBA"
                                                            name="salarios_Reais_NBA"
                                                            value={salarios_Reais_NBA}
                                                            onChange={e => { setSalarios_Reais_NBA(Number(e.target.value)); setValorUtilizadoSalario(""); setAtualizar_Picks_Rodada_Inicial(true); }}
                                                            defaultValue={0}
                                                        >
                                                            {/* <MenuItem key="0" value="0">Selecione</MenuItem> */}
                                                            {
                                                                SimNao.map(qtd =>
                                                                    <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>)
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            {/* </Scope> */}
                                            {qtdRodadas > 0 && (
                                                <Grid container>
                                                    <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2} >
                                                        <Grid size={{ xs: 12, sm: 12, md: 12 }} >
                                                            <FormControl>
                                                                <FormLabel component="legend">Rodadas Jogadores Restritos</FormLabel>
                                                                <FormGroup aria-label="position" row>
                                                                    {
                                                                        rowsRodadasDraft.map((i, index) =>
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <MuiCheckBox
                                                                                        name="chkJogadasJogRestritos"
                                                                                        value={index}
                                                                                        id={index.toString()}
                                                                                        defaultChecked={cksRodJogRest?.find(f => f.rodada === i)?.value}
                                                                                        onChange={(e) => handleCheckedJogadoresRestritos(e)} />}
                                                                                label={i}
                                                                                key={i}
                                                                            />
                                                                        )
                                                                    }
                                                                </FormGroup>
                                                            </FormControl>
                                                        </Grid>
                                                        {/* </Grid>
                                                <Grid container size={{xs:12, sm:12}} spacing={1} display="flex" marginBottom={2} > */}
                                                        <Grid size={{ xs: 12, sm: 12, md: 12 }} >
                                                            <FormControl>
                                                                <FormLabel component="legend">Escolhas Espelhadas</FormLabel>
                                                                <FormGroup aria-label="position" row>
                                                                    {
                                                                        rowsEscolhasDraft.map((i, index) =>
                                                                            <FormControlLabel
                                                                                control={<MuiCheckBox
                                                                                    name="chkEscolhasEspelhadas"
                                                                                    value={index}
                                                                                    id={index.toString()}
                                                                                    defaultChecked={cksRodJogEsp?.find(f => f.rodada === i)?.value}
                                                                                    onChange={(e) => handleCheckedJogadoresEspelhados(e)} />}
                                                                                key={i}
                                                                                label={i}
                                                                            />
                                                                        )
                                                                    }
                                                                </FormGroup>
                                                            </FormControl>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            )}
                                            {salarios_Reais_NBA === 1 ?
                                                (<Grid container spacing={2} display="flex">
                                                    <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" marginTop={2}>
                                                        <Typography variant="h6">Intervalo de Salários</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            name="salarioMinimo"
                                                            disabled={isLoading}
                                                            label="Salário Mínimo"
                                                            defaultValue="0"
                                                            value={valorSalarioMinimo}
                                                            onFocus={(e) => e.target.select()}
                                                            onChange={(e) => { setValorSalarioMinimo(e.target.value) }}
                                                            slotProps={{
                                                                input: {
                                                                    inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                                },
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                                htmlInput: {
                                                                    maxLength: 20,
                                                                    min: 0
                                                                }
                                                            }}
                                                        />

                                                        {/* <VTextMaskCustom
                                                            fullWidth
                                                            name="salarioMinimo"
                                                            disabled={isLoading}
                                                            label="Salário Mínimo"
                                                            type="text"
                                                            typeMask="currency"
                                                            value={valorSalarioMinimo}
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                }
                                                            }}

                                                            onFocus={(e) => e.target.select()}
                                                            onChange={(e) => setValorSalarioMinimo(e.target.value)}
                                                        /> */}
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            name="salarioMaximo"
                                                            disabled={isLoading}
                                                            label="Salário Máximo"
                                                            defaultValue="0"
                                                            value={valorSalarioMaximo}
                                                            onFocus={(e) => e.target.select()}
                                                            onChange={(e) => setValorSalarioMaximo(e.target.value)}
                                                            slotProps={{
                                                                input: {
                                                                    inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                                },
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                                htmlInput: {
                                                                    maxLength: 20,
                                                                    min: 0
                                                                }
                                                            }}
                                                        />

                                                        {/* <VTextMaskCustom
                                                            fullWidth
                                                            name="salarioMaximo"
                                                            disabled={isLoading}
                                                            label="Salário Máximo"
                                                            type="text"
                                                            typeMask="currency"
                                                            value={valorSalarioMaximo}
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                }
                                                            }}

                                                            onFocus={(e) => e.target.select()}
                                                            onChange={(e) => setValorSalarioMaximo(e.target.value)}

                                                        /> */}
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            type="number"
                                                            name="porcentagemDesconto"
                                                            disabled={isLoading}
                                                            label="% Desconto"
                                                            defaultValue="0"
                                                            value={valorDesconto}
                                                            onFocus={(e) => e.target.select()}
                                                            onChange={(e) => setValorDesconto(e.target.value)}
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                                htmlInput: {
                                                                    maxLength: 6,
                                                                    min: 0
                                                                }
                                                            }}
                                                        />
                                                        {/* <VInputNumber
                                                            maxLength={6}
                                                            fullWidth
                                                            name="porcentagemDesconto"
                                                            type="text"
                                                            typeMask="currency"
                                                            disabled={isLoading}
                                                            label="% Desconto"
                                                            value={valorDesconto}
                                                            //onBlur={() => setValorDesconto(valorDesconto)}
                                                            onChange={(e) => setValorDesconto(e.target.value)}
                                                            onFocus={(e) => e.target.select()}


                                                        /> */}
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 3 }} display="flex" alignItems="center" justifyContent="flex-end" justifyItems="center" textAlign="end">
                                                        <Button
                                                            color="primary"
                                                            variant="contained"
                                                            disableElevation
                                                            onClick={criarIntervaloSalarios}
                                                            endIcon={<Icon>add</Icon>}
                                                        >
                                                            Adicionar
                                                        </Button>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }} >
                                                        <hr />
                                                        <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                            <Table>
                                                                <TableHead>
                                                                    <StyledTableRow>
                                                                        <StyledTableCell align="center" width={100}>Ações</StyledTableCell>
                                                                        <StyledTableCell>Mínimo</StyledTableCell>
                                                                        <StyledTableCell>Máximo</StyledTableCell>
                                                                        <StyledTableCell align="center" >Desconto</StyledTableCell>
                                                                    </StyledTableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {draftSimRows.map((row, index) => (
                                                                        <StyledTableRow key={index}>
                                                                            <StyledTableCell align="center" sx={{ padding: "2px" }}>
                                                                                <IconButton size="small" onClick={() => deleteIntervaloSalarios(index)}>
                                                                                    <Icon>delete</Icon>
                                                                                </IconButton>
                                                                            </StyledTableCell>
                                                                            <StyledTableCell>{moedaRealLocaleValue(row.minimo)}</StyledTableCell>
                                                                            <StyledTableCell>{moedaRealLocaleValue(row.maximo)}</StyledTableCell>
                                                                            <StyledTableCell align="center">{moedaRealLocaleValue(row.desconto)}</StyledTableCell>
                                                                        </StyledTableRow>
                                                                    ))
                                                                    }
                                                                </TableBody>
                                                                {draftSimTotalCount === 0 && !isLoading && (
                                                                    <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                                                )}
                                                                <TableFooter>
                                                                    {isLoading && (
                                                                        <StyledTableRow>
                                                                            <StyledTableCell colSpan={7}>
                                                                                <LinearProgress variant="indeterminate" />
                                                                            </StyledTableCell>
                                                                        </StyledTableRow>
                                                                    )}
                                                                    {(draftSimTotalCount > 0 && draftSimTotalCount > Enviroment.LIMITE_DE_LINHAS) && (
                                                                        <StyledTableRow>
                                                                            <StyledTableCell colSpan={7}>
                                                                                <Pagination
                                                                                    page={pagina}
                                                                                    count={Math.ceil(draftSimTotalCount / Enviroment.LIMITE_DE_LINHAS)}
                                                                                    onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                                                                                />
                                                                            </StyledTableCell>
                                                                        </StyledTableRow>
                                                                    )}
                                                                </TableFooter>
                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                </Grid>)
                                                : salarios_Reais_NBA === 2 ?
                                                    (
                                                        <Grid container spacing={2} display="flex" >
                                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" marginTop={2}>
                                                                <Typography variant="h6">Limite de Salários</Typography>
                                                                <hr />
                                                            </Grid>
                                                            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel id="demo-simple-select-label">Tempo de contrato</InputLabel>
                                                                    <Select
                                                                        size="small"
                                                                        disabled={isLoading}
                                                                        label="Tempo de contrato"
                                                                        name="tempoContrato"
                                                                        value={escolharTempoContrato}
                                                                        onChange={e => { setEscolharTempoContrato(Number(e.target.value)); }}
                                                                        defaultValue={1}
                                                                    >
                                                                        <MenuItem key="0" value="0">Selecione</MenuItem>
                                                                        {
                                                                            lstTempoContrato.map(qtd =>
                                                                                <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>)
                                                                        }
                                                                    </Select>
                                                                </FormControl>
                                                                {/* <SelectComponent
                                                                    isExternalLoading={isLoading}
                                                                    label="Tempo de contrato"
                                                                    name="tempoContrato"
                                                                    items={lstTempoContrato}
                                                                    value={escolharTempoContrato}
                                                                    onChange={(e) => setEscolharTempoContrato(Number(e.target.value))}
                                                                    defaultValue={1}
                                                                /> */}
                                                            </Grid>
                                                            <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                                <TextField
                                                                    size="small"
                                                                    fullWidth
                                                                    name="valorUtilizadoSalario"
                                                                    disabled={isLoading}
                                                                    label="CAP Utilizado"
                                                                    defaultValue="0"
                                                                    value={valorUtilizadoSalario}
                                                                    onFocus={(e) => e.target.select()}
                                                                    onChange={(e) => setValorUtilizadoSalario(e.target.value)}
                                                                    slotProps={{
                                                                        input: {
                                                                            inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                                        },
                                                                        inputLabel: {
                                                                            shrink: edicao ? true : undefined,
                                                                            style: {
                                                                                fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                            }
                                                                        },
                                                                        htmlInput: {
                                                                            maxLength: 20,
                                                                            min: 0
                                                                        }
                                                                    }}
                                                                />
                                                                {/* <VTextMaskCustom
                                                                    fullWidth
                                                                    name="valorUtilizadoSalario"
                                                                    disabled={isLoading}
                                                                    label="CAP Utilizado"
                                                                    type="text"
                                                                    typeMask="currency"
                                                                    value={valorUtilizadoSalario}
                                                                    slotProps={{
                                                                        inputLabel: {
                                                                            shrink: edicao ? true : undefined,
                                                                        }
                                                                    }}

                                                                    onChange={e => setValorUtilizadoSalario(e.target.value)}
                                                                    onFocus={(e) => e.target.select()}
                                                                /> */}
                                                            </Grid>
                                                            <Grid size={{ xs: 12, sm: 6, md: 3 }} display="flex" alignItems="center" justifyContent="flex-end" justifyItems="center" textAlign="end">
                                                                <Button
                                                                    color="primary"
                                                                    variant="contained"
                                                                    disableElevation
                                                                    onClick={handleCalculoDraftInicio}
                                                                    endIcon={<Icon>add</Icon>}>
                                                                    Gerar
                                                                </Button>
                                                            </Grid>
                                                            <Grid size={{ xs: 12, sm: 12 }}>
                                                                {!removeLoading && <Loading />}
                                                            </Grid>
                                                            <Grid size={{ xs: 12, sm: 12 }} >
                                                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" marginBottom={2}>
                                                                    <hr />
                                                                </Grid>

                                                                {isLoading && (
                                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                                        <LinearProgress variant="indeterminate" />
                                                                    </Grid>
                                                                )}
                                                                <Box sx={{
                                                                    height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                                    '& .super-app-theme--header': {
                                                                        backgroundColor: theme.palette.common.black,
                                                                        color: theme.palette.common.white,
                                                                    },
                                                                    '& .super-app.negative': {
                                                                        color: 'red',
                                                                        fontWeight: 'bold'
                                                                    },
                                                                    '& .super-app.positive': {
                                                                        color: themeName === "light" ? "black" : "auto",
                                                                    },
                                                                }}>
                                                                    <DataGrid
                                                                        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                        getRowId={(r) => r.codigo}
                                                                        rows={draftNaoRows}
                                                                        columns={columns}
                                                                        editMode="cell"
                                                                        columnVisibilityModel={columnVisibilityModel}
                                                                        initialState={{
                                                                            pagination: {
                                                                                paginationModel: {
                                                                                    pageSize: 64,
                                                                                    page: pagina,
                                                                                },
                                                                            },
                                                                        }}
                                                                        pageSizeOptions={[64]}
                                                                        processRowUpdate={handleProcessRowUpdate}
                                                                    //disableRowSelectionOnClick
                                                                    />
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    ) : null}
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={valueTabs} index={3}>
                                    {(!removeLoading || isLoading) && <Loading />}
                                    <Grid container direction="column" >
                                        <Grid container size={{ xs: 12, sm: 12 }} spacing={2} display="flex">
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                <Typography variant="h6">Draft Calouros</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 10 }} spacing={1}>
                                                <Grid size={{ xs: 12, sm: 6, md: 1 }} alignItems="center" display="flex">
                                                    <FormControl fullWidth>
                                                        <Typography variant="h6" textAlign="end">First</Typography>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">Tempo</InputLabel>
                                                        <Select
                                                            size="small"
                                                            disabled={isLoading}
                                                            label="Tempo"
                                                            name="tempoDraftCalouros"
                                                            value={escolharTempoContrato}
                                                            onChange={e => { setTempoDraftCalouros(Number(e.target.value)); }}
                                                            defaultValue={0}
                                                        >
                                                            <MenuItem key="0" value="0">Selecione</MenuItem>
                                                            {
                                                                lstTempoAnos.map(qtd =>
                                                                    <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>)
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                    {/* <SelectComponent
                                                        isExternalLoading={isLoading}
                                                        label="Tempo"
                                                        name="tempoDraftCalouros"
                                                        items={lstTempoAnos}
                                                        defaultValue=""
                                                        value={tempoDraftCalouros}
                                                        onChange={(e) => setTempoDraftCalouros(Number(e.target.value))}
                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <FormControl>
                                                        <FormControlLabel
                                                            control={<MuiCheckBox
                                                                required
                                                                name="chkRestritaDraftCalourosFirst"
                                                                checked={chkRestritaDraftCalourosFirst ? chkRestritaDraftCalourosFirst : false}
                                                                onChange={e => setChkRestritaDraftCalourosFirst(e.target.checked)}
                                                            />}
                                                            label="Restrito"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <TextField
                                                        size="small"
                                                        fullWidth
                                                        name="primeiroSalarioFirst"
                                                        disabled={isLoading}
                                                        label="Primeiro Salário"
                                                        defaultValue="0"
                                                        value={primeiroSalarioFirst}
                                                        onFocus={(e) => e.target.select()}
                                                        onChange={(e) => setPrimeiroSalarioFirst(e.target.value)}
                                                        slotProps={{
                                                            input: {
                                                                inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                            },
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                            htmlInput: {
                                                                maxLength: 20,
                                                                min: 0
                                                            }
                                                        }}
                                                    />
                                                    {/* <VTextMaskCustom
                                                        fullWidth
                                                        name="primeiroSalarioFirst"
                                                        disabled={isLoading}
                                                        label="Primeiro Salário"
                                                        type="text"
                                                        typeMask="currency"
                                                        value={primeiroSalarioFirst}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            }
                                                        }}

                                                        onChange={e => setPrimeiroSalarioFirst(e.target.value)}
                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <TextField
                                                        size="small"
                                                        fullWidth
                                                        name="intervDriftCalouroFirst"
                                                        disabled={isLoading}
                                                        label="Intervalo Salário"
                                                        value={intervDriftCalouroFirst}
                                                        onFocus={(e) => e.target.select()}
                                                        onChange={(e) => setIntervDriftCalouroFirst(e.target.value)}
                                                        slotProps={{
                                                            input: {
                                                                inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                            },
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                            htmlInput: {
                                                                maxLength: 20,
                                                                min: 0
                                                            }
                                                        }}
                                                    />
                                                    {/* <VTextMaskCustom
                                                        fullWidth
                                                        name="intervDriftCalouroFirst"
                                                        disabled={isLoading}
                                                        label="Intervalo Salário"
                                                        type="text"
                                                        typeMask="currency"
                                                        value={intervDriftCalouroFirst}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            }
                                                        }}

                                                        onChange={e => setIntervDriftCalouroFirst(e.target.value)}
                                                    /> */}

                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 10 }} spacing={1}>
                                                <Grid size={{ xs: 12, sm: 6, md: 1 }} alignItems="center" display="flex">
                                                    <FormControl fullWidth>
                                                        <Typography variant="h6" textAlign="end">Second</Typography>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">Tempo</InputLabel>
                                                        <Select
                                                            size="small"
                                                            disabled={isLoading}
                                                            label="Tempo"
                                                            name="tempoDraftCalouroSecond"
                                                            value={tempoDraftCalouroSecond}
                                                            onChange={e => { setTempoDraftCalouroSecond(Number(e.target.value)); }}
                                                            defaultValue={0}
                                                        >
                                                            <MenuItem key="0" value="0">Selecione</MenuItem>
                                                            {
                                                                lstTempoAnos.map(qtd =>
                                                                    <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>)
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                    {/* <SelectComponent
                                                        isExternalLoading={isLoading}
                                                        label="Tempo"
                                                        name="tempoDraftCalouroSecond"
                                                        items={lstTempoAnos}
                                                        value={tempoDraftCalouroSecond}
                                                        defaultValue=""
                                                        onChange={(e) => setTempoDraftCalouroSecond(Number(e.target.value))}
                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <FormControl>
                                                        <FormControlLabel
                                                            control={<MuiCheckBox
                                                                required
                                                                name="chkRestritaDraftCalourosSecond"
                                                                checked={chkRestritaDraftCalourosSecond ? chkRestritaDraftCalourosSecond : false}
                                                                onChange={e => setChkRestritaDraftCalourosSecond(e.target.checked)}
                                                            />}
                                                            label="Restrito"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <TextField
                                                        size="small"
                                                        fullWidth
                                                        name="primeiroSalarioSecond"
                                                        disabled={isLoading}
                                                        label="Intervalo Salário"
                                                        value={primeiroSalarioSecond}
                                                        onFocus={(e) => e.target.select()}
                                                        onChange={(e) => setPrimeiroSalarioSecond(e.target.value)}
                                                        slotProps={{
                                                            input: {
                                                                inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                            },
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                            htmlInput: {
                                                                maxLength: 20,
                                                                min: 0
                                                            }
                                                        }}
                                                    />
                                                    {/* <VTextMaskCustom
                                                        fullWidth
                                                        name="primeiroSalarioSecond"
                                                        disabled={isLoading}
                                                        label="Primeiro Salário"
                                                        type="text"
                                                        typeMask="currency"
                                                        value={primeiroSalarioSecond}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            }
                                                        }}

                                                        onChange={e => setPrimeiroSalarioSecond(e.target.value)}
                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <TextField
                                                        size="small"
                                                        fullWidth
                                                        name="intervDriftCalouroSecond"
                                                        disabled={isLoading}
                                                        label="Intervalo Salário"
                                                        value={intervDriftCalouroSecond}
                                                        onFocus={(e) => e.target.select()}
                                                        onChange={(e) => setPrimeiroSalarioSecond(e.target.value)}
                                                        slotProps={{
                                                            input: {
                                                                inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                            },
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                            htmlInput: {
                                                                maxLength: 20,
                                                                min: 0
                                                            }
                                                        }}
                                                    />
                                                    {/* <VTextMaskCustom
                                                        fullWidth
                                                        name="intervDriftCalouroSecond"
                                                        disabled={isLoading}
                                                        label="Intervalo Salário"
                                                        type="text"
                                                        typeMask="currency"
                                                        value={intervDriftCalouroSecond}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            }
                                                        }}

                                                        onChange={e => setIntervDriftCalouroSecond(e.target.value)}
                                                    /> */}
                                                </Grid>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 2 }} spacing={1}
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="center"
                                                justifyItems="center"
                                            >
                                                <Button
                                                    color="primary"
                                                    variant="contained"
                                                    disableElevation
                                                    onClick={handleCalculoDraftCalouros}
                                                    endIcon={<Icon>add</Icon>}
                                                >
                                                    Gerar
                                                </Button>
                                            </Grid>

                                            <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                {(!removeLoading || isLoading) && <Loading />}
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} marginTop={2} >
                                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                        <Table>
                                                            <TableHead>
                                                                <StyledTableRow>
                                                                    {/* <StyledTableCell width={100}>Ações</StyledTableCell> */}
                                                                    {/* {edicao && <StyledTableCell >Código</StyledTableCell>} */}
                                                                    <StyledTableCell align="center">Escolha</StyledTableCell>
                                                                    <StyledTableCell align="center">Restrito</StyledTableCell>
                                                                    <StyledTableCell align="center">Ano 1</StyledTableCell>
                                                                    <StyledTableCell align="center">Ano 2</StyledTableCell>
                                                                    <StyledTableCell align="center">Ano 3</StyledTableCell>
                                                                    <StyledTableCell align="center">Ano 4</StyledTableCell>
                                                                    <StyledTableCell align="center">Ano 5</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {draftCalourosRows.map((row, index) => (
                                                                    <StyledTableRow key={index}>
                                                                        {/* <StyledTableCell>
                                                                        <IconButton size="small" onClick={() => deleteEscolhasDraftCalouros(index)}>
                                                                            <Icon>delete</Icon>
                                                                        </IconButton>
                                                                        <IconButton size="small" onClick={handleEnabledInputs}>
                                                                            <Icon>edit</Icon>
                                                                        </IconButton>
                                                                    </StyledTableCell> */}
                                                                        {/* {edicao && <StyledTableCell>{row.codigo}</StyledTableCell>} */}
                                                                        <StyledTableCell align="center">{row.pick}</StyledTableCell>
                                                                        <StyledTableCell align="center">{row.restrito ? "Sim" : "Não"}</StyledTableCell>
                                                                        <StyledTableCell align="center">{row.ano1 === 0 ? "" : moedaRealLocaleValue(row.ano1.toString())}</StyledTableCell>
                                                                        <StyledTableCell align="center">{row.ano2 === 0 || row.ano2 === null ? "" : moedaRealLocaleValue(row.ano2.toString())}</StyledTableCell>
                                                                        <StyledTableCell align="center">{row.ano3 === 0 || row.ano3 === null ? "" : moedaRealLocaleValue(row.ano3.toString())}</StyledTableCell>
                                                                        <StyledTableCell align="center">{row.ano4 === 0 || row.ano4 === null ? "" : moedaRealLocaleValue(row.ano4.toString())}</StyledTableCell>
                                                                        <StyledTableCell align="center">{row.ano5 === 0 || row.ano5 === null ? "" : moedaRealLocaleValue(row.ano5.toString())}</StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))
                                                                }
                                                            </TableBody>
                                                            {totalCountDraftCalouros === 0 && !isLoading && (
                                                                <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                                            )}
                                                            <TableFooter>
                                                                {isLoading && (
                                                                    <StyledTableRow>
                                                                        <StyledTableCell colSpan={7}>
                                                                            <LinearProgress variant="indeterminate" />
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>
                                                                )}
                                                                {/* {(totalCountDraftCalouros > 0 && totalCountDraftCalouros > Enviroment.LIMITE_DE_LINHAS) && (
                                                                <StyledTableRow>
                                                                    <StyledTableCell colSpan={7}>
                                                                        <Pagination
                                                                            page={pagina}
                                                                            count={Math.ceil(totalCountDraftCalouros / Enviroment.LIMITE_DE_LINHAS)}
                                                                            onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                                                                        />
                                                                    </StyledTableCell>
                                                                </StyledTableRow>
                                                            )} */}
                                                            </TableFooter>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={valueTabs} index={4}>
                                    {(!removeLoading || isLoading) && <Loading />}
                                    <Grid container size={12} >
                                        <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                            <Typography variant="h6">Outras Configurações</Typography>
                                            <hr />
                                        </Grid>
                                    </Grid>
                                    <Grid container margin={1} display="flex" justifyItems="center" alignItems="end">
                                        <Grid container size={{ xs: 12, sm: 4, md: 4 }} spacing={1} display="flex" >
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="center" >
                                                <Typography variant="h6">Picks Firsts</Typography>
                                                <hr style={{ width: "98%" }} />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 6 }} >
                                                <Controller name="configuracao_Liga.min_First_Tempo" control={control}
                                                    rules={{ required: true }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            size="small"
                                                            required
                                                            fullWidth
                                                            name="min_First_Tempo"
                                                            disabled={isLoading}
                                                            label="Qtde. Temporada Sem"
                                                            slotProps={{

                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                                htmlInput: {
                                                                    maxLength: 2,
                                                                    min: 0
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                />

                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                <FormControl>
                                                    <FormControlLabel
                                                        control={<MuiCheckBox
                                                            required
                                                            name="configuracao_Liga.first_Propria"
                                                            checked={first_Propria}
                                                            onChange={e => {
                                                                setChkFirstPropria(e.target.checked);
                                                            }}
                                                        />}
                                                        label="Própria?"
                                                        labelPlacement="start"
                                                    />
                                                </FormControl>
                                                {/* <CheckBox
                                                    name="configuracao_Liga.first_Propria"
                                                    isExternalLoading={isLoading}
                                                    checked={first_Propria ? first_Propria : false}
                                                    onChange={e => setChkFirstPropria(e.target.checked)}
                                                    label="Própria?"
                                                    labelPlacement="start"
                                                /> */}
                                            </Grid>
                                        </Grid>
                                        {/* <Scope path="free_Agency"> */}
                                        <Grid container size={{ xs: 12, sm: 8, md: 8 }} spacing={1} display="flex" justifyContent="center" alignContent="center">
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="center" >
                                                <Typography variant="h6">Free Agency</Typography>
                                                <hr style={{ width: "98%" }} />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                <Controller name="free_Agency.intervalo_Lance_Minimo" control={control}
                                                    rules={{ required: true }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            size="small"
                                                            required
                                                            fullWidth
                                                            name="intervalo_Lance_Minimo"
                                                            disabled={isLoading}
                                                            label="Intervalo Lances Mínimo"
                                                            slotProps={{

                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                                htmlInput: {
                                                                    maxLength: 20,
                                                                    min: 0
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                />

                                                {/* <VTextMaskCustom
                                                        fullWidth
                                                        name="intervalo_Lance_Minimo"
                                                        type="text"
                                                        disabled={isLoading}
                                                        label="Intervalo Lances Mínimo"
                                                        typeMask="currency"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            }
                                                        }}

                                                        onFocus={(e) => e.target.select()}
                                                    /> */}
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                <Controller name="free_Agency.tempo_Duracao" control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            size="small"
                                                            fullWidth
                                                            name="tempo_Duracao"
                                                            disabled={isLoading}
                                                            label="Tempo Final Lance"
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                                htmlInput: {
                                                                    maxLength: 2,
                                                                    min: 0
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {/* <VInputNumber
                                                        fullWidth
                                                        name="tempo_Duracao"
                                                        type="number"
                                                        disabled={isLoading}
                                                        label="Tempo Final Lance"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            }
                                                        }}

                                                        maxLength={2}
                                                        onFocus={(e) => e.target.select()}
                                                    /> */}
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                <Controller name="free_Agency.tempo_Restrito" control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            size="small"
                                                            fullWidth
                                                            name="tempo_Restrito"
                                                            disabled={isLoading}
                                                            label="Tempo Restrito Aprovação"
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                                htmlInput: {
                                                                    maxLength: 2,
                                                                    min: 0
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {/* <VInputNumber
                                                        fullWidth
                                                        name="tempo_Restrito"
                                                        type="number"
                                                        disabled={isLoading}
                                                        label="Tempo Restrito Aprovação"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            }
                                                        }}

                                                        maxLength={2}
                                                        onFocus={(e) => e.target.select()}
                                                    /> */}
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                <Controller name="free_Agency.porcentagem_Aumento" control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            size="small"
                                                            fullWidth
                                                            name="porcentagem_Aumento"
                                                            disabled={isLoading}
                                                            label="Porcentagem (%)"
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                                htmlInput: {
                                                                    maxLength: 3,
                                                                    min: 0
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {/* <VTextMaskCustom
                                                        fullWidth
                                                        name="porcentagem_Aumento"
                                                        type="text"
                                                        disabled={isLoading}
                                                        label="Porcentagem %"
                                                        typeMask="currency"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            }
                                                        }}

                                                        onFocus={(e) => e.target.select()}
                                                    /> */}
                                            </Grid>
                                        </Grid>
                                        {/* </Scope> */}
                                    </Grid>
                                    <Grid container size={12}>
                                        <Grid container size={12} marginTop={2}>
                                            <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" >
                                                <Grid size={{ xs: 12, sm: 12 }} padding={1} textAlign="initial" >
                                                    <Typography variant="h6">Duração Salários</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <TextField
                                                        size="small"
                                                        fullWidth
                                                        name="min_Valor"
                                                        disabled={isLoading}
                                                        label="Minimo Valor"
                                                        value={`R$ ${min_Valor}`}
                                                        onFocus={(e) => e.target.select()}
                                                        onChange={(e) => setMin_Valor(e.target.value)}
                                                        slotProps={{
                                                            input: {
                                                                inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                            },
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                            htmlInput: {
                                                                maxLength: 20,
                                                                min: 0
                                                            }
                                                        }}
                                                    />

                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <TextField
                                                        size="small"
                                                        fullWidth
                                                        name="max_Valor"
                                                        disabled={isLoading}
                                                        label="Máximo Valor"
                                                        value={`R$ ${max_Valor}`}
                                                        onFocus={(e) => e.target.select()}
                                                        onChange={(e) => setMax_Valor(e.target.value)}
                                                        slotProps={{
                                                            input: {
                                                                inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                            },
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                            htmlInput: {
                                                                maxLength: 20,
                                                                min: 0
                                                            }
                                                        }}
                                                    />
                                                    {/* <VTextMaskCustom
                                                        fullWidth
                                                        name="max_Valor"
                                                        type="text"
                                                        disabled={isLoading}
                                                        label="Máximo Valor"
                                                        value={`R$ ${max_Valor}`}
                                                        onChange={e => setMax_Valor(e.target.value)}
                                                        typeMask="currency"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            }
                                                        }}

                                                        onFocus={(e) => e.target.select()}
                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">Tempo</InputLabel>
                                                        <Select
                                                            size="small"
                                                            disabled={isLoading}
                                                            label="Mínimo Duração"
                                                            name="min_Duracao"
                                                            value={min_Duracao}
                                                            onChange={e => { setMin_Duracao(Number(e.target.value)); }}
                                                            defaultValue={0}
                                                        >
                                                            <MenuItem key="0" value="0">Selecione</MenuItem>
                                                            {
                                                                lstAnos.map(qtd =>
                                                                    <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>)
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                    {/* <SelectComponent
                                                        isExternalLoading={isLoading}
                                                        label="Mínimo Duração"
                                                        name="min_Duracao"
                                                        items={lstAnos}
                                                        disabled={isLoading}
                                                        defaultValue=""
                                                        onChange={e => setMin_Duracao(Number(e.target.value))}
                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">Tempo</InputLabel>
                                                        <Select
                                                            size="small"
                                                            disabled={isLoading}
                                                            label="Máximo Duração"
                                                            name="max_Duracao"
                                                            value={max_Duracao}
                                                            onChange={e => { setMax_Duracao(Number(e.target.value)); }}
                                                            defaultValue={0}
                                                        >
                                                            <MenuItem key="0" value="0">Selecione</MenuItem>
                                                            {
                                                                lstAnos.map(qtd =>
                                                                    <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>)
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <FormControl>
                                                        <FormControlLabel
                                                            control={<MuiCheckBox
                                                                required
                                                                name="permite_Ano_Adicional"
                                                                checked={chkPermite_Ano_Adicional}
                                                                onChange={e => {
                                                                    setChkPermite_Ano_Adicional(e.target.checked);
                                                                }}
                                                            />}
                                                            label="Ano Adicional"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                    {/* <CheckBox
                                                        name="permite_Ano_Adicional"
                                                        isExternalLoading={isLoading}
                                                        checked={chkPermite_Ano_Adicional}
                                                        onChange={e => setChkPermite_Ano_Adicional(e.target.checked)}
                                                        label="Ano Adicional"
                                                        labelPlacement="start"
                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} display="flex" alignItems="center" justifyContent="flex-end" justifyItems="center" textAlign="end">
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={criarDuracao}
                                                        startIcon={<Icon>add</Icon>}
                                                    >
                                                        Adicionar
                                                    </Button>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                        <Table>
                                                            <TableHead>
                                                                <StyledTableRow>
                                                                    <StyledTableCell align="center" width={100}>Ações</StyledTableCell>
                                                                    {/* {edicao && <StyledTableCell>Código</StyledTableCell>} */}
                                                                    <StyledTableCell>Min Valor</StyledTableCell>
                                                                    <StyledTableCell>Max Valor</StyledTableCell>
                                                                    <StyledTableCell align="center">Min Duração</StyledTableCell>
                                                                    <StyledTableCell align="center">Max Duração</StyledTableCell>
                                                                    <StyledTableCell align="center">ANO ADICIONAL</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {duracaoRows.map((row, index) => (
                                                                    <StyledTableRow key={index}>
                                                                        <StyledTableCell align="center" sx={{ padding: "2px" }}>
                                                                            <IconButton size="small" onClick={() => deleteDuracao(index)}>
                                                                                <Icon>delete</Icon>
                                                                            </IconButton>
                                                                        </StyledTableCell>
                                                                        {/* {edicao && <StyledTableCell>{row.codigo}</StyledTableCell>} */}
                                                                        <StyledTableCell>{moedaRealLocaleValue(row.valor_Minimo.toString())}</StyledTableCell>
                                                                        <StyledTableCell>{moedaRealLocaleValue(row.valor_Maximo.toString())}</StyledTableCell>
                                                                        <StyledTableCell align="center">{row.tempo_Minimo}</StyledTableCell>
                                                                        <StyledTableCell align="center">{row.tempo_Maximo}</StyledTableCell>
                                                                        <StyledTableCell align="center">{row.permite_Ano_Adicional ? "SIM" : "NÃO"}</StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))
                                                                }
                                                            </TableBody>
                                                            {totalCountRowsDuracao === 0 && !isLoading && (
                                                                <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                                            )}
                                                            <TableFooter>
                                                                {isLoading && (
                                                                    <StyledTableRow>
                                                                        <StyledTableCell colSpan={7}>
                                                                            <LinearProgress variant="indeterminate" />
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>
                                                                )}
                                                                {(totalCountRowsDuracao > 0 && totalCountRowsDuracao > Enviroment.LIMITE_DE_LINHAS) && (
                                                                    <StyledTableRow>
                                                                        <StyledTableCell colSpan={7}>
                                                                            <Pagination
                                                                                page={pagina}
                                                                                count={Math.ceil(totalCountRowsDuracao / Enviroment.LIMITE_DE_LINHAS)}
                                                                                onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                                                                            />
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>
                                                                )}
                                                            </TableFooter>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    {/* <Scope path="configuracao_Contusao"> */}
                                    <Grid container size={12} margin={1} spacing={1} display="flex" justifyItems="center" alignItems="end">
                                        <Grid size={{ xs: 12, sm: 12 }} textAlign="start" >
                                            <Typography variant="h6">Configuração Contusão</Typography>
                                            <hr />
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <FormControl>
                                                <FormControlLabel
                                                    control={<MuiCheckBox
                                                        required
                                                        name="temporada"
                                                        checked={temporada}
                                                        onChange={e => {
                                                            setTemporada(e.target.checked);
                                                        }}
                                                    />}
                                                    label="Ofs - Fora da Temporada"
                                                    labelPlacement="start"
                                                />
                                            </FormControl>
                                            {/* <CheckBox
                                                    name="temporada"
                                                    isExternalLoading={isLoading}
                                                    checked={temporada ? temporada : false}
                                                    onChange={e => setTemporada(e.target.checked)}
                                                    label="Ofs - Fora da Temporada"
                                                    labelPlacement="start"
                                                /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                            <Controller name="configuracao_Contusao.porcentagem" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="porcentagem"
                                                        disabled={isLoading}
                                                        label="Abatimento Salário %"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                            htmlInput: {
                                                                maxLength: 6,
                                                                min: 0
                                                            }
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                    maxLength={6}
                                                    typeMask="currency"
                                                    fullWidth
                                                    name="porcentagem"
                                                    type="text"
                                                    disabled={isLoading}
                                                    label="Abatimento Salário %"

                                                /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                            <FormControl>
                                                <FormControlLabel
                                                    control={<MuiCheckBox
                                                        required
                                                        name="libera_Slote"
                                                        checked={libera_Slote}
                                                        onChange={e => {
                                                            setLiberaSlot(e.target.checked);
                                                        }}
                                                    />}
                                                    label="Libera Slot"
                                                    labelPlacement="start"
                                                />
                                            </FormControl>
                                            {/* <CheckBox
                                                    name="libera_Slote"
                                                    isExternalLoading={isLoading}
                                                    checked={libera_Slote ? libera_Slote : false}
                                                    onChange={e => setLiberaSlot(e.target.checked)}
                                                    label="Libera Slot"
                                                    labelPlacement="start"
                                                /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                            <FormControl>
                                                <FormControlLabel
                                                    control={<MuiCheckBox
                                                        required
                                                        name="automatico"
                                                        checked={automatico}
                                                        onChange={e => {
                                                            setAutomatico(e.target.checked);
                                                        }}
                                                    />}
                                                    label="OUT - Fora"
                                                    labelPlacement="start"
                                                />
                                            </FormControl>
                                            {/* <CheckBox
                                                    name="automatico"
                                                    isExternalLoading={isLoading}
                                                    checked={automatico}
                                                    onChange={e => setAutomatico(e.target.checked)}
                                                    label="OUT - Fora"
                                                    labelPlacement="start"
                                                /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <FormControl>
                                                <FormControlLabel
                                                    control={<MuiCheckBox
                                                        required
                                                        name="autoriza_Contratacao"
                                                        checked={autoriza_Contratacao}
                                                        onChange={e => {
                                                            setAutoriza_Contratacao(e.target.checked);
                                                        }}
                                                    />}
                                                    label="Contratação Temporária"
                                                    labelPlacement="start"
                                                />
                                            </FormControl>
                                            {/* <CheckBox
                                                    name="autoriza_Contratacao"
                                                    isExternalLoading={isLoading}
                                                    checked={autoriza_Contratacao ? autoriza_Contratacao : false}
                                                    onChange={e => setAutoriza_Contratacao(e.target.checked)}
                                                    label="Contratação Temporária"
                                                    labelPlacement="start"
                                                /> */}
                                        </Grid>
                                    </Grid>
                                    {/* </Scope> */}
                                    <Grid container size={12} margin={1} display="flex" justifyItems="center" alignItems="end">
                                        <Grid container size={12} spacing={1} display="flex" >
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="start" >
                                                <Typography variant="h6">Bloqueio De Calouros</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 4 }} >
                                                <FormControl>
                                                    <FormControlLabel
                                                        control={<MuiCheckBox
                                                            required
                                                            name="configuracao_Liga.bloquear_Calouro_Primeira_Rodada"
                                                            checked={chkBloquearCalouroPrimeiraRodada}
                                                            onChange={e => {
                                                                setChkBloquearCalouroPrimeiraRodada(e.target.checked);
                                                            }}
                                                        />}
                                                        label="Primeira Rodada"
                                                        labelPlacement="start"
                                                    />
                                                </FormControl>
                                                {/* <CheckBox
                                                    name="configuracao_Liga.bloquear_Calouro_Primeira_Rodada"
                                                    isExternalLoading={isLoading}
                                                    checked={chkBloquearCalouroPrimeiraRodada}
                                                    onChange={e => setChkBloquearCalouroPrimeiraRodada(e.target.checked)}
                                                    label="Primeira Rodada"
                                                    labelPlacement="start"
                                                /> */}
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 4 }} >
                                                <FormControl>
                                                    <FormControlLabel
                                                        control={<MuiCheckBox
                                                            required
                                                            name="configuracao_Liga.bloquear_Calouro_Segunda_Rodada"
                                                            checked={chkBloquearCalouroSegundaRodada}
                                                            onChange={e => {
                                                                setChkBloquearCalouroSegundaRodada(e.target.checked);
                                                            }}
                                                        />}
                                                        label="Segunda Rodada"
                                                        labelPlacement="start"
                                                    />
                                                </FormControl>
                                                {/* <CheckBox
                                                    name="configuracao_Liga.bloquear_Calouro_Segunda_Rodada"
                                                    isExternalLoading={isLoading}
                                                    checked={chkBloquearCalouroSegundaRodada}
                                                    onChange={e => setChkBloquearCalouroSegundaRodada(e.target.checked)}
                                                    label="Segunda Rodada"
                                                    labelPlacement="start"
                                                /> */}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={valueTabs} index={5}>
                                    {(!removeLoading || isLoading) && <Loading />}
                                    <Grid container size={12} direction="column" >
                                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" justifyContent="center" alignContent="center">
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                <Typography variant="h6">Configuração de Multas</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2} >
                                                <Grid size={{ xs: 12, sm: 8, md: 8 }}>
                                                    <FormControl>
                                                        <FormLabel>Envio de Multas</FormLabel>
                                                        <MuiRadioGroup
                                                            row
                                                            name="separar_Multa_Temporada"
                                                            //onBlur={onBlur}
                                                            value={separarMultaTemporada}
                                                            onChange={(e) => { setSepararMultaTemporada(Number(e.target.value)); }}
                                                        >
                                                            {
                                                                configuracaoMultas.map(item => (<FormControlLabel key={item.codigo} value={item.codigo} control={<Radio />} label={item.label} />))
                                                            }
                                                        </MuiRadioGroup>
                                                    </FormControl >
                                                    {/* <RadioGroup
                                                        isExternalLoading={isLoading}
                                                        items={configuracaoMultas}
                                                        name="separar_Multa_Temporada"
                                                        label="Envio de Multas"
                                                        value={separarMultaTemporada}
                                                        onChange={(e) => setSepararMultaTemporada(Number(e.target.value))}
                                                    /> */}
                                                </Grid>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                <Typography variant="h6">Bloqueio</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} margin={1} spacing={1} display="flex" justifyItems="center" >
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                                    <FormControl>
                                                        <FormControlLabel
                                                            control={<MuiCheckBox
                                                                name="bloqueio_Maximo_Multa"
                                                                checked={bloqueio_Maximo_Multa}
                                                                onChange={e => setBloqueio_Maximo_Multa(e.target.checked)}
                                                            />}
                                                            label="Bloqueio Máximo"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} display={bloqueio_Maximo_Multa ? "block" : "none"}>
                                                    <Controller name="porcentagem_Bloqueio_Maximo_Multa" control={control}
                                                        render={({ field }) => (
                                                            <TextField
                                                                {...field}
                                                                size="small"
                                                                fullWidth
                                                                name="porcentagem_Bloqueio_Maximo_Multa"
                                                                disabled={isLoading}
                                                                label="Limite de Multas (% CAP Franquia)"
                                                                value={porcentagem_Bloqueio_Maximo_Multa}
                                                                onChange={e => setPorcentagem_Bloqueio_Maximo_Multa(e.target.value)}
                                                                slotProps={{
                                                                    inputLabel: {
                                                                        shrink: edicao ? true : undefined,
                                                                        style: {
                                                                            fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                        }
                                                                    },
                                                                    htmlInput: {
                                                                        maxLength: 3,
                                                                        min: 0
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                    {/* <VTextMaskCustom
                                                        maxLength={3}
                                                        typeMask="currency"
                                                        fullWidth
                                                        name="porcentagem_Bloqueio_Maximo_Multa"
                                                        type="text"
                                                        disabled={isLoading}
                                                        label="% Bloqueio Máximo"
                                                        value={porcentagem_Bloqueio_Maximo_Multa}
                                                        onChange={e => setPorcentagem_Bloqueio_Maximo_Multa(e.target.value)}
                                                    /> */}
                                                </Grid>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                <Typography variant="h6">Salários</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} margin={1} spacing={1} display="flex" justifyItems="center" >
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <TextField
                                                        size="small"
                                                        fullWidth
                                                        name="valorMinimoMulta"
                                                        disabled={isLoading}
                                                        label="Valor Mínimo"
                                                        value={`R$ ${valorMinimoMulta}`}
                                                        onFocus={(e) => e.target.select()}
                                                        onChange={(e) => setValorMinimoMulta(e.target.value)}
                                                        slotProps={{
                                                            input: {
                                                                inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                            },
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                            htmlInput: {
                                                                maxLength: 20,
                                                                min: 0
                                                            }
                                                        }}
                                                    />
                                                    {/* <VTextMaskCustom
                                                        fullWidth
                                                        name="valorMinimoMulta"
                                                        type="text"
                                                        disabled={isLoading}
                                                        label="Valor Mínimo"
                                                        //prefix="R$"
                                                        value={`R$ ${valorMinimoMulta}`}
                                                        onChange={e => setValorMinimoMulta(e.target.value)}
                                                        typeMask="currency"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            }
                                                        }}

                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <TextField
                                                        size="small"
                                                        fullWidth
                                                        name="valorMaximomulta"
                                                        disabled={isLoading}
                                                        label="Valor Máximo"
                                                        value={`R$ ${valorMaximoMulta}`}
                                                        onFocus={(e) => e.target.select()}
                                                        onChange={(e) => setValorMaximoMulta(e.target.value)}
                                                        slotProps={{
                                                            input: {
                                                                inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                            },
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                            htmlInput: {
                                                                maxLength: 20,
                                                                min: 0
                                                            }
                                                        }}
                                                    />
                                                    {/* <VTextMaskCustom
                                                        fullWidth
                                                        name="valorMaximomulta"
                                                        type="text"
                                                        disabled={isLoading}
                                                        label="Valor Máximo"
                                                        // value={`R$ ${valorMaximoMulta}`}
                                                        onChange={e => setValorMaximoMulta(e.target.value)}
                                                        typeMask="currency"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            }
                                                        }}

                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <TextField
                                                        size="small"
                                                        fullWidth
                                                        name="porcentagemMulta"
                                                        disabled={isLoading}
                                                        label="% Salário"
                                                        value={porcentagemMulta}
                                                        onFocus={(e) => e.target.select()}
                                                        onChange={(e) => setPorcentagemMulta(e.target.value)}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                            htmlInput: {
                                                                maxLength: 6,
                                                                min: 0
                                                            }
                                                        }}
                                                    />
                                                    {/* <VTextMaskCustom
                                                        maxLength={6}
                                                        typeMask="currency"
                                                        fullWidth
                                                        name="porcentagem"
                                                        type="text"
                                                        disabled={isLoading}
                                                        label="% Salário"
                                                        value={porcentagemMulta}
                                                        onChange={e => setPorcentagemMulta(e.target.value)}
                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 6 }}
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    justifyItems="center">
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={criaMulta}
                                                        endIcon={<Icon>add</Icon>}
                                                    >
                                                        Adicionar
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} marginTop={2} >
                                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                        <Table>
                                                            <TableHead>
                                                                <StyledTableRow>
                                                                    <StyledTableCell align="center" width={100}>Ações</StyledTableCell>
                                                                    <StyledTableCell>Mínimo</StyledTableCell>
                                                                    <StyledTableCell>Máximo</StyledTableCell>
                                                                    <StyledTableCell align="center">%</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {multaRows.map((row, index) => (
                                                                    <StyledTableRow key={index}>
                                                                        <StyledTableCell align="center" sx={{ padding: "2px" }}>
                                                                            <IconButton size="small" onClick={() => deleteMulta(index)}>
                                                                                <Icon>delete</Icon>
                                                                            </IconButton>
                                                                        </StyledTableCell>
                                                                        <StyledTableCell>{moedaRealLocaleValue(row.valor_Minimo.toString())}</StyledTableCell>
                                                                        <StyledTableCell>{moedaRealLocaleValue(row.valor_Maximo.toString())}</StyledTableCell>
                                                                        <StyledTableCell align="center">{moedaRealLocaleValue(row.porcentagem)}</StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))
                                                                }
                                                            </TableBody>
                                                            {totalCountMultas === 0 && !isLoading && (
                                                                <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                                            )}
                                                            <TableFooter>
                                                                {isLoading && (
                                                                    <StyledTableRow>
                                                                        <StyledTableCell colSpan={7}>
                                                                            <LinearProgress variant="indeterminate" />
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>
                                                                )}
                                                                {(totalCountMultas > 0 && totalCountMultas > Enviroment.LIMITE_DE_LINHAS) && (
                                                                    <StyledTableRow>
                                                                        <StyledTableCell colSpan={7}>
                                                                            <Pagination
                                                                                page={pagina}
                                                                                count={Math.ceil(totalCountMultas / Enviroment.LIMITE_DE_LINHAS)}
                                                                                onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                                                                            />
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>
                                                                )}
                                                            </TableFooter>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={valueTabs} index={6}>
                                    {(!removeLoading || isLoading) && <Loading />}
                                    <Grid container size={12} spacing={1} direction="column" >
                                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" justifyContent="center" alignContent="center">
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                <Typography variant="h6">Posições Confronto</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2} >
                                                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
                                                        <Select
                                                            size="small"
                                                            disabled={isLoading}
                                                            label="Tipo"
                                                            name="configuracao_Liga.codigo_Tipo_Posicao_Confronto"
                                                            value={tipoPosicaoConfronto}
                                                            onChange={e => { handlePosicaoConfronto(e) }}
                                                            defaultValue={0}
                                                        >
                                                            <MenuItem key="0" value="0">Selecione</MenuItem>
                                                            {
                                                                lstTiposPosicaoConfronto.map(qtd =>
                                                                    <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>)
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                    {/* <SelectComponent
                                                        isExternalLoading={isLoading}
                                                        label="Tipo"
                                                        name="configuracao_Liga.codigo_Tipo_Posicao_Confronto"
                                                        items={lstTiposPosicaoConfronto}
                                                        onChange={(e) => handlePosicaoConfronto(e)}
                                                        value={tipoPosicaoConfronto}
                                                        defaultValue={0}
                                                    /> */}
                                                </Grid>
                                            </Grid>
                                            {isCriarPosicoes && (
                                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                    <Typography variant="h6">Posições</Typography>
                                                    <hr />
                                                </Grid>
                                            )}
                                            {isCriarPosicoes && (
                                                <Grid container margin={1} spacing={1} display="flex" justifyItems="center" >
                                                    <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            name="posicao"
                                                            disabled={isLoading}
                                                            label="Máximo Valor"
                                                            value={posicao}
                                                            onFocus={(e) => e.target.select()}
                                                            onChange={(e) => setPosicao(e.target.value)}
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                                htmlInput: {
                                                                    maxLength: 3,
                                                                    min: 0
                                                                }
                                                            }}
                                                        />
                                                        {/* <VTextField
                                                            fullWidth
                                                            name="posicao"
                                                            type="text"
                                                            disabled={isLoading}
                                                            label="Posição"
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                }
                                                            }}

                                                            maxLength={3}
                                                            onChange={(e) => setPosicao(e.target.value)}
                                                        /> */}
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                        <FormControl fullWidth size={"small"}>
                                                            <InputLabel id="demo-simple-select-label">Referência</InputLabel>
                                                            <Select
                                                                size="small"
                                                                required
                                                                //disabled={isLoading || edicao}
                                                                label="Referência"
                                                                variant="outlined"
                                                                name="referenciaConfronto"
                                                                value={referenciaConfronto}
                                                                defaultValue={""}
                                                                onChange={(e) => { setReferenciaConfronto(e.target.value); }}
                                                            >
                                                                <MenuItem value={0}>Selecione</MenuItem>
                                                                {
                                                                    lstReferenciasPosicaoConfronto.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                }
                                                            </Select>

                                                        </FormControl >
                                                        {/* <SelectComponent
                                                            isExternalLoading={isLoading}
                                                            label="Referência"
                                                            name="referenciaConfronto "
                                                            items={lstReferenciasPosicaoConfronto}
                                                            onChange={(e: any) => setReferenciaConfronto(e.target.value)}
                                                            defaultValue=""
                                                        /> */}
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}
                                                        display="flex"
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        justifyItems="center">
                                                        <Button
                                                            color="primary"
                                                            variant="contained"
                                                            disableElevation
                                                            onClick={criaPosicaoConfronto}
                                                            endIcon={<Icon>add</Icon>}
                                                        >
                                                            Adicionar
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            )}

                                            <Grid container size={{ xs: 12, sm: 12 }} marginTop={2} >
                                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                        <Table>
                                                            <TableHead>
                                                                <StyledTableRow>
                                                                    {isCriarPosicoes && <StyledTableCell align="center" width={100}>Ações</StyledTableCell>}
                                                                    <StyledTableCell align="center">Posição</StyledTableCell>
                                                                    <StyledTableCell>Referência</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {posConfrontoRows.map((row, index) => (
                                                                    <StyledTableRow key={index}>
                                                                        {isCriarPosicoes && (<StyledTableCell align="center" sx={{ padding: "2px" }}>
                                                                            <IconButton size="small" onClick={() => deletePosicaoConfronto(index)}>
                                                                                <Icon>delete</Icon>
                                                                            </IconButton>
                                                                        </StyledTableCell>)}
                                                                        <StyledTableCell align="center">{row.posicao_Liga}</StyledTableCell>
                                                                        <StyledTableCell>{tipoPosicaoConfronto === 4 ? row.posicao_Original === "G" ? "PG - SG" : row.posicao_Original === "F" ? "PF - SF" : row.posicao_Original : row.posicao_Original}</StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))
                                                                }
                                                            </TableBody>
                                                            {totalCountPosConfronto === 0 && !isLoading && (
                                                                <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                                            )}
                                                            <TableFooter>
                                                                {isLoading && (
                                                                    <StyledTableRow>
                                                                        <StyledTableCell colSpan={7}>
                                                                            <LinearProgress variant="indeterminate" />
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>
                                                                )}
                                                                {(totalCountPosConfronto > 0 && totalCountPosConfronto > Enviroment.LIMITE_DE_LINHAS) && (
                                                                    <StyledTableRow>
                                                                        <StyledTableCell colSpan={7}>
                                                                            <Pagination
                                                                                page={pagina}
                                                                                count={Math.ceil(totalCountPosConfronto / Enviroment.LIMITE_DE_LINHAS)}
                                                                                onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                                                                            />
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>
                                                                )}
                                                            </TableFooter>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} marginTop={3} spacing={1} display="flex" justifyContent="center" alignContent="center">
                                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                    <Typography variant="h6">Troca Posição</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2} >
                                                    <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                        <FormControl fullWidth size={"small"}>
                                                            <InputLabel id="demo-simple-select-label">Temporada</InputLabel>
                                                            <Select
                                                                size="small"
                                                                disabled={isLoading}
                                                                label="Temporada"
                                                                variant="outlined"
                                                                name="temporadaTrocaPosicao"
                                                                value={temporadaTrocaPosicao}
                                                                defaultValue={0}
                                                                onChange={(e) => { setTemporadaTrocaPosicao(Number(e.target.value)); }}
                                                            >
                                                                <MenuItem value={0}>Selecione</MenuItem>
                                                                {
                                                                    lstTemporadasFiltros.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                }
                                                            </Select>

                                                        </FormControl >
                                                        {/* <SelectComponent
                                                            isExternalLoading={isLoading}
                                                            label="Temporada"
                                                            name="temporadaTrocaPosicao"
                                                            items={lstTemporadasFiltros}
                                                            defaultValue=""
                                                            onChange={(e: any) => setTemporadaTrocaPosicao(e.target.value)}
                                                        /> */}
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            name="minutosTrocaPosicao"
                                                            disabled={isLoading}
                                                            label="Minutos"
                                                            onChange={(e: any) => setMinutosTrocaPosicao(e.target.value)}
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                                htmlInput: {
                                                                    maxLength: 3,
                                                                    min: 0
                                                                }
                                                            }}
                                                        />
                                                        {/* <VInputNumber
                                                            fullWidth
                                                            name="minutosTrocaPosicao"
                                                            type="text"
                                                            disabled={isLoading}
                                                            label="Minutos"
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                }
                                                            }}
                                                            maxLength={3}
                                                            onChange={(e: any) => setMinutosTrocaPosicao(e.target.value)}
                                                        /> */}
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            name="porcentagemTrocaPosicao"
                                                            disabled={isLoading}
                                                            label="Valor Máximo"
                                                            value={porcentagemTrocaPosicao}
                                                            onFocus={(e) => e.target.select()}
                                                            onChange={(e: any) => { Number(e.target.value) <= 100 ? setPorcentagemTrocaPosicao(e.target.value) : setPorcentagemTrocaPosicao(100); }}
                                                            slotProps={{
                                                                input: {
                                                                    inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                                },
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                                htmlInput: {
                                                                    maxLength: 6,
                                                                    min: 0
                                                                }
                                                            }}
                                                        />
                                                        {/* <VTextMaskCustom
                                                            maxLength={6}
                                                            typeMask="currency"
                                                            fullWidth
                                                            name="porcentagemTrocaPosicao"
                                                            type="text"
                                                            disabled={isLoading}
                                                            label="Porcentagem"
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                }
                                                            }}

                                                            onChange={(e: any) => { Number(e.target.value) <= 100 ? setPorcentagemTrocaPosicao(e.target.value) : setPorcentagemTrocaPosicao(100); }}
                                                        /> */}
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 3 }}
                                                        display="flex"
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        justifyItems="center">
                                                        <Button
                                                            color="primary"
                                                            variant="contained"
                                                            disableElevation
                                                            onClick={criaTrocaPosicao}
                                                            endIcon={<Icon>add</Icon>}
                                                        >
                                                            Adicionar
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} marginTop={2} >
                                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                        <Table>
                                                            <TableHead>
                                                                <StyledTableRow>
                                                                    <StyledTableCell align="center" width={100}>Ações</StyledTableCell>
                                                                    <StyledTableCell align="center">Temporada</StyledTableCell>
                                                                    <StyledTableCell align="center">Minutos</StyledTableCell>
                                                                    <StyledTableCell align="center">Porcentagem</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {trocaPosicaoRows.map((row, index) => (
                                                                    <StyledTableRow key={index}>
                                                                        <StyledTableCell align="center" sx={{ padding: "2px" }}>
                                                                            <IconButton size="small" onClick={() => deleteTrocaPosicao(index)}>
                                                                                <Icon>delete</Icon>
                                                                            </IconButton>
                                                                        </StyledTableCell>
                                                                        <StyledTableCell align="center">{lstTodasTemporadas.find(f => f.codigo === row.codigo_Temporada)?.label}</StyledTableCell>
                                                                        <StyledTableCell align="center">{row.tempo_Minimo}</StyledTableCell>
                                                                        <StyledTableCell align="center">{row.porcentagem}</StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))
                                                                }
                                                            </TableBody>
                                                            {totalCountTrocaPosicao === 0 && !isLoading && (
                                                                <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                                            )}
                                                            <TableFooter>
                                                                {isLoading && (
                                                                    <StyledTableRow>
                                                                        <StyledTableCell colSpan={7}>
                                                                            <LinearProgress variant="indeterminate" />
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>
                                                                )}
                                                                {(totalCountTrocaPosicao > 0 && totalCountTrocaPosicao > Enviroment.LIMITE_DE_LINHAS) && (
                                                                    <StyledTableRow>
                                                                        <StyledTableCell colSpan={7}>
                                                                            <Pagination
                                                                                page={pagina}
                                                                                count={Math.ceil(totalCountTrocaPosicao / Enviroment.LIMITE_DE_LINHAS)}
                                                                                onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                                                                            />
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>
                                                                )}
                                                            </TableFooter>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                            {/* <Scope path="configuracao_Liga"> */}
                                            <Grid container size={{ xs: 12, sm: 12 }} marginTop={3} spacing={1} textAlign="initial" >
                                                <Grid container size={{ xs: 12, sm: 4 }} spacing={1} textAlign="initial" >
                                                    <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                        <Typography variant="h6">Escalação</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid container margin={1} spacing={1} size={{ xs: 12, sm: 12 }} display="flex" justifyItems="start" >
                                                        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                            <Controller name="configuracao_Liga.minimo_Jogadores_Escalacao" control={control}
                                                                rules={{ required: true }}
                                                                render={({ field }) => (
                                                                    <TextField
                                                                        {...field}
                                                                        size="small"
                                                                        required
                                                                        fullWidth
                                                                        name="minimo_Jogadores_Escalacao"
                                                                        disabled={isLoading}
                                                                        label="Mínimo"
                                                                        defaultValue="2"
                                                                        slotProps={{
                                                                            inputLabel: {
                                                                                shrink: edicao ? true : undefined,
                                                                                style: {
                                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                                }
                                                                            },
                                                                            htmlInput: {
                                                                                maxLength: 2,
                                                                                min: 0
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                            {/* <VTextField
                                                                    fullWidth
                                                                    name="minimo_Jogadores_Escalacao"
                                                                    type="number"
                                                                    disabled={isLoading}
                                                                    label="Mínimo"
                                                                    slotProps={{
                                                                        inputLabel: {
                                                                            shrink: edicao ? true : undefined,
                                                                        }
                                                                    }}

                                                                    defaultValue="2"
                                                                /> */}
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                            <Controller name="configuracao_Liga.maximo_Jogadores_Escalacao" control={control}
                                                                rules={{ required: true }}
                                                                render={({ field }) => (
                                                                    <TextField
                                                                        {...field}
                                                                        size="small"
                                                                        required
                                                                        fullWidth
                                                                        name="maximo_Jogadores_Escalacao"
                                                                        disabled={isLoading}
                                                                        label="Máximo"
                                                                        defaultValue=""
                                                                        slotProps={{
                                                                            inputLabel: {
                                                                                shrink: edicao ? true : undefined,
                                                                                style: {
                                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                                }
                                                                            },
                                                                            htmlInput: {
                                                                                maxLength: 2,
                                                                                min: 0
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                            {/* <VTextField
                                                                    fullWidth
                                                                    name="maximo_Jogadores_Escalacao"
                                                                    type="number"
                                                                    disabled={true}
                                                                    label="Máximo"
                                                                    slotProps={{
                                                                        inputLabel: {
                                                                            shrink: edicao ? true : undefined,
                                                                        }
                                                                    }}

                                                                    defaultValue=""
                                                                /> */}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 4 }} spacing={1} textAlign="initial" >
                                                    <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                        <Typography variant="h6">Posição</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid container margin={1} spacing={1} size={{ xs: 12 }} display="flex" justifyItems="start" >
                                                        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                            <Controller name="configuracao_Liga.min_Posicao" control={control}
                                                                rules={{ required: true }}
                                                                render={({ field }) => (
                                                                    <TextField
                                                                        {...field}
                                                                        size="small"
                                                                        required
                                                                        fullWidth
                                                                        name="min_Posicao"
                                                                        disabled={isLoading}
                                                                        label="Mínimo"
                                                                        defaultValue=""
                                                                        slotProps={{
                                                                            inputLabel: {
                                                                                shrink: edicao ? true : undefined,
                                                                                style: {
                                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                                }
                                                                            },
                                                                            htmlInput: {
                                                                                maxLength: 2,
                                                                                min: 0
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                            {/* <VTextField
                                                                    fullWidth
                                                                    name="min_Posicao"
                                                                    type="number"
                                                                    disabled={isLoading}
                                                                    label="Mínimo"
                                                                    slotProps={{
                                                                        inputLabel: {
                                                                            shrink: edicao ? true : undefined,
                                                                        }
                                                                    }}

                                                                    defaultValue="2"
                                                                /> */}
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 6, md: 6 }} display="none">
                                                            <Controller name="configuracao_Liga.max_Posicao" control={control}
                                                                rules={{ required: true }}
                                                                render={({ field }) => (
                                                                    <TextField
                                                                        {...field}
                                                                        size="small"
                                                                        required
                                                                        fullWidth
                                                                        name="max_Posicao"
                                                                        disabled={isLoading}
                                                                        label="Máxima"
                                                                        defaultValue="12"
                                                                        slotProps={{
                                                                            inputLabel: {
                                                                                shrink: edicao ? true : undefined,
                                                                                style: {
                                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                                }
                                                                            },
                                                                            htmlInput: {
                                                                                maxLength: 2,
                                                                                min: 0
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                            {/* <VTextField
                                                                    fullWidth
                                                                    name="max_Posicao"
                                                                    type="number"
                                                                    disabled={isLoading}
                                                                    label="Máxima"
                                                                    slotProps={{
                                                                        inputLabel: {
                                                                            shrink: edicao ? true : undefined,
                                                                        }
                                                                    }}

                                                                    defaultValue="12"
                                                                /> */}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 4 }} spacing={1} textAlign="initial" >
                                                    <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                        <Typography variant="h6">Retorno</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid container margin={1} spacing={1} size={{ xs: 12 }} display="flex" justifyItems="start" >
                                                        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                            <FormControl fullWidth size={"small"}>
                                                                <InputLabel id="demo-simple-select-label">Jogador</InputLabel>
                                                                <Controller name="configuracao_Liga.retorno_Jogador" control={control}
                                                                    render={({ field: { onChange } }) => (
                                                                        <Select
                                                                            size="small"
                                                                            //disabled={isLoading || edicao}
                                                                            label="Jogador"
                                                                            variant="outlined"
                                                                            name="retorno_Jogador"
                                                                            defaultValue={0}
                                                                            onChange={(e) => { onChange(e); handleSelectedTemporada(e); }}
                                                                        >
                                                                            <MenuItem value={0}>Selecione</MenuItem>
                                                                            {
                                                                                lstRetornoJogador.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                            }
                                                                        </Select>
                                                                    )}
                                                                />
                                                            </FormControl >
                                                            {/* <SelectComponent
                                                                required
                                                                isExternalLoading={isLoading}
                                                                label="Jogador"
                                                                name="retorno_Jogador"
                                                                items={lstRetornoJogador}
                                                                onChange={handleSelectedTemporada}
                                                                defaultValue={0}
                                                            /> */}
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                            <Controller name="configuracao_Liga.retorno_Jogador_Dispensado" control={control}
                                                                rules={{ required: true }}
                                                                render={({ field }) => (
                                                                    <TextField
                                                                        {...field}
                                                                        size="small"
                                                                        required
                                                                        fullWidth
                                                                        name="retorno_Jogador_Dispensado"
                                                                        disabled={isLoading}
                                                                        label="Jogador Dispensado (Dias)"
                                                                        defaultValue={0}
                                                                        slotProps={{
                                                                            inputLabel: {
                                                                                shrink: edicao ? true : undefined,
                                                                                style: {
                                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                                }
                                                                            },
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            {/* </Scope> */}
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={valueTabs} index={7}>
                                    {(!removeLoading || isLoading) && <Loading />}
                                    <Grid container size={{ xs: 12, sm: 12 }} >
                                        <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                            <Typography variant="h6">Bônus CAP Liga</Typography>
                                            <hr />
                                        </Grid>
                                    </Grid>
                                    {/* <Scope path="bonusCAP_Liga"> */}
                                    <Grid container size={12} margin={1} spacing={2} display="flex" justifyItems="center" >
                                        <Grid size={{ xs: 12, sm: 12 }} textAlign="center" marginBottom={1} >
                                            <Typography variant="h6">Franquia</Typography>
                                            <hr style={{ width: "98%" }} />
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_Liga.treinador_Liga" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="treinador_Liga"
                                                        disabled={isLoading}
                                                        label="Treinador Liga"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                    fullWidth
                                                    name="treinador_Liga"
                                                    type="text"
                                                    disabled={isLoading}
                                                    label="Treinador Liga"
                                                    //value={`R$ ${min_Valor}`}
                                                    //onChange={e => setMin_Valor(e.target.value)}
                                                    typeMask="currency"
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        }
                                                    }}

                                                    onFocus={(e) => e.target.select()}
                                                /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_Liga.campeao_Liga" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="campeao_Liga"
                                                        disabled={isLoading}
                                                        label="Campeão Liga"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                    fullWidth
                                                    name="campeao_Liga"
                                                    type="text"
                                                    disabled={isLoading}
                                                    label="Campeão Liga"
                                                    //value={`R$ ${min_Valor}`}
                                                    //onChange={e => setMin_Valor(e.target.value)}
                                                    typeMask="currency"
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        }
                                                    }}

                                                    onFocus={(e) => e.target.select()}
                                                /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_Liga.vice_Campeao_Liga" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="vice_Campeao_Liga"
                                                        disabled={isLoading}
                                                        label="Vice Campeão Liga"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="vice_Campeao_Liga"
                                                type="text"
                                                disabled={isLoading}
                                                label="Vice Campeão Liga"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_Liga.campeao_Conferencia_Liga" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="campeao_Conferencia_Liga"
                                                        disabled={isLoading}
                                                        label="Campeão Conferência"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="campeao_Conferencia_Liga"
                                                type="text"
                                                disabled={isLoading}
                                                label="Campeão Conferência"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_Liga.vice_Conferencia_Liga" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="vice_Conferencia_Liga"
                                                        disabled={isLoading}
                                                        label="Vice Campeão Conferência"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="vice_Conferencia_Liga"
                                                type="text"
                                                disabled={isLoading}
                                                label="Vice Campeão Conferência"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_Liga.semifinalista_Liga" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="semifinalista_Liga"
                                                        disabled={isLoading}
                                                        label="Semi Finalista"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="semifinalista_Liga"
                                                type="text"
                                                disabled={isLoading}
                                                label="Semi Finalista"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_Liga.playoffs_Liga" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="playoffs_Liga"
                                                        disabled={isLoading}
                                                        label="Player Offs"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="playoffs_Liga"
                                                type="text"
                                                disabled={isLoading}
                                                label="Player Offs"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_Liga.campeao_Divisao_Liga" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="campeao_Divisao_Liga"
                                                        disabled={isLoading}
                                                        label="Campeão Divisão"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="campeao_Divisao_Liga"
                                                type="text"
                                                disabled={isLoading}
                                                label="Campeão Divisão"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_Liga.vice_Divisao_Liga" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="vice_Divisao_Liga"
                                                        disabled={isLoading}
                                                        label="Vice Divisão"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="vice_Divisao_Liga"
                                                type="text"
                                                disabled={isLoading}
                                                label="Vice Divisão"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_Liga.terceiro_Divisao_Liga" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="terceiro_Divisao_Liga"
                                                        disabled={isLoading}
                                                        label="Terceiro Divisão"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 12 }} textAlign="center" marginBottom={1}>
                                            <Typography variant="h6">Jogador</Typography>
                                            <hr style={{ width: "98%" }} />
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_Liga.mvp_Liga" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="mvp_Liga"
                                                        disabled={isLoading}
                                                        label="MVP Liga"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_Liga.roy_Liga" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="roy_Liga"
                                                        disabled={isLoading}
                                                        label="Roy Liga"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />

                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_Liga.dpoy_Liga" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="dpoy_Liga"
                                                        disabled={isLoading}
                                                        label="Droy Liga"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="dpoy_Liga"
                                                type="text"
                                                disabled={isLoading}
                                                label="Droy Liga"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_Liga.all_Star_Liga_First" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="all_Star_Liga_First"
                                                        disabled={isLoading}
                                                        label="Time All Star First"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="all_Star_Liga_First"
                                                type="text"
                                                disabled={isLoading}
                                                label="Time All Star First"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_Liga.all_Star_Liga_Second" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="all_Star_Liga_Second"
                                                        disabled={isLoading}
                                                        label="Time All Star Second"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="all_Star_Liga_Second"
                                                type="text"
                                                disabled={isLoading}
                                                label="Time All Star Second"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_Liga.calouros_Liga" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="calouros_Liga"
                                                        disabled={isLoading}
                                                        label="Time Calouros"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="calouros_Liga"
                                                type="text"
                                                disabled={isLoading}
                                                label="Time Calouros"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_Liga.gm_Liga" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="gm_Liga"
                                                        disabled={isLoading}
                                                        label="GM Liga"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="gm_Liga"
                                                type="text"
                                                disabled={isLoading}
                                                label="GM Liga"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                    </Grid>
                                    {/* </Scope> */}
                                    <Grid container size={{ xs: 12, sm: 12 }} margin={1} spacing={2} display="flex" justifyItems="center" >
                                        <Grid size={{ xs: 12, sm: 12 }} textAlign="center" marginTop={2} >
                                            <Typography variant="h6">Configuração</Typography>
                                            <hr style={{ width: "98%" }} />
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 4 }} >
                                            <Controller name="bonusCAP_Liga.minimo_Jogos" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        required
                                                        fullWidth
                                                        name="minimo_Jogos"
                                                        disabled={isLoading}
                                                        label="Mínimo Jogos"
                                                        //onChange={(e: any) => setMinutosTrocaPosicao(e.target.value)}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                            htmlInput: {
                                                                maxLength: 3,
                                                                min: 0
                                                            }
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VInputNumber
                                                fullWidth
                                                name="bonusCAP_Liga.minimo_Jogos"
                                                type="text"
                                                disabled={isLoading}
                                                label="Mínimo Jogos"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    },
                                                    htmlInput: {
                                                        maxLength: 20,
                                                        min: 0
                                                    }
                                                }}

                                                maxLength={3}
                                                onFocus={(e) => e.target.select()}
                                            // onChange={(e: any) => setMinutosTrocaPosicao(e.target.value)}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 4 }} >
                                            <Controller name="bonusCAP_Liga.minimo_Minutos" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        required
                                                        fullWidth
                                                        name="minimo_Minutos"
                                                        disabled={isLoading}
                                                        label="Minutos Tempo"
                                                        //onChange={(e: any) => setMinutosTrocaPosicao(e.target.value)}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                            htmlInput: {
                                                                maxLength: 3,
                                                                min: 0
                                                            }
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VInputNumber
                                                fullWidth
                                                name="bonusCAP_Liga.minimo_Minutos"
                                                type="text"
                                                disabled={isLoading}
                                                label="Minutos Tempo"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    },
                                                    htmlInput: {
                                                        maxLength: 20,
                                                        min: 0
                                                    }
                                                }}

                                                maxLength={3}
                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                                            <FormControl fullWidth size={"small"}>
                                                <InputLabel id="demo-simple-select-label">Jogador</InputLabel>
                                                <Select
                                                    size="small"
                                                    //disabled={isLoading || edicao}
                                                    label="Método"
                                                    variant="outlined"
                                                    name="metodo_Configuracao_Jogador"
                                                    defaultValue={0}
                                                    onChange={(e) => { setMetodo_Configuracao_Jogador(Number(e.target.value)) }}
                                                >
                                                    <MenuItem value={0}>Selecione</MenuItem>
                                                    {
                                                        lstMetodoConfigJogador.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                    }
                                                </Select>
                                            </FormControl >
                                            {/* <SelectComponent
                                                isExternalLoading={isLoading}
                                                label="Método"
                                                name="metodo_Configuracao_Jogador"
                                                items={lstMetodoConfigJogador}
                                                value={metodo_Configuracao_Jogador}
                                                defaultValue=""
                                                onChange={(e: any) => setMetodo_Configuracao_Jogador(e.target.value)}
                                            /> */}
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={valueTabs} index={8}>
                                    {(!removeLoading || isLoading) && <Loading />}
                                    <Grid container size={{ xs: 12, sm: 12 }} >
                                        <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                            <Typography variant="h6">Bônus CAP NBA</Typography>
                                            <hr />
                                        </Grid>
                                    </Grid>
                                    {/* <Scope path="bonusCAP_NBA"> */}
                                    <Grid container size={12} margin={1} spacing={2} display="flex" justifyItems="center" >
                                        <Grid size={{ xs: 12, sm: 12 }} textAlign="center" marginBottom={1} >
                                            <Typography variant="h6">Franquia</Typography>
                                            <hr style={{ width: "98%" }} />
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_NBA.campeao_NBA" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="campeao_NBA"
                                                        disabled={isLoading}
                                                        label="Campeão NBA"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            input: {
                                                                inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                            },
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                    fullWidth
                                                    name="campeao_NBA"
                                                    type="text"
                                                    disabled={isLoading}
                                                    label="Campeão NBA"
                                                    //value={`R$ ${min_Valor}`}
                                                    //onChange={e => setMin_Valor(e.target.value)}
                                                    typeMask="currency"
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        }
                                                    }}

                                                    onFocus={(e) => e.target.select()}
                                                /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_NBA.vice_Campeao_NBA" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="vice_Campeao_NBA"
                                                        disabled={isLoading}
                                                        label="Vice Campeão NBA"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            input: {
                                                                inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                            },
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="vice_Campeao_NBA"
                                                type="text"
                                                disabled={isLoading}
                                                label="Vice Campeão NBA"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            />*/}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_NBA.campeao_Conferencia_NBA" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="campeao_Conferencia_NBA"
                                                        disabled={isLoading}
                                                        label="Campeão Conferência"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            input: {
                                                                inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                            },
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="campeao_Conferencia_NBA"
                                                type="text"
                                                disabled={isLoading}
                                                label="Campeão Conferência"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_NBA.vice_Conferencia_NBA" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="vice_Conferencia_NBA"
                                                        disabled={isLoading}
                                                        label="Vice Campeão Conferência"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            input: {
                                                                inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                            },
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="vice_Conferencia_NBA"
                                                type="text"
                                                disabled={isLoading}
                                                label="Vice Campeão Conferência"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_NBA.semifinalista_NBA" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="semifinalista_NBA"
                                                        disabled={isLoading}
                                                        label="Semi Finalista"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            input: {
                                                                inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                            },
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="semifinalista_NBA"
                                                type="text"
                                                disabled={isLoading}
                                                label="Semi Finalista"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_NBA.playoffs_NBA" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="playoffs_NBA"
                                                        disabled={isLoading}
                                                        label="Play Offs"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            input: {
                                                                inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                            },
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="playoffs_NBA"
                                                type="text"
                                                disabled={isLoading}
                                                label="Play Offs"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_NBA.campeao_Divisao_NBA" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="campeao_Divisao_NBA"
                                                        disabled={isLoading}
                                                        label="Campeão Divisão"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            input: {
                                                                inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                            },
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="campeao_Divisao_NBA"
                                                type="text"
                                                disabled={isLoading}
                                                label="Campeão Divisão"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_NBA.vice_Campeao_Divisao_NBA" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="vice_Campeao_Divisao_NBA"
                                                        disabled={isLoading}
                                                        label="Vice Campeão Divisão"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            input: {
                                                                inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                            },
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="vice_Campeao_Divisao_NBA"
                                                type="text"
                                                disabled={isLoading}
                                                label="Vice Campeão Divisão"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                            <Controller name="bonusCAP_NBA.terceiro_Divisao_NBA" control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        size="small"
                                                        fullWidth
                                                        name="terceiro_Divisao_NBA"
                                                        disabled={isLoading}
                                                        label="Terceiro Divisão"
                                                        onFocus={(e) => e.target.select()}
                                                        slotProps={{
                                                            input: {
                                                                inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                            },
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <VTextMaskCustom
                                                fullWidth
                                                name="terceiro_Divisao_NBA"
                                                type="text"
                                                disabled={isLoading}
                                                label="Terceiro Divisão"
                                                //value={`R$ ${min_Valor}`}
                                                //onChange={e => setMin_Valor(e.target.value)}
                                                typeMask="currency"
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: edicao ? true : undefined,
                                                    }
                                                }}

                                                onFocus={(e) => e.target.select()}
                                            /> */}
                                        </Grid>
                                        <Grid container size={{ xs: 12, sm: 12 }} spacing={2} >
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="center" marginBottom={1}>
                                                <Typography variant="h6">Jogador</Typography>
                                                <hr style={{ width: "98%" }} />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                <Controller name="bonusCAP_NBA.mvp_NBA" control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            size="small"
                                                            fullWidth
                                                            name="mvp_NBA"
                                                            disabled={isLoading}
                                                            label="MVP NBA"
                                                            onFocus={(e) => e.target.select()}
                                                            slotProps={{
                                                                input: {
                                                                    inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                                },
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {/* <VTextMaskCustom
                                                    fullWidth
                                                    name="mvp_NBA"
                                                    type="text"
                                                    disabled={isLoading}
                                                    label="MVP NBA"
                                                    //value={`R$ ${min_Valor}`}
                                                    //onChange={e => setMin_Valor(e.target.value)}
                                                    typeMask="currency"
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        }
                                                    }}

                                                    onFocus={(e) => e.target.select()}
                                                /> */}
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                <Controller name="bonusCAP_NBA.roy_NBA" control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            size="small"
                                                            fullWidth
                                                            name="roy_NBA"
                                                            disabled={isLoading}
                                                            label="Roy NBA"
                                                            onFocus={(e) => e.target.select()}
                                                            slotProps={{
                                                                input: {
                                                                    inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                                },
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {/* <VTextMaskCustom
                                                    fullWidth
                                                    name="roy_NBA"
                                                    type="text"
                                                    disabled={isLoading}
                                                    label="Roy NBA"
                                                    //value={`R$ ${min_Valor}`}
                                                    //onChange={e => setMin_Valor(e.target.value)}
                                                    typeMask="currency"
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        }
                                                    }}

                                                    onFocus={(e) => e.target.select()}
                                                /> */}
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                <Controller name="bonusCAP_NBA.dpoy_NBA" control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            size="small"
                                                            fullWidth
                                                            name="dpoy_NBA"
                                                            disabled={isLoading}
                                                            label="Dpoy NBA"
                                                            onFocus={(e) => e.target.select()}
                                                            slotProps={{
                                                                input: {
                                                                    inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                                },
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {/* <VTextMaskCustom
                                                    fullWidth
                                                    name="dpoy_NBA"
                                                    type="text"
                                                    disabled={isLoading}
                                                    label="Dpoy Liga"
                                                    //value={`R$ ${min_Valor}`}
                                                    //onChange={e => setMin_Valor(e.target.value)}
                                                    typeMask="currency"
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        }
                                                    }}

                                                    onFocus={(e) => e.target.select()}
                                                /> */}
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                <Controller name="bonusCAP_NBA.all_Star_NBA_First" control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            size="small"
                                                            fullWidth
                                                            name="all_Star_NBA_First"
                                                            disabled={isLoading}
                                                            label="All Star NBA First"
                                                            onFocus={(e) => e.target.select()}
                                                            slotProps={{
                                                                input: {
                                                                    inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                                },
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {/* <VTextMaskCustom
                                                    fullWidth
                                                    name="all_Star_NBA_First"
                                                    type="text"
                                                    disabled={isLoading}
                                                    label="All Star NBA First"
                                                    //value={`R$ ${min_Valor}`}
                                                    //onChange={e => setMin_Valor(e.target.value)}
                                                    typeMask="currency"
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        }
                                                    }}

                                                    onFocus={(e) => e.target.select()}
                                                /> */}
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                <Controller name="bonusCAP_NBA.all_Star_NBA_Second" control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            size="small"
                                                            fullWidth
                                                            name="all_Star_NBA_Second"
                                                            disabled={isLoading}
                                                            label="all_Star_NBA_Second"
                                                            onFocus={(e) => e.target.select()}
                                                            slotProps={{
                                                                input: {
                                                                    inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                                },
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {/* <VTextMaskCustom
                                                    fullWidth
                                                    name="all_Star_NBA_Second"
                                                    type="text"
                                                    disabled={isLoading}
                                                    label="Time All Star Second"
                                                    //value={`R$ ${min_Valor}`}
                                                    //onChange={e => setMin_Valor(e.target.value)}
                                                    typeMask="currency"
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        }
                                                    }}

                                                    onFocus={(e) => e.target.select()}
                                                /> */}
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                <Controller name="bonusCAP_NBA.calouros_NBA" control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            size="small"
                                                            fullWidth
                                                            name="calouros_NBA"
                                                            disabled={isLoading}
                                                            label="Calouros NBA"
                                                            onFocus={(e) => e.target.select()}
                                                            slotProps={{
                                                                input: {
                                                                    inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                                },
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {/* <VTextMaskCustom
                                                    fullWidth
                                                    name="calouros_NBA"
                                                    type="text"
                                                    disabled={isLoading}
                                                    label="Calouros NBA"
                                                    //value={`R$ ${min_Valor}`}
                                                    //onChange={e => setMin_Valor(e.target.value)}
                                                    typeMask="currency"
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        }
                                                    }}

                                                    onFocus={(e) => e.target.select()}
                                                /> */}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    {/* </Scope> */}
                                </TabPanel>
                                <TabPanel value={valueTabs} index={9}>
                                    {(!removeLoading || isLoading) && <Loading />}
                                    <Grid container size={12} direction="column" >
                                        <Grid container size={{ xs: 12, sm: 12 }} spacing={2} display="flex">
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                <Typography variant="h6">Bônus CAP Jogadores</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} margin={1} spacing={2} display="flex" justifyItems="center" >
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <TextField
                                                        size="small"
                                                        fullWidth
                                                        name="minimo_Jogos"
                                                        disabled={isLoading}
                                                        label="Mínimo Jogos"
                                                        onChange={(e) => setMin_Jogos(Number(e.target.value))}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                            htmlInput: {
                                                                maxLength: 3,
                                                                min: 0
                                                            }
                                                        }}
                                                    />

                                                    {/* <VInputNumber
                                                        fullWidth
                                                        name="minimo_Jogos"
                                                        type="text"
                                                        disabled={isLoading}
                                                        label="Mínimo Jogos"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            }
                                                        }}

                                                        onChange={(e) => setMin_Jogos(Number(e.target.value))}
                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    {/* <Controller name="bonusCAP_Jogadores.minimo_Minutos" control={control}
                                                        render={({ field }) => ( */}
                                                    <TextField
                                                        size="small"
                                                        required
                                                        fullWidth
                                                        name="minimo_Minutos"
                                                        disabled={isLoading}
                                                        label="Mínimo Minutos"
                                                        value={min_Minutos}
                                                        onChange={(e) => setMin_Minutos(Number(e.target.value))}

                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                            htmlInput: {
                                                                maxLength: 3,
                                                                min: 0
                                                            }
                                                        }}
                                                    />

                                                    {/* <VInputNumber
                                                        fullWidth
                                                        name="minimo_Minutos"
                                                        type="text"
                                                        disabled={isLoading}
                                                        label="Mínimo Minutos"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            }
                                                        }}

                                                        onChange={(e) => setMin_Minutos(Number(e.target.value))}
                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <FormControl fullWidth disabled={isLoading}>
                                                        <InputLabel id="demo-simple-select-label">Apuração</InputLabel>
                                                        <Select
                                                            size="small"
                                                            id="demo-simple-select-apuracao"
                                                            variant="outlined"
                                                            value={bonus_Apuracao}
                                                            label="Apuração"
                                                            onChange={(e) => setBonus_Apuracao(Number(e.target.value))}
                                                            defaultValue={1}

                                                        >
                                                            <MenuItem value={0}>Selecione</MenuItem>
                                                            {
                                                                lstTipoLigaNBA.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                            }

                                                        </Select>
                                                    </FormControl >

                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} margin={1} spacing={2} display="flex" justifyItems="center" >
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                                                    <FormControl fullWidth size={"small"}>
                                                        <InputLabel id="demo-simple-select-label">Box Score</InputLabel>
                                                        <Select
                                                            size="small"
                                                            //disabled={isLoading || edicao}
                                                            label="Box Score"
                                                            variant="outlined"
                                                            name="boxScore"
                                                            defaultValue={0}
                                                            onChange={(e) => { setBoxScore(Number(e.target.value)) }}
                                                        >
                                                            <MenuItem value={0}>Selecione</MenuItem>
                                                            {
                                                                BoxScore.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                            }
                                                        </Select>
                                                    </FormControl >
                                                    {/* <SelectComponent
                                                        isExternalLoading={isLoading}
                                                        label="Box Score"
                                                        name="boxScore"
                                                        items={BoxScore}
                                                        onChange={(e) => setBoxScore(Number(e.target.value))}
                                                        defaultValue=""
                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <TextField
                                                        size="small"
                                                        required
                                                        fullWidth
                                                        name="inicio_Intervalo"
                                                        disabled={isLoading}
                                                        label="Início Intervalo"
                                                        value={inicio_Intervalo}
                                                        onChange={(e) => setInicio_Intervalo(Number(e.target.value))}

                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                            htmlInput: {
                                                                maxLength: 3,
                                                                min: 0
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <TextField
                                                        size="small"
                                                        required
                                                        fullWidth
                                                        name="fim_Intervalo"
                                                        disabled={isLoading}
                                                        label="Fim Intervalo"
                                                        value={fim_Intervalo}
                                                        onChange={(e) => setFim_Intervalo(Number(e.target.value))}

                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                            htmlInput: {
                                                                maxLength: 3,
                                                                min: 0
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <TextField
                                                        size="small"
                                                        fullWidth
                                                        name="valor"
                                                        disabled={isLoading}
                                                        label="Valor"
                                                        onFocus={(e) => e.target.select()}
                                                        value={valor}
                                                        onChange={(e) => setValor(e.target.value)}
                                                        slotProps={{
                                                            input: {
                                                                inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                            },
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                                style: {
                                                                    fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                }
                                                            },
                                                        }}
                                                    />
                                                    {/* <VTextMaskCustom
                                                        fullWidth
                                                        name="valor"
                                                        type="text"
                                                        disabled={isLoading}
                                                        label="Valor"
                                                        typeMask="currency"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            }
                                                        }}

                                                        onChange={(e) => setValor(e.target.value)}
                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                                                    <FormControl fullWidth size={"small"}>
                                                        <InputLabel id="demo-simple-select-label">Classificação</InputLabel>
                                                        <Select
                                                            size="small"
                                                            //disabled={isLoading || edicao}
                                                            label="Classificação"
                                                            variant="outlined"
                                                            name="classificacao"
                                                            defaultValue={""}
                                                            onChange={(e) => { setTipo(Number(e.target.value)) }}
                                                        >
                                                            <MenuItem value={0}>Selecione</MenuItem>
                                                            {
                                                                lstTipoBonusJogador.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                            }
                                                        </Select>
                                                    </FormControl >
                                                    {/* <SelectComponent
                                                        isExternalLoading={isLoading}
                                                        label="Classificação"
                                                        name="classificacao"
                                                        items={lstTipoBonusJogador}
                                                        onChange={(e) => setTipo(Number(e.target.value))}
                                                        defaultValue=""
                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }}
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    justifyItems="center">
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={criaBonusCAPJogadoresRows}
                                                        endIcon={<Icon>add</Icon>}
                                                    >
                                                        Adicionar
                                                    </Button>
                                                </Grid>
                                            </Grid>

                                            <Grid container size={{ xs: 12, sm: 12 }} marginTop={2} >
                                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                    <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                        <Table>
                                                            <TableHead>
                                                                <StyledTableRow>
                                                                    <StyledTableCell align="center" width={100}>Ações</StyledTableCell>
                                                                    <StyledTableCell align="center">Box Score</StyledTableCell>
                                                                    <StyledTableCell align="center">Início</StyledTableCell>
                                                                    <StyledTableCell align="center">Fim</StyledTableCell>
                                                                    <StyledTableCell align="center">Classificação</StyledTableCell>
                                                                    <StyledTableCell align="center">Valor</StyledTableCell>
                                                                    <StyledTableCell align="center">Min. Jogos</StyledTableCell>
                                                                    <StyledTableCell align="center">Mín. Minutos</StyledTableCell>
                                                                    <StyledTableCell align="center">Apuração</StyledTableCell>

                                                                </StyledTableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {bonusCAPJogadoresRows.map((row, index) => (
                                                                    <StyledTableRow key={index}>
                                                                        <StyledTableCell align="center" sx={{ padding: "2px" }}>
                                                                            <IconButton size="small" onClick={() => deleteBonusCAPJogadoresRows(index)}>
                                                                                <Icon>delete</Icon>
                                                                            </IconButton>
                                                                        </StyledTableCell>
                                                                        <StyledTableCell align="center">{BoxScore.find(f => f.codigo === row.boxScore)?.label}</StyledTableCell>
                                                                        <StyledTableCell align="center">{row.inicio_Intervalo}</StyledTableCell>
                                                                        <StyledTableCell align="center">{row.fim_Intervalo}</StyledTableCell>
                                                                        <StyledTableCell align="center">{lstTipoBonusJogador.find(f => f.codigo === row.classificacao)?.label}</StyledTableCell>
                                                                        <StyledTableCell align="center">{moedaRealLocaleValue(row.valor)}</StyledTableCell>
                                                                        <StyledTableCell align="center">{row.minimo_Jogos}</StyledTableCell>
                                                                        <StyledTableCell align="center">{row.minimo_Minutos}</StyledTableCell>
                                                                        <StyledTableCell align="center">{lstTipoLigaNBA.find(f => f.codigo === (row.considera_Liga ? 1 : 2))?.label}</StyledTableCell>

                                                                    </StyledTableRow>
                                                                ))
                                                                }
                                                            </TableBody>
                                                            {totalCountBonusCapJogadores === 0 && !isLoading && (
                                                                <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                                            )}
                                                            <TableFooter>
                                                                {isLoading && (
                                                                    <StyledTableRow>
                                                                        <StyledTableCell colSpan={9}>
                                                                            <LinearProgress variant="indeterminate" />
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>
                                                                )}
                                                                {(totalCountBonusCapJogadores > 0 && totalCountBonusCapJogadores > Enviroment.LIMITE_DE_LINHAS) && (
                                                                    <StyledTableRow>
                                                                        <StyledTableCell colSpan={9}>
                                                                            <Pagination
                                                                                page={pagina}
                                                                                count={Math.ceil(totalCountBonusCapJogadores / Enviroment.LIMITE_DE_LINHAS)}
                                                                                onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                                                                            />
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>
                                                                )}
                                                            </TableFooter>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={valueTabs} index={10}>
                                    {(!removeLoading || isLoading) && <Loading />}
                                    <Grid container size={12} direction="column" >
                                        <Grid container size={{ xs: 12, sm: 12 }} spacing={2} display="flex">
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                <Typography variant="h6">Configurações Free Agency</Typography>
                                                <hr />
                                            </Grid>
                                            {/* <Scope path="configuracao_Free_Agency"> */}
                                            <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2} >
                                                <Grid size={{ xs: 12, sm: 6, md: 6 }} display="flex" justifyContent="center">
                                                    <FormControl>
                                                        <FormLabel>Tipo Free Agency</FormLabel>
                                                        <MuiRadioGroup
                                                            row
                                                            name="tipo"
                                                            value={tipoFreeAgency}
                                                            onChange={(e) => { setTipoFreeAgency(Number(e.target.value)); }}
                                                        >
                                                            {
                                                                configuracaoFreeAgency.map(item => (<FormControlLabel key={item.codigo} value={item.codigo} control={<Radio />} label={item.label} />))
                                                            }
                                                        </MuiRadioGroup>
                                                    </FormControl >
                                                    {/* <RadioGroup
                                                            isExternalLoading={isLoading}
                                                            items={configuracaoFreeAgency}
                                                            name="tipo"
                                                            label="Tipo Free Agency"
                                                            value={tipoFreeAgency}
                                                            onChange={(e) => setTipoFreeAgency(Number(e.target.value))}
                                                        /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} display={tipoFreeAgency === 3 ? "block" : "none"} style={{ paddingTop: "20px" }}>
                                                    <Controller name="configuracao_Free_Agency.porcentagem_Contrato_Ajustavel" control={control}
                                                        render={({ field }) => (
                                                            <TextField
                                                                {...field}
                                                                size="small"
                                                                required
                                                                fullWidth
                                                                name="porcentagem_Contrato_Ajustavel"
                                                                disabled={isLoading}
                                                                label="Porcentagem"
                                                                slotProps={{
                                                                    inputLabel: {
                                                                        shrink: edicao ? true : undefined,
                                                                        style: {
                                                                            fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                        }
                                                                    },
                                                                    htmlInput: {
                                                                        maxLength: 3,
                                                                        min: 0
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    />

                                                    {/* <VInputNumber
                                                        fullWidth
                                                        name="porcentagem_Contrato_Ajustavel"
                                                        type="text"
                                                        disabled={isLoading}
                                                        label="Porcentagem"
                                                        maxLength={3}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            },
                                                            htmlInput: {
                                                                maxLength: 20,
                                                                min: 0
                                                            }
                                                        }}

                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} display={tipoFreeAgency === 3 ? "block" : "none"} style={{ paddingTop: "20px" }}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">Tipo Contrato Ajustável</InputLabel>
                                                        <Select
                                                            size="small"
                                                            name="tipo_Contrato_Ajustavel"
                                                            label="Tipo Contrato Ajustável"
                                                            defaultValue={0}
                                                            value={tipoContratoAjustavel}
                                                            onChange={(e) => setTipoContratoAjustavel(Number(e.target.value))}
                                                        >
                                                            <MenuItem key="3" value={0}>Progressiva e Regressiva</MenuItem>
                                                            <MenuItem key="1" value={1}>Somente Progressiva</MenuItem>
                                                            <MenuItem key="2" value={2}>Somente Regressiva</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                    <Typography variant="h6">Jogadores</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                                    <FormControl fullWidth size={"small"}>
                                                        <InputLabel id="demo-simple-select-label">Ano Adicional Direitos</InputLabel>
                                                        <Controller name="configuracao_Free_Agency.ano_Adicional_Direito_Jogador" control={control}
                                                            render={({ field: { onChange } }) => (
                                                                <Select
                                                                    size="small"
                                                                    //disabled={isLoading || edicao}
                                                                    label="Ano Adicional Direitos"
                                                                    variant="outlined"
                                                                    name="ano_Adicional_Direito_Jogador"
                                                                    defaultValue={0}
                                                                    onChange={(e) => { onChange(e); }}
                                                                >
                                                                    <MenuItem value={0}>Selecione</MenuItem>
                                                                    {
                                                                        lstAnos.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                    }
                                                                </Select>
                                                            )}
                                                        />
                                                    </FormControl >
                                                    {/* <SelectComponent
                                                            required
                                                            isExternalLoading={isLoading}
                                                            label="Ano Adicional Direitos"
                                                            name="ano_Adicional_Direito_Jogador"
                                                            items={lstAnos}
                                                            defaultValue="1"
                                                        /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                                    <FormControl fullWidth size={"small"}>
                                                        <InputLabel id="demo-simple-select-label">Ano Adicional Direitos</InputLabel>
                                                        <Controller name="configuracao_Free_Agency.ano_Adicional_Restrito_Jogador" control={control}
                                                            render={({ field: { onChange } }) => (
                                                                <Select
                                                                    size="small"
                                                                    disabled={isLoading}
                                                                    label="Ano Adicional Restritos"
                                                                    variant="outlined"
                                                                    name="ano_Adicional_Restrito_Jogador"
                                                                    defaultValue={0}
                                                                    onChange={(e) => { onChange(e); }}
                                                                >
                                                                    <MenuItem value={0}>Selecione</MenuItem>
                                                                    {
                                                                        lstAnos.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                    }
                                                                </Select>
                                                            )}
                                                        />
                                                    </FormControl >
                                                    {/* <SelectComponent
                                                        required
                                                        isExternalLoading={isLoading}
                                                        label="Ano Adicional Restritos"
                                                        name="ano_Adicional_Restrito_Jogador"
                                                        items={lstAnos}
                                                        defaultValue="1"
                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <Controller name="configuracao_Free_Agency.desconto_Renovacao_Direito" control={control}
                                                        render={({ field }) => (
                                                            <TextField
                                                                {...field}
                                                                size="small"
                                                                required
                                                                fullWidth
                                                                name="desconto_Renovacao_Direito"
                                                                disabled={isLoading}
                                                                label="Desconto Renovação Direito"
                                                                slotProps={{
                                                                    inputLabel: {
                                                                        shrink: edicao ? true : undefined,
                                                                        style: {
                                                                            fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                        }
                                                                    },
                                                                    htmlInput: {
                                                                        maxLength: 3,
                                                                        min: 0
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                    {/* <VInputNumber
                                                        fullWidth
                                                        name="desconto_Renovacao_Direito"
                                                        type="text"
                                                        disabled={isLoading}
                                                        label="Desconto Renovação Direito"
                                                        maxLength={3}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            },
                                                            htmlInput: {
                                                                maxLength: 20,
                                                                min: 0
                                                            }
                                                        }}

                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <Controller name="configuracao_Free_Agency.desconto_Renovacao_Restrito" control={control}
                                                        render={({ field }) => (
                                                            <TextField
                                                                {...field}
                                                                size="small"
                                                                required
                                                                fullWidth
                                                                name="desconto_Renovacao_Restrito"
                                                                disabled={isLoading}
                                                                label="Desconto Renovação Restrito"
                                                                slotProps={{
                                                                    inputLabel: {
                                                                        shrink: edicao ? true : undefined,
                                                                        style: {
                                                                            fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                        }
                                                                    },
                                                                    htmlInput: {
                                                                        maxLength: 3,
                                                                        min: 0
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                    {/* <VInputNumber
                                                        fullWidth
                                                        name="desconto_Renovacao_Restrito"
                                                        disabled={isLoading}
                                                        label="Desconto Renovação Restrito "
                                                        type="text"
                                                        maxLength={3}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            },
                                                            htmlInput: {
                                                                maxLength: 20,
                                                                min: 0
                                                            }
                                                        }}

                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                    <Controller name="configuracao_Free_Agency.desconto_Renovacao_Draftado" control={control}
                                                        render={({ field }) => (
                                                            <TextField
                                                                {...field}
                                                                size="small"
                                                                required
                                                                fullWidth
                                                                name="desconto_Renovacao_Draftado"
                                                                disabled={isLoading}
                                                                label="Desconto Renovação Draftado"
                                                                slotProps={{
                                                                    inputLabel: {
                                                                        shrink: edicao ? true : undefined,
                                                                        style: {
                                                                            fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                        }
                                                                    },
                                                                    htmlInput: {
                                                                        maxLength: 3,
                                                                        min: 0
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                    {/* <VInputNumber
                                                        fullWidth
                                                        name="desconto_Renovacao_Draftado"
                                                        disabled={isLoading}
                                                        label="Desconto Renovação Draftado"
                                                        type="text"
                                                        maxLength={3}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            },
                                                            htmlInput: {
                                                                maxLength: 20,
                                                                min: 0
                                                            }
                                                        }}

                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                    <Typography variant="h6">Desconto Restrito</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                                    <FormControl fullWidth size={"small"}>
                                                        <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
                                                        <Controller name="configuracao_Free_Agency.codigo_Tipo_Desconto_Restrito" control={control}
                                                            render={({ field: { onChange } }) => (
                                                                <Select
                                                                    size="small"
                                                                    disabled={isLoading}
                                                                    label="Tipo"
                                                                    variant="outlined"
                                                                    name="codigo_Tipo_Desconto_Restrito"
                                                                    defaultValue={1}
                                                                    onChange={(e) => { onChange(e) }}
                                                                >
                                                                    <MenuItem value={0}>Selecione</MenuItem>
                                                                    {
                                                                        lstDescontoRestritoFreeAgence.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                    }
                                                                </Select>
                                                            )}
                                                        />
                                                    </FormControl >
                                                    {/* <SelectComponent
                                                            required
                                                            isExternalLoading={isLoading}
                                                            label="Tipo"
                                                            name="codigo_Tipo_Desconto_Restrito"
                                                            items={lstDescontoRestritoFreeAgence}
                                                            defaultValue="1"
                                                        // value={codigoTipoDescontoRestrito}
                                                        //  onChange={(e) => setcodigoTipoDescontoRestrito(Number(e.target.value))}
                                                        /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                    <Typography variant="h6">Renovação</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                    <Typography variant="body1">COM DIREITOS</Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                                    <FormControl fullWidth size={"small"}>
                                                        <InputLabel id="demo-simple-select-label">Opções</InputLabel>
                                                        <Controller name="configuracao_Free_Agency.codigo_Opcao_Direito" control={control}
                                                            render={({ field: { onChange } }) => (
                                                                <Select
                                                                    size="small"
                                                                    disabled={isLoading}
                                                                    label="Opções"
                                                                    variant="outlined"
                                                                    name="codigo_Opcao_Direito"
                                                                    defaultValue={0}
                                                                    onChange={(e) => { onChange(e) }}
                                                                >
                                                                    <MenuItem value={0}>Selecione</MenuItem>
                                                                    {
                                                                        lstDireitos.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                    }
                                                                </Select>
                                                            )}
                                                        />
                                                    </FormControl >
                                                    {/* <SelectComponent
                                                            required
                                                            isExternalLoading={isLoading}
                                                            label="Opções"
                                                            name="codigo_Opcao_Direito"
                                                            items={lstDireitos}
                                                            defaultValue="0"
                                                        /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <FormControl fullWidth size={"small"}>
                                                        <InputLabel id="demo-simple-select-label">Regressivo</InputLabel>
                                                        <Controller name="configuracao_Free_Agency.quantidade_Ano_Regressivo_Direito" control={control}
                                                            render={({ field: { onChange } }) => (
                                                                <Select
                                                                    size="small"
                                                                    disabled={isLoading}
                                                                    label="Regressivo"
                                                                    variant="outlined"
                                                                    name="quantidade_Ano_Regressivo_Direito"
                                                                    defaultValue={0}
                                                                    onChange={(e) => { onChange(e); handleSelectedAPartir(e); }}
                                                                >
                                                                    <MenuItem value={0}>Selecione</MenuItem>
                                                                    {
                                                                        lstQuantidadeDireitos.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                    }
                                                                </Select>
                                                            )}
                                                        />
                                                    </FormControl >
                                                    {/* <SelectComponent
                                                            required
                                                            isExternalLoading={isLoading}
                                                            label="Regressivo"
                                                            name="quantidade_Ano_Regressivo_Direito"
                                                            items={lstQuantidadeDireitos}
                                                            defaultValue="0"
                                                            onChange={(e) => {
                                                                handleSelectedAPartir(e);
                                                                //    setErrors({ ...errors, qtdDireitosRegressivoRef: "" }) 
                                                            }}
                                                            ref={qtdDireitosRegressivoRef as any}
                                                        /> */}
                                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} height="24px">
                                                        {errors.configuracao_Free_Agency?.quantidade_Ano_Regressivo_Direito && <span style={{ fontSize: "13px", color: "red" }}>Campo Obrigatório</span>}
                                                    </Grid>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <FormControl fullWidth size={"small"}>
                                                        <InputLabel id="demo-simple-select-label">A Partir</InputLabel>
                                                        <Controller name="configuracao_Free_Agency.quantidade_Ano_Partir_Direito" control={control}
                                                            render={({ field: { onChange } }) => (
                                                                <Select
                                                                    size="small"
                                                                    disabled={isLoading}
                                                                    label="A Partir"
                                                                    variant="outlined"
                                                                    name="quantidade_Ano_Partir_Direito"
                                                                    defaultValue={0}
                                                                    onChange={(e) => { onChange(e); setQuantidade_Ano_Partir_Direito(Number(e.target.value)); }}
                                                                >
                                                                    <MenuItem value={0}>Selecione</MenuItem>
                                                                    {
                                                                        newLstQuantidadeDireitos.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                    }
                                                                </Select>
                                                            )}
                                                        />
                                                    </FormControl >
                                                    {/* <SelectComponent
                                                            required
                                                            isExternalLoading={isLoading}
                                                            label="A Partir"
                                                            name="quantidade_Ano_Partir_Direito"
                                                            items={newLstQuantidadeDireitos}
                                                            ref={qtdDireitosApartirRef as any}
                                                            defaultValue="0"
                                                            onChange={(e) => { setQuantidade_Ano_Partir_Direito(Number(e.target.value)); }}
                                                        /> */}
                                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} height="24px">
                                                        {errors.configuracao_Free_Agency?.quantidade_Ano_Partir_Direito && <span style={{ fontSize: "13px", color: "red" }}>Campo obrigatório</span>}
                                                    </Grid>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                    <Typography variant="body1">SEM DIREITOS</Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                                    <FormControl fullWidth size={"small"}>
                                                        <InputLabel id="demo-simple-select-label">Opções</InputLabel>
                                                        <Controller name="configuracao_Free_Agency.codigo_Opcao_Sem_Direito" control={control}
                                                            render={({ field: { onChange } }) => (
                                                                <Select
                                                                    size="small"
                                                                    //disabled={isLoading || edicao}
                                                                    label="Opções"
                                                                    variant="outlined"
                                                                    name="codigo_Opcao_Sem_Direito"
                                                                    defaultValue={0}
                                                                    onChange={(e) => { onChange(e); handleSelectedTemporada(e); }}
                                                                >
                                                                    <MenuItem value={0}>Selecione</MenuItem>
                                                                    {
                                                                        lstDireitos.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                    }
                                                                </Select>
                                                            )}
                                                        />
                                                    </FormControl >
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <FormControl fullWidth size={"small"}>
                                                        <InputLabel id="demo-simple-select-label">Regressivo</InputLabel>
                                                        <Controller name="configuracao_Free_Agency.quantidade_Ano_Regressivo_Sem_Direito" control={control}
                                                            render={({ field: { onChange } }) => (
                                                                <Select
                                                                    size="small"
                                                                    //disabled={isLoading || edicao}
                                                                    label="Regressivo"
                                                                    variant="outlined"
                                                                    name="quantidade_Ano_Regressivo_Sem_Direito"
                                                                    defaultValue={0}
                                                                    onChange={(e) => { onChange(e); handleSelectedAPartirSem(e); }}
                                                                    ref={qtdDireitosRegressivoSemRef as any}
                                                                >
                                                                    <MenuItem value={0}>Selecione</MenuItem>
                                                                    {
                                                                        lstQuantidadeDireitos.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                    }
                                                                </Select>
                                                            )}
                                                        />
                                                    </FormControl >
                                                    {/* <SelectComponent
                                                        required
                                                        isExternalLoading={isLoading}
                                                        label="Regressivo"
                                                        name="quantidade_Ano_Regressivo_Sem_Direito"
                                                        items={lstQuantidadeDireitos}
                                                        defaultValue="0"
                                                        onChange={(e) => {
                                                            handleSelectedAPartirSem(e);
                                                            //    setErrors({ ...errors, qtdDireitosRegressivoSemRef: "" }) 
                                                        }}
                                                        ref={qtdDireitosRegressivoSemRef as any}
                                                    />*/}
                                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} height="24px">
                                                        {errors.configuracao_Free_Agency?.quantidade_Ano_Regressivo_Sem_Direito && <span style={{ fontSize: "13px", color: "red" }}>Campo obrigatório</span>}
                                                    </Grid>

                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <FormControl fullWidth size={"small"}>
                                                        <InputLabel id="demo-simple-select-label">A Partir</InputLabel>
                                                        <Controller name="configuracao_Free_Agency.quantidade_Ano_Partir_Sem_Direito" control={control}
                                                            render={({ field: { onChange } }) => (
                                                                <Select
                                                                    size="small"
                                                                    //disabled={isLoading || edicao}
                                                                    label="A Partir"
                                                                    variant="outlined"
                                                                    name="quantidade_Ano_Partir_Sem_Direito"
                                                                    defaultValue={0}
                                                                    onChange={(e) => { onChange(e); setQuantidade_Ano_Partir_Sem_Direito(Number(e.target.value)) }}
                                                                    ref={qtdDireitosApartirSemRef as any}
                                                                >
                                                                    <MenuItem value={0}>Selecione</MenuItem>
                                                                    {
                                                                        newLstQuantidadeDireitosSem.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                    }
                                                                </Select>
                                                            )}
                                                        />
                                                    </FormControl >
                                                    {/* <SelectComponent
                                                        required
                                                        isExternalLoading={isLoading}
                                                        label="A Partir"
                                                        name="quantidade_Ano_Partir_Sem_Direito"
                                                        items={newLstQuantidadeDireitosSem}
                                                        defaultValue="0"
                                                        ref={qtdDireitosApartirSemRef as any}
                                                        onChange={(e) => {
                                                            setQuantidade_Ano_Partir_Sem_Direito(Number(e.target.value));
                                                            //    setErrors({ ...errors, qtdDireitosApartirSemRef: "" }) 
                                                        }}
                                                    /> */}
                                                    <Grid size={{ xs: 12, sm: 12, md: 12 }} height="24px">
                                                        {errors.configuracao_Free_Agency?.quantidade_Ano_Partir_Sem_Direito && <span style={{ fontSize: "13px", color: "red" }}>Campo obrigatório</span>}
                                                    </Grid>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} display={"none"}>
                                                    <FormControl>
                                                        <FormControlLabel
                                                            control={<MuiCheckBox
                                                                name="resetar_Bloqueio_Franquias"
                                                                checked={resetar_Bloqueio_Franquias}
                                                                onChange={e => setResetar_Bloqueio_Franquias(e.target.checked)}
                                                            />}
                                                            label="Resetar Bloqueio Franquias"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} display={"none"} >
                                                    <FormControl>
                                                        <FormControlLabel
                                                            control={<MuiCheckBox
                                                                name="resetar_Posicao_Jogadores"
                                                                checked={resetar_Posicao_Jogadores}
                                                                onChange={e => setResetar_Posicao_Jogadores(e.target.checked)}
                                                            />}
                                                            label="Resetar Posição Jogadores"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <FormControl>
                                                        <FormControlLabel
                                                            control={<MuiCheckBox
                                                                name="divisao_Lotes"
                                                                checked={divisao_Lotes}
                                                                onChange={e => setDivisao_Lotes(e.target.checked)}
                                                            />}
                                                            label="Divisão Por Lotes"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} display={"none"}>
                                                    <FormControl>
                                                        <FormControlLabel
                                                            control={<MuiCheckBox
                                                                name="player_Option"
                                                                checked={player_Option}
                                                                onChange={e => setPlayer_Option(e.target.checked)}
                                                            />}
                                                            label="Play Option"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} display={"none"}>
                                                    <FormControl>
                                                        <FormControlLabel
                                                            control={<MuiCheckBox
                                                                name="team_Option"
                                                                checked={team_Option}
                                                                onChange={e => setTeam_Option(e.target.checked)}
                                                            />}
                                                            label="Team Option"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <FormControl>
                                                        <FormControlLabel
                                                            control={<MuiCheckBox
                                                                name="sign_Trade"
                                                                checked={sign_Trade}
                                                                onChange={e => setSign_Trade(e.target.checked)}
                                                            />}
                                                            label="Sign Trade"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                                    <FormControl>
                                                        <FormControlLabel
                                                            control={<MuiCheckBox
                                                                name="match_Desconto"
                                                                checked={match_Desconto}
                                                                onChange={e => setMatch_Desconto(e.target.checked)}
                                                            />}
                                                            label="Match com Desconto"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} display={"flex"}>
                                                    <FormControl>
                                                        <FormControlLabel
                                                            control={<MuiCheckBox
                                                                name="lance_Desconto_Restrito"
                                                                checked={lanceDescontoRestrito}
                                                                onChange={e => setLanceDescontoRestrito(e.target.checked)}
                                                            />}
                                                            label="Lance Desconto Restrito"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} display={"flex"}>
                                                    <FormControl>
                                                        <FormControlLabel
                                                            control={<MuiCheckBox
                                                                name="lance_Desconto_Direito"
                                                                checked={lanceDescontoDireito}
                                                                onChange={e => setLanceDescontoDireito(e.target.checked)}
                                                            />}
                                                            label="Lance Desconto Direito"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} display={"flex"}>
                                                    <FormControl>
                                                        <FormControlLabel
                                                            control={<MuiCheckBox
                                                                name="cobrir_Temporada"
                                                                checked={cobrirTemporada}
                                                                onChange={e => setCobrirTemporada(e.target.checked)}
                                                            />}
                                                            label="Cobrir Temporada"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} display={"flex"}>
                                                    <FormControl>
                                                        <FormControlLabel
                                                            control={<MuiCheckBox
                                                                name="cobrir_Temporada_Direito"
                                                                checked={cobrirTemporadaDireito}
                                                                onChange={e => setCobrirTemporadaDireito(e.target.checked)}
                                                            />}
                                                            label="Cobrir Temporada Direito"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                    <hr />
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" >
                                                    <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                                                        <FormControl>
                                                            <FormControlLabel
                                                                control={<MuiCheckBox
                                                                    name="two_Way"
                                                                    checked={two_Way}
                                                                    onChange={e => setTwo_Way(e.target.checked)}
                                                                />}
                                                                label="Two Way"
                                                                labelPlacement="start"
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            name="valor_Contrato_Maximo_Two_Way"
                                                            disabled={isLoading}
                                                            label="Valor"
                                                            onFocus={(e) => e.target.select()}
                                                            value={`R$ ${valor_Contrato_Maximo_Two_Way}`}
                                                            onChange={(e) => setValor_Contrato_Maximo_Two_Way(Number(e.target.value))}
                                                            slotProps={{
                                                                input: {
                                                                    inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                                },
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            name="tempo_Contrato_Maximo_Two_Way"
                                                            disabled={isLoading}
                                                            label="Valor"
                                                            onFocus={(e) => e.target.select()}
                                                            value={tempo_Contrato_Maximo_Two_Way}
                                                            defaultValue={0}
                                                            onChange={(e) => setTempo_Contrato_Maximo_Two_Way(Number(e.target.value))}
                                                            slotProps={{
                                                                input: {
                                                                    inputComponent: NumericFormatCustomMoneyNoDecimal as any,
                                                                },
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                        {/* <VInputNumber
                                                            fullWidth
                                                            name="tempo_Contrato_Maximo_Two_Way"
                                                            disabled={isLoading || !two_Way}
                                                            label="Tempo Máximo"
                                                            type="text"
                                                            value={tempo_Contrato_Maximo_Two_Way}
                                                            defaultValue={0}
                                                            onChange={(e) => setTempo_Contrato_Maximo_Two_Way(Number(e.target.value))}
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                }
                                                            }}

                                                            onFocus={(e) => e.target.select()}
                                                        /> */}
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            name="quantidade_Jogos_Maximo_Two_Way"
                                                            disabled={isLoading}
                                                            label="Quantidade Jogos"
                                                            onFocus={(e) => e.target.select()}
                                                            value={quantidade_Jogos_Maximo_Two_Way}
                                                            defaultValue={0}
                                                            onChange={(e) => setQuantidade_Jogos_Maximo_Two_Way(Number(e.target.value))}
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                        {/* <VInputNumber
                                                            fullWidth
                                                            name="quantidade_Jogos_Maximo_Two_Way"
                                                            disabled={isLoading || !two_Way}
                                                            label="Quantidade Jogos"
                                                            type="text"
                                                            value={quantidade_Jogos_Maximo_Two_Way}
                                                            defaultValue={0}
                                                            onChange={(e) => setQuantidade_Jogos_Maximo_Two_Way(Number(e.target.value))}
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                }
                                                            }}

                                                            onFocus={(e) => e.target.select()}
                                                        /> */}
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            name="quantidade_Jogadores_Maximo_Two_Way"
                                                            disabled={isLoading}
                                                            label="Quantidade Jogadores"
                                                            onFocus={(e) => e.target.select()}
                                                            value={quantidade_Jogadores_Maximo_Two_Way}
                                                            defaultValue={0}
                                                            onChange={(e) => setQuantidade_Jogadores_Maximo_Two_Way(Number(e.target.value))}
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                        {/* <VInputNumber
                                                            fullWidth
                                                            name="quantidade_Jogadores_Maximo_Two_Way"
                                                            disabled={isLoading || !two_Way}
                                                            label="Quantidade Jogadores"
                                                            type="text"
                                                            value={quantidade_Jogadores_Maximo_Two_Way}
                                                            defaultValue={0}
                                                            onChange={(e) => setQuantidade_Jogadores_Maximo_Two_Way(Number(e.target.value))}
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                }
                                                            }}
                                                            onFocus={(e) => e.target.select()}
                                                        /> */}
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                                                        <FormControl>
                                                            <FormControlLabel
                                                                control={<MuiCheckBox
                                                                    name="incluir_Calouro_Two_Way"
                                                                    checked={incluir_Calouro_Two_Way}
                                                                    onChange={e => setIncluir_Calouro_Two_Way(e.target.checked)}
                                                                    disabled={isLoading || !two_Way}
                                                                />}
                                                                label="Calouros"
                                                                labelPlacement="start"
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                        <hr />
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" >
                                                    <Grid size={{ xs: 12, sm: 12 }} padding={1} textAlign="initial" >
                                                        <Typography variant="h6">Tempo por Período</Typography>
                                                        <hr />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            type="number"
                                                            name="min_Valor_Periodo"
                                                            disabled={isLoading}
                                                            label="Mínimo Mínimo"
                                                            onFocus={(e) => e.target.select()}
                                                            value={min_Valor_Periodo}
                                                            defaultValue={0}
                                                            onChange={(e) => setMin_Valor_Periodo(Number(e.target.value))}
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                        {/* <VInputNumber
                                                            fullWidth
                                                            name="min_Valor_Periodo"
                                                            disabled={isLoading}
                                                            label="Minimo Mínimo"
                                                            type="text"
                                                            value={min_Valor_Periodo}
                                                            defaultValue={0}
                                                            onChange={(e) => setMin_Valor_Periodo(Number(e.target.value))}
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                }
                                                            }}

                                                            onFocus={(e) => e.target.select()}
                                                        /> */}

                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            type="number"
                                                            name="max_Valor_Periodo"
                                                            disabled={isLoading}
                                                            label="Máximo Mínimo"
                                                            onFocus={(e) => e.target.select()}
                                                            value={max_Valor_Periodo}
                                                            defaultValue={0}
                                                            onChange={(e) => setMax_Valor_Periodo(Number(e.target.value))}
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                        {/* <VInputNumber
                                                            fullWidth
                                                            name="max_Valor_Periodo"
                                                            disabled={isLoading}
                                                            label="Máximo Mínimo"
                                                            type="text"
                                                            value={max_Valor_Periodo}
                                                            defaultValue={0}
                                                            onChange={(e) => setMax_Valor_Periodo(Number(e.target.value))}
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                }
                                                            }}

                                                            onFocus={(e) => e.target.select()}
                                                        /> */}
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                        <TextField
                                                            size="small"
                                                            fullWidth
                                                            type="number"
                                                            name="aumento_Minimo_Periodo"
                                                            disabled={isLoading}
                                                            label="Período Horas"
                                                            onFocus={(e) => e.target.select()}
                                                            value={aumento_Minimo_Periodo}
                                                            defaultValue={0}
                                                            onChange={(e) => setAumento_Minimo_Periodo(Number(e.target.value))}
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                    style: {
                                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                        {/* <VInputNumber
                                                            fullWidth
                                                            name="aumento_Minimo"
                                                            disabled={isLoading}
                                                            label="Período Horas"
                                                            type="text"
                                                            maxLength={3}
                                                            value={aumento_Minimo_Periodo}
                                                            defaultValue={0}
                                                            onChange={(e) => setAumento_Minimo_Periodo(Number(e.target.value))}
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: edicao ? true : undefined,
                                                                },
                                                                htmlInput: {
                                                                    maxLength: 20,
                                                                    min: 0
                                                                }
                                                            }}
                                                        /> */}
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 4 }} display="flex" alignItems="center" justifyContent="flex-end" justifyItems="center" textAlign="end">
                                                        <Button
                                                            color="primary"
                                                            variant="contained"
                                                            disableElevation
                                                            onClick={handleCriarTempoPeriodo}
                                                            startIcon={<Icon>add</Icon>}
                                                        >
                                                            Adicionar
                                                        </Button>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12 }} >
                                                        <hr />
                                                        <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                            <Table>
                                                                <TableHead>
                                                                    <StyledTableRow>
                                                                        <StyledTableCell align="center" width={100}>Ações</StyledTableCell>
                                                                        <StyledTableCell>Min Valor</StyledTableCell>
                                                                        <StyledTableCell>Max Valor</StyledTableCell>
                                                                        <StyledTableCell align="center">Aumento Min</StyledTableCell>
                                                                    </StyledTableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {tempoPeriodoRows.map((row, index) => (
                                                                        <StyledTableRow key={index}>
                                                                            <StyledTableCell align="center" sx={{ padding: "2px" }}>
                                                                                <IconButton size="small" onClick={() => deleteTempoPeriodo(index)}>
                                                                                    <Icon>delete</Icon>
                                                                                </IconButton>
                                                                            </StyledTableCell>

                                                                            <StyledTableCell>{row.tempo_Final_Lance}</StyledTableCell>
                                                                            <StyledTableCell>{row.tempo_Restrito_Aprovacao}</StyledTableCell>
                                                                            <StyledTableCell align="center">{row.periodo_Horas}</StyledTableCell>

                                                                        </StyledTableRow>
                                                                    ))
                                                                    }
                                                                </TableBody>
                                                                {totalCountRowsTempoPeriodo === 0 && !isLoading && (
                                                                    <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                                                )}
                                                                <TableFooter>
                                                                    {isLoading && (
                                                                        <StyledTableRow>
                                                                            <StyledTableCell colSpan={7}>
                                                                                <LinearProgress variant="indeterminate" />
                                                                            </StyledTableCell>
                                                                        </StyledTableRow>
                                                                    )}
                                                                    {/* {(totalCountRowsIntervaloLance > 0 && totalCountRowsIntervaloLance > Enviroment.LIMITE_DE_LINHAS) && (
                                                                                    <StyledTableRow>
                                                                                        <StyledTableCell colSpan={7}>
                                                                                            <Pagination
                                                                                                page={pagina}
                                                                                                count={Math.ceil(totalCountRowsIntervaloLance / Enviroment.LIMITE_DE_LINHAS)}
                                                                                                onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                                                                                            />
                                                                                        </StyledTableCell>
                                                                                    </StyledTableRow>
                                                                                )} */}
                                                                </TableFooter>
                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            {/* </Scope> */}
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={valueTabs} index={11}>
                                    {(!removeLoading || isLoading) && <Loading />}
                                    <Grid container size={12} direction="column" >
                                        <Grid container size={{ xs: 12, sm: 12 }} spacing={2} display="flex">
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                <Typography variant="h6">Configurações Player Option</Typography>
                                                <hr />
                                            </Grid>
                                            {/* <Scope path="configuracao_Free_Agency"> */}
                                            <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2} >
                                                <Grid size={{ xs: 12 }}>
                                                    <FormControl>
                                                        <FormControlLabel
                                                            control={<MuiCheckBox
                                                                name="player_Option"
                                                                checked={player_Option}
                                                                onChange={(e) => { setPlayer_Option(e.target.checked); setPlayerOptionRows([]); setAtualizar_Configuracao_Player_Option(true); setShowQtdJogosPO(false); }}
                                                            />}
                                                            label="Play Option"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2} >
                                                <Grid size={{ xs: 12, sm: 6, md: 5 }}>
                                                    <FormControl fullWidth disabled={isLoading}>
                                                        <InputLabel id="demo-simple-select-label">Item Player Option</InputLabel>
                                                        <Select
                                                            size="small"
                                                            fullWidth
                                                            variant="outlined"
                                                            name={`codigo_Item_Payer_Option`}
                                                            value={codigo_Item_Payer_Option}
                                                            label="Item Player Option"
                                                            onChange={(e) => { setCodigo_Item_Payer_Option(Number(e.target.value)); handleShowQuantidadeJogosPO(Number(e.target.value)); }}
                                                            defaultValue={0}
                                                            disabled={isLoading || !player_Option}
                                                        >
                                                            <MenuItem value={0}>Selecione</MenuItem>
                                                            {
                                                                dropItensPlayerOption.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                                                    <TextField
                                                        fullWidth
                                                        type="number"
                                                        name="pontuacao"
                                                        disabled={isLoading || !player_Option}
                                                        label="Pontuação"
                                                        defaultValue={""}
                                                        value={pontuacao}
                                                        onChange={(e) => { setPontuacao(Number(e.target.value)); }}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            },
                                                            htmlInput: { max: 100, min: 0 }
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} display={showQtdJogosPO ? "flow" : "none"}>
                                                    <TextField
                                                        fullWidth
                                                        type="number"
                                                        name="quantidade_Jogo"
                                                        disabled={isLoading || !player_Option}
                                                        label="Quantidade Jogos"
                                                        value={quantidade_Jogo}
                                                        defaultValue={""}
                                                        onChange={(e) => { setQuantidade_Jogo(Number(e.target.value)); }}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            },
                                                            htmlInput: { max: 100, min: 0 }
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} display="flex" alignItems="center" justifyContent="flex-end" justifyItems="center" textAlign="end">
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={(e) => { adicionarPlayerOption(); }}
                                                        endIcon={<Icon>add</Icon>}
                                                    >
                                                        Adicionar
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12 }} display={playerOptionRows.length > 0 ? "flow" : "none"}>
                                                <hr />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12 }} display={playerOptionRows.length > 0 ? "flow" : "none"}>
                                                <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                    <Table>
                                                        <TableHead>
                                                            <StyledTableRow>
                                                                <StyledTableCell align="center" width={100}>AÇÕES</StyledTableCell>
                                                                <StyledTableCell>ITEM</StyledTableCell>
                                                                <StyledTableCell>PONTUAÇÃO</StyledTableCell>
                                                                <StyledTableCell align="center" >QTD. JOGOS</StyledTableCell>
                                                            </StyledTableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {playerOptionRows.map((row, index) => (
                                                                <StyledTableRow key={index}>
                                                                    <StyledTableCell align="center" sx={{ padding: "2px" }}>
                                                                        <IconButton size="small" onClick={() => deletePlayerOption(index)}>
                                                                            <Icon>delete</Icon>
                                                                        </IconButton>
                                                                    </StyledTableCell>
                                                                    <StyledTableCell>{dropItensPlayerOption.find(f => f.codigo === row.codigo_Item_Player_Option)?.label}</StyledTableCell>
                                                                    <StyledTableCell>{row.pontuacao}</StyledTableCell>
                                                                    <StyledTableCell align="center">{row.quantidade_Jogos}</StyledTableCell>
                                                                </StyledTableRow>
                                                            ))
                                                            }
                                                        </TableBody>
                                                        {playerOptionTotalCount === 0 && !isLoading && (
                                                            <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                                        )}
                                                        <TableFooter>
                                                            {isLoading && (
                                                                <StyledTableRow>
                                                                    <StyledTableCell colSpan={7}>
                                                                        <LinearProgress variant="indeterminate" />
                                                                    </StyledTableCell>
                                                                </StyledTableRow>
                                                            )}
                                                            {(playerOptionTotalCount > 0 && playerOptionTotalCount > Enviroment.LIMITE_DE_LINHAS) && (
                                                                <StyledTableRow>
                                                                    <StyledTableCell colSpan={7}>
                                                                        <Pagination
                                                                            page={pagina}
                                                                            count={Math.ceil(playerOptionTotalCount / Enviroment.LIMITE_DE_LINHAS)}
                                                                            onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                                                                        />
                                                                    </StyledTableCell>
                                                                </StyledTableRow>
                                                            )}
                                                        </TableFooter>
                                                    </Table>
                                                </TableContainer>
                                            </Grid>
                                            {/* </Scope> */}
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={valueTabs} index={12}>
                                    {(!removeLoading || isLoading) && <Loading />}
                                    <Grid container size={{ xs: 12, sm: 12 }} direction="column">
                                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" justifyContent="start" alignContent="start">
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                <Typography variant="h6">Regras Desempate Classificação</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 3 }} display="flex" justifyContent="start" justifyItems="start">
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Regras</InputLabel>
                                                    <Select
                                                        size="small"
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        label="Stats"
                                                        value={valorRegraDesempate}
                                                        onChange={(e) => setValorRegraDesempate(Number(e.target.value))}
                                                        defaultValue={0}>
                                                        <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                                        {
                                                            enumLstCriterioDesempate.map(qtd =>
                                                                <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                            )
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 6 }} display="flex" alignItems="center" justifyContent="start" justifyItems="start" textAlign="start">
                                                <Button
                                                    color="primary"
                                                    variant="contained"
                                                    disableElevation
                                                    onClick={cadastroRegrasDesempateClassificacao}
                                                    endIcon={<Icon>add</Icon>}
                                                >
                                                    Adicionar
                                                </Button>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                <hr />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12 }} >
                                                <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                    <Table>
                                                        <TableHead>
                                                            <StyledTableRow>
                                                                <StyledTableCell align="center" width={100}>Ação</StyledTableCell>
                                                                <StyledTableCell align="center">Ordem</StyledTableCell>
                                                                <StyledTableCell>Regra</StyledTableCell>
                                                            </StyledTableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {regraDesempateRows.map((row, index) => (
                                                                <StyledTableRow key={index}>
                                                                    <StyledTableCell align="center" sx={{ padding: "2px" }} >
                                                                        <IconButton size="small" onClick={() => deleteRegraDesempate(index)}>
                                                                            <Icon>delete</Icon>
                                                                        </IconButton>
                                                                    </StyledTableCell>
                                                                    <StyledTableCell align="center">{row.ordem}</StyledTableCell>
                                                                    <StyledTableCell>{enumLstCriterioDesempate.find(f => f.codigo === row.codigo_Criterio_Desempate)?.label}</StyledTableCell>
                                                                </StyledTableRow>
                                                            ))
                                                            }
                                                        </TableBody>
                                                        {totalCountRegrasDesempate === 0 && !isLoading && (
                                                            <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                                        )}
                                                        <TableFooter>
                                                            {isLoading && (
                                                                <StyledTableRow>
                                                                    <StyledTableCell colSpan={7}>
                                                                        <LinearProgress variant="indeterminate" />
                                                                    </StyledTableCell>
                                                                </StyledTableRow>
                                                            )}
                                                            {(totalCountRegrasDesempate > 0 && totalCountRegrasDesempate > (Enviroment.LIMITE_DE_LINHAS * 2)) && (
                                                                <StyledTableRow>
                                                                    <StyledTableCell colSpan={7}>
                                                                        <Pagination
                                                                            page={pagina}
                                                                            count={Math.ceil(totalCountRegrasDesempate / (Enviroment.LIMITE_DE_LINHAS * 2))}
                                                                            onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                                                                        />
                                                                    </StyledTableCell>
                                                                </StyledTableRow>
                                                            )}
                                                        </TableFooter>
                                                    </Table>
                                                </TableContainer>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box >
            </form>
        </LayoutBaseDePagina >
    );
};